/* eslint-disable */
// eslint-disable-next-line import/no-unresolved
import React, { PureComponent, Fragment } from 'react';
// eslint-disable-next-line import/no-unresolved
import PropTypes, { number } from 'prop-types';
// eslint-disable-next-line import/no-unresolved
import styled from 'styled-components';
// eslint-disable-next-line import/no-unresolved
import axios from 'axios';
// eslint-disable-next-line import/no-unresolved
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';
// eslint-disable-next-line import/no-unresolved
import moment from 'moment-timezone';
import * as uuid from 'uuid';


import {
  insertCartItem,
  insertContactInfo,
  insertShuttleInfo,
  getCartItems,
  getContactInformation,
  clearData,
  getQuickData,
  removeQuickData,
  deleteCartItem,
  saveQuickData,
  setParkingStatus,
  getParkingStatus,
  setCurrentStepParking,
  getCurrentStepParking,
  setCurrentStepTicket,
  getCurrentStepTicket,
  saveTripShutleData,
  saveTripShuttleRoundData,
  setCleanShuttleRoutes,
  getCleanShuttleRoutes
} from '../../../helpers/CartManager';

import {
  PURPLE_LIGHT, PURPLE, PINK, BLACK, PURPLE_DARK, WHITE
} from '../../../constants/colors';
import {
  exists, isValidArray, getKey, isValidObject, capitalize
} from '../../../helpers';
import Text from '../../base/Text';
// import destinationToggle from '../../../assets/images/icons/destinationToggle.png';
// import singleDestinationToggle from '../../../assets/images/icons/singleDestinationToggle.png';
// import Destination from './Destination';
import OptionsInput from '../../base/OptionsInput';
// import ContinueBuyButton from '../../base/ContinueBuyButton';
import InputsField from '../../base/InputsFieldFlat';
import InputCheckBox from '../../base/InputCheckBox';
import CloseIcon from '../../base/CloseIcon';
import ValidateButton from './ValidateButton';
import ticketSVGen from '../../../assets/images/ticketDownloadEn.png';
import ticketSVGes from '../../../assets/images/ticketDownloadEs.png';
import ticketSuccess from '../../../assets/images/ticketDownloadSuccess.png';
import ticketMail from '../../../assets/images/icons/ticketMail.png';
import Styles from './Tickets.styles';
import ModalStyles from '../../base/Modal/Modal.styles';
import QuickSelector from '../../base/QuickSelector';
import TextInput from '../../base/TextInput/index';
import tickets_success from '../TicketsWhite/Assets/tickets_success.png';
import shopping_processing from '../../../assets/images/clock.gif';
import shopping_error from '../../../assets/images/cbx_shopping_error.png';
import plus from '../TicketsWhite/Assets/plus.svg';
import email from '../TicketsWhite/Assets/email.svg';
import download from '../TicketsWhite/Assets/download.svg';
import tickets from './Assets/ico_tickets.svg';
import ico_parking from './Assets/ico_parking.svg';
import deleteIcon from './Assets/ico_delete.svg';
import editIcon from './Assets/ico_edit.svg';
import icoParkingWhite from './Assets/ico_parking_white.svg';
import icoTicketWhite from './Assets/ico_ticket_white.svg';
import CBX_Recurso_X from '../../../assets/images/icons/CBX_Recurso_X.png';
import FreedomPay from '../FreedomPay/index';
import purple_arrow from "../../../assets/images/purple_arrow.png"
import damaris_logo from '../../../assets/images/damaris_logo.png';
import losLimousines from '../../../assets/images/losLimousines.svg';
import gettingData from '../../../assets/images/clock.gif';
import cbx_shopping_error from '../../../assets/images/cbx_shopping_error.png';
import cbxCloseIcon from '../ParkingLot/map/CBX_closeIcon.png';
import CBX_pinkUbication from '../../../assets/images/Shuttle/CBX_pinkUbication.svg';
import CBX_purpleUbication from '../../../assets/images/Shuttle/CBX_purpleUbication.svg';
import CBX_IconShuttle from "../../../assets/images/CBX_IconShuttle.png"

// Components
import TicketInfoGrayCollapsable from './TicketInfoGrayCollapsable';
import TicketInfo from '../TicketInfo'
import TicketInfoTemplate from "../../../templates/ticketInfo";
import Stepper from '../Stepper';
import ParkingForm from '../../compound/ParkingForm';
import WheelsForm from '../../compound/WheelsForm';

import ParkingLot from "../../compound/ParkingLot";
import ParkingSpotError from "../../compound/ParkingSpotError";
import { set } from 'core-js/core/dict';
import lot_unavailable from '../../../assets/images/CBX_ErrorAlert.png';

import shuttle_unavailable from '../../../assets/images/shuttle_unavailable.png';
import ShuttleForm from '../ShuttleForm/ShuttleForm';
import ShuttlePassenger from '../ShuttlePassenger/ShuttlePassenger';
import ShuttleSelectTrip from '../ShuttleSelectTrip/ShuttleSelectTrip';
import ShuttleSelectSeats from "../ShuttleSelectSeats";
import ModalToSelectSeats from '../../base/ModalToSelectSeats/ModalToSelectSeats';


import shuttlePurpleIcon from '../../../assets/images/icons/CBX_purpleShuttle.svg';
import CartItem from "../../base/CartItem";

import DonationButtonStrip from '../DonationButtonStrip';
import GotoApp from '../../base/GoToApp/GoToApp';
import AssistPassForm from '../AssistPassForm/AssistPassForm';

import createUUID from '../../../helpers/uuid';
import { InsuranceProvider, isInsuranceFeatureEnabled } from '../../../../features/insurance';

const ModalWrapper = styled.div`${ModalStyles.modalWrapper}`; // prettier-ignore
const Dialog = styled.div`${ModalStyles.dialog}`; // prettier-ignore
const Header = styled.div`${ModalStyles.header}`; // prettier-ignore
const Body = styled.div`${ModalStyles.body}`; // prettier-ignore
const Title = styled.h3`${ModalStyles.title}`; // prettier-ignore
// const Close = styled.button`${ModalStyles.close}`; // prettier-ignore
const Footer = styled.div`${ModalStyles.footer}`; // prettier-ignore
const Button = styled.button`${ModalStyles.button}`; // prettier-ignore
const Select = styled.select`${Styles.inputRounderSelect}`;
const LabelInput = styled(Text).attrs({ bold: true })`${Styles.labelInput}`;
const Wrapper = styled.div`${Styles.wrapper}`; // prettier-ignore
const Desktop = styled.div`${Styles.desktop}`; // prettier-ignore
const Mobile = styled.div`${Styles.mobile}`; // prettier-ignore
const ContentWrapper = styled.div`${Styles.contentWrapper}`; // prettier-ignore
// const DestinationWrapper = styled.div`${Styles.destinationWrapper}`; // prettier-ignore
const InfoWrapper = styled.div`${Styles.infoWrapper}`; // prettier-ignore
// const ToggleIcon = styled.img`${Styles.destinationToggle};`; // prettier-ignore
// const Price = styled(Text).attrs({ bold: true })`${Styles.price}`; // prettier-ignore
const Info = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.info}`; // prettier-ignore
// const BuyingWrapperMobile = styled.div`${Styles.buyingWrapperMobile}`; // prettier-ignore
// const BuyingWrapperDesktop = styled.div`${Styles.buyingWrapperDesktop}`; // prettier-ignore
// const BuyingWrapperDesktopBackground = styled.div`${Styles.buyingWrapperDesktopBackground}`; // prettier-ignore
// const BuyingWrapperDesktopArrow = styled.div`${Styles.buyingWrapperDesktopArrow}`; // prettier-ignore
// const BuyingWrapperDesktopContent = styled.div`${Styles.buyingWrapperDesktopContent}`; // prettier-ignore
const CheckBoxesWrapper = styled.div`${Styles.checkBoxesWrapper}`; // prettier-ignore
// const ContactInformationWrapper = styled.div`${Styles.contactInformationWrapper}`; // prettier-ignore
const PaymentInformationWrapper = styled.div`${Styles.paymentInformationWrapper}`; // prettier-ignore
const CartTicketsListWrapper = styled.div`${Styles.cartTicketsListWrapper}`;
const CartTotal = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.cartTotal}`;
const CartTotalWrapper = styled.div`${Styles.cartTotalWrapper}`;
// const TotalWrapperDesktop = styled.div`${Styles.totalWrapperDesktop}`; // prettier-ignore
// const DesktopForm = styled.div`${Styles.desktopForm}`; // prettier-ignore
// const PaymentProcessingDesktop = styled.div`${Styles.paymentProcessingDesktop}`; // prettier-ignore
const CircleBlink = styled.div`${Styles.circleBlink}`; // prettier-ignore
// const CircleBlinkWrapper = styled.div`${Styles.circleBlinkWrapper}`; // prettier-ignore
const TicketImage_en = styled.img.attrs({ src: ticketSVGen })`${Styles.ticketImage}`; // prettier-ignore
const TicketImage_es = styled.img.attrs({ src: ticketSVGes })`${Styles.ticketImage}`; // prettier-ignore
const TicketImageDownloaded = styled.img.attrs({ src: ticketSuccess })`${Styles.ticketImage}`; // prettier-ignore
const ShowTicketWrapper = styled.div`${Styles.showTicketWrapper}`; // prettier-ignore
const DownloadTicket = styled.a.attrs({ className: 'cbx-bold' })`${Styles.downloadTicket}`; // prettier-ignore
const CloseIconWrapper = styled.div`${Styles.closeIconWrapper}`; // prettier-ignore
// const ErrorWrapper = styled.div`${Styles.errorWrapper}`; // prettier-ignore
const Label = styled(Text).attrs({ bold: true })`${Styles.labelInput}`; // prettier-ignore
const LabelLight = styled(Text).attrs({ bold: true })`${Styles.labelight}`; // prettier-ignore
const ContentWrapperInputs = styled.div`${Styles.contentWrapperInputs}`; // prettier-ignore
const ContentWrapperInputsSmall = styled.div`${Styles.contentWrapperInputsSmall}`; // prettier-ignore
const CartSection = styled.div`${Styles.cartSection}`;
const GrayContainer = styled.div`${Styles.grayContainer}`; // prettier-ignore
const ContainerPurpleButton = styled.div`${Styles.containerPurpleButton}`; // prettier-ignore
const ButtonWrapper = styled.div`${Styles.buttonWrapper}`; // prettier-ignore
const ButtonsContainer = styled.div`${Styles.buttonsContainer}`

/** Tickets component */

const DestinationWrapperWhite = styled.div`${Styles.destinationWrapper}`; // prettier-ignore
const WrapperTicketInfo = styled.div`${Styles.wrapperTicketInfo}`; // prettier-ignore
const PinkLabel = styled(Text).attrs({ bold: true })`${Styles.pinkLabel}`; // prettier-ignore
const PurpleLabel = styled(Text).attrs({ bold: true })`${Styles.purpleLabel}`; // prettier-ignore

const instance = axios.create();
/**
 * Tickets component
 * @returns {JSX}
 */
class TicketsWhite extends PureComponent {
  static propTypes = {
    ticketType: PropTypes.object,
    travelType: PropTypes.object,
    travelPurposes: PropTypes.object,
    shuttleDestinations: PropTypes.object,
    shuttleOrigins: PropTypes.object,
    translations: PropTypes.object,
    locale: PropTypes.oneOf(['es', 'en']),
    south: PropTypes.shape({
      abbreviatedName: PropTypes.string,
      place: PropTypes.string
    }),
    north: PropTypes.shape({
      abbreviatedName: PropTypes.string,
      place: PropTypes.string
    }),
    packages: PropTypes.array,
    user: PropTypes.object,
    uid: PropTypes.string
  };

  /**
   * Checks the credit card brand
   * @param {string} value - credit card numer
   * @returns {string}
   */
  static checkCreditCard(value) {
    const amexCheck = /^3[47][0-9]/;
    const visaCheck = /^4[0-9]/;
    const masterCardCheck = /^5[1-5][0-9]/;

    const creditCard = {
      brand: '',
      length: 16
    };

    if (amexCheck.test(value)) {
      Object.assign(creditCard, {
        brand: 'AMEX',
        length: 15
      });
    } else if (visaCheck.test(value)) {
      Object.assign(creditCard, {
        brand: 'Visa'
      });
    } else if (masterCardCheck.test(value)) {
      Object.assign(creditCard, {
        brand: 'MasterCard'
      });
    }

    return creditCard;
  }

  /**
   * Calculate the current discount value
   * @param {number} oldValue - old value
   * @param {*} newValue - discount value
   * @returns {?Object}
   */
  static calculateCurrentDiscount(oldValue, newValue) {
    return oldValue && oldValue !== newValue
      ? {
        old: oldValue,
        new: newValue,
        legendDesktop: (
          <Fragment>
            Total: <span>${oldValue.toFixed(2)} USD</span>
            <br />${newValue.toFixed(2)} USD
            <br />
          </Fragment>
        ),
        legendMobile: (
          <Fragment>
            <span>${oldValue.toFixed(2)} USD</span> ${newValue.toFixed(2)} USD
          </Fragment>
        )
      }
      : false;
  }

  /**
   * Calculates the current amount
   * @param {Object} options - tickets params to calculate value
   * @returns {string}
   */
  static calculateValueToDate(options) {
    const {
      packages,
      ticketNumber,
      isFamily,
      isRoundTrip,
      company,
      ticketType,
      filterDate
    } = options;
    /**
     * Calculates the current amount
     * @param {Object} datumDate - Date in Datum format
     * @returns {string}
     */
    const momentDate = (datumDate) => {
      const dateTz = parseInt(datumDate.split('(')[1].split('-')[0], 10);
      return new Date(
        moment(dateTz)
          .tz('America/Tijuana')
          .valueOf()
        + moment(dateTz)
          .tz('America/Tijuana')
          .utcOffset()
        * 60
        * 1000
      )
        .toISOString()
        .substring(0, 10);
    };
    const numberOfTickets = parseInt(ticketNumber, 10);
    const ticketProdClassification = parseInt(ticketType, 10);
    if (isValidArray(packages)) {
      const values = packages
        .filter((datum = {}) => datum.IdCompany === company)
        .filter(
          (datum = {}) => (isRoundTrip ? datum.IdCrossingType === 3 : datum.IdCrossingType !== 3)
        )
        .filter((datum = {}) => datum.IdProdClassification === ticketProdClassification);

      if (isValidArray(values)) {
        const productPacks = getKey(values[0], 'ProductPacks');
        if (!isFamily) {
          const [ticketProduct] = productPacks.filter((datum) => {
            const dtStart = momentDate(datum.DtStart);
            const dtEnd = momentDate(datum.DtEnd);
            return dtStart <= filterDate && filterDate <= dtEnd;
          });
          if (isValidObject(ticketProduct)) {
            const ticketPrice = getKey(ticketProduct, 'Amount', 0) * numberOfTickets;
            const ticketDisplayPrice = getKey(ticketProduct, 'DisplayAmount', 0) * numberOfTickets;
            const ticketProducts = Object.assign({}, ticketProduct, {
              NuProdQuant: numberOfTickets
            });
            if (ticketPrice > 0) {
              const retProducts = [ticketProducts];
              return {
                products: retProducts,
                total: `$${ticketDisplayPrice.toFixed(2)} ${getKey(ticketProduct, 'DisplayCurrency')}`,
                amount: ticketPrice
              };
            }
          }
        } else {
          const ticketProducts = productPacks.filter((datum = {}) => {
            const dtStart = momentDate(datum.DtStart);
            const dtEnd = momentDate(datum.DtEnd);
            return (
              datum.NuPersonQuant === numberOfTickets
              && dtStart <= filterDate
              && filterDate <= dtEnd
            );
          });
          const ticketPrice = ticketProducts.reduce((acc, datum) => {
            const numberOfPackages = getKey(datum, 'NuProdQuant', 0);
            const amount = getKey(datum, 'Amount', 0);
            return acc + numberOfPackages * amount;
          }, 0);
          const ticketDisplayPrice = ticketProducts.reduce((acc, datum) => {
            const numberOfPackages = getKey(datum, 'NuProdQuant', 0);
            const amount = getKey(datum, 'DisplayAmount', 0);
            return acc + numberOfPackages * amount;
          }, 0);
          const response = [...ticketProducts];
          ticketProducts.forEach((prod, index) => {
            const localProd = { ...prod };
            if (prod.NuPassenger === 1) {
              localProd.IdProdClassification = 2;
            } else {
              localProd.IdProdClassification = 3;
            }
            response[index] = localProd;
          });
          if (ticketPrice > 0) {
            return {
              products: response,
              total: `$${ticketDisplayPrice.toFixed(2)} ${getKey(ticketProducts[0], 'DisplayCurrency')}`,
              amount: ticketPrice
            };
          }
        }
      }
    }

    return { products: [], total: ' ', TotalAmount: 0 };
  }

  /**
   * Calculates the current amount
   * @param {Object} options - tickets params to calculate value
   * @returns {string}
   */
  static calculateValue = (options) => {
    const { isRoundTrip, flightDate, returnDate } = options;
    if (!flightDate) {
      return { products: [], total: '', TotalAmount: 0 };
    }

    /**
     * Return date in yyyy-mm-dd format from a given date
     * @param {Object} date - Date to return as yyyy-mm-dd
     * @returns {string}
     */

    const ticketDateValues = TicketsWhite.calculateValueToDate({
      ...options,
      filterDate: flightDate
    });
    const returnDateValues = isRoundTrip
      ? TicketsWhite.calculateValueToDate({ ...options, filterDate: returnDate })
      : ticketDateValues;
    const valuesToReturn = ticketDateValues.amount > returnDateValues.amount ? ticketDateValues : returnDateValues;
    if (options.acceptDonate.checked) {
      valuesToReturn.amount += 1;
      valuesToReturn.products.push({
        IdProduct: 18000277,
        NuPersonQuant: 0,
        NuProdQuant: 1,
        Amount: 1,
        DcMex: 0,
        DcUsa: 0,
        IdPricing: 1801,
        IdHierarchy: 10
      });
      valuesToReturn.total = `$${valuesToReturn.amount.toFixed(2)} USD`;
    }
    return valuesToReturn;
  };

  getParkingAvailable = parkData => instance.post(
    process.env.GATSBY_API_POST_PARKING_PRICE,
    {
      from_time: new Date(`${parkData.start_time}+00:00`),
      to_time: new Date(`${parkData.end_time}+00:00`),
      quantity_spots: 1,
      location_id: parkData.lot
    }, {
    headers: {
      'Content-Type': 'application/json'
    }
  }
  );

  getShuttleLocations = () => {
    axios.get(process.env.GATSBY_GET_SHUTTLE_LOCATIONS)
      .then(({ data }) => {
        this.setState({
          shuttleOrigins: data,
          shuttleDestinations: data
        });
        window.localStorage.setItem('CBX_Shuttle_Locations', JSON.stringify(data));
      })
      .catch((error) => {
        return error;
      });
  }

  verifySpotsAvailability = () => {
    const cartItems = getCartItems();
    const parkingItems = cartItems.filter(i => i.type === 'parking');
    const promises = [];

    parkingItems.forEach((p) => {
      // eslint-disable-next-line no-prototype-builtins
      if (p.hasOwnProperty('noAvailability')) {
        // eslint-disable-next-line no-param-reassign
        delete p.noAvailability;
      }
    });

    const parkItemsMap = {};

    parkingItems.forEach((i, idx) => {
      const dateKey = i.start_time.split('T')[0];
      // eslint-disable-next-line no-prototype-builtins
      if (parkItemsMap.hasOwnProperty(dateKey)) {
        parkItemsMap[dateKey].indexes.push(idx);
      } else {
        parkItemsMap[dateKey] = { indexes: [idx] };
      }
      promises.push(this.getParkingAvailable(i));
    });

    Promise.all(promises)
      .then((results) => {
        const dates = Object.keys(parkItemsMap);
        const vals = Object.values(parkItemsMap);

        const cartItemsClone = [...cartItems];
        const parkItemsClone = [...parkingItems];

        results.forEach((res, idx) => {
          const index = vals.findIndex(i => i.indexes.includes(idx));
          parkItemsMap[dates[index]].availableSpots = res.data.data.spots;
        });

        dates.forEach((date) => {
          const requestedSpots = parkItemsMap[date].indexes.length;
          const { availableSpots } = parkItemsMap[date];

          if (requestedSpots > availableSpots) {
            const parkItemsByDate = parkItemsClone.filter(park => park.start_time.includes(date));
            const spotsDiff = availableSpots - requestedSpots;
            const noSpotsParkItems = parkItemsByDate.splice(spotsDiff);

            noSpotsParkItems.forEach((item) => {
              const index = cartItemsClone.findIndex(obj => obj.reservation === item.reservation);
              cartItemsClone[index] = { ...cartItemsClone[index], noAvailability: true };
            });
          }
        });

        window.localStorage.setItem('CBX_Cart_Items', JSON.stringify(cartItemsClone));
        this.setState({
          cart: cartItemsClone
        });
      })
      .catch(e => console.log(e));
  }

  /**
   * Returns the loading circles
   * @param {number} numberOfCircles - the number of circles
   * @returns {JSX}
   */
  static getCircles(numberOfCircles) {
    return (
      <Fragment>
        {Array.from({ length: numberOfCircles }, (_, index) => (
          <CircleBlink delay={index + 1} key={`circle_${index}`} />
        ))}
      </Fragment>
    );
  }

  /**
   * Constructor method
   * @param {Object} props - component props
   */
  constructor(props) {
    super(props);
    this.switchPlaces = this.switchPlaces.bind(this);
    this.buyingToggle = this.buyingToggle.bind(this);
    this.focusField = this.focusField.bind(this);
    this.cancelAction = this.cancelAction.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangePromo = this.handleChangePromo.bind(this);
    this.fetchPromo = this.fetchPromo.bind(this);
    this.ticketTypeHandler = this.ticketTypeHandler.bind(this);
    this.lotHandler = this.lotHandler.bind(this);
    this.travelPurposeHandler = this.travelPurposeHandler.bind(this);
    this.shuttleTravelHandler = this.shuttleTravelHandler.bind(this);
    this.updateShuttleQuickData = this.updateShuttleQuickData.bind(this);
    this.shuttleStartDateHandler = this.shuttleStartDateHandler.bind(this);
    this.shuttleEndDateHandler = this.shuttleEndDateHandler.bind(this);
    this.travelTypeHandler = this.travelTypeHandler.bind(this);
    this.closeBuyedTicket = this.closeBuyedTicket.bind(this);
    this.handleSavedCards = this.handleSavedCards.bind(this);
    this.setProductView = this.setProductView.bind(this);
    this.removeCart = this.removeCart.bind(this);
    this.removeElementFromCart = this.removeElementFromCart.bind(this);
    this.toggleGrow = this.toggleGrow.bind(this);
    this.toggleShrink = this.toggleShrink.bind(this);
    this.flightDateHandler = this.flightDateHandler.bind(this);
    this.returnDateHandler = this.returnDateHandler.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.addParkingCart = this.addParkingCart.bind(this);
    this.addWheelsCart = this.addWheelsCart.bind(this);
    this.doShopping = this.doShopping.bind(this);
    this.handleParkingChange = this.handleParkingChange.bind(this);
    this.removePromo = this.removePromo.bind(this);
    this.getParkingAvailable = this.getParkingAvailable.bind(this);
    this.getShuttleLocations = this.getShuttleLocations.bind(this);
    this.handleDonationChange = this.handleDonationChange.bind(this);
    this.currentYear = parseInt(
      new Date()
        .getFullYear()
        .toString()
        .substr(-2),
      10
    );

    this.nonDigit = /[^\d]/g;
    this.phoneCheck = /^[+#*\\[\]]*([0-9]*){6,16}$/;
    this.quantityOptions = Array.from({ length: 16 }, (_, index) => ({
      name: index,
      value: index
    }));
    this.quantityOptionsBaggage = Array.from({ length: 16 }, (_, index) => ({
      name: index,
      value: index
    }));
    this.personsOptions = Array.from({ length: 12 }, (_, index) => ({
      name: index + 4,
      value: index + 4
    }));

    // References, old school in order to pass the grep pattern
    // instead of the following lines
    /*
    this.requiredField.forEach((field) => {
      this[`${field}Ref`] = React.createRef();
    });
    */
    this.nameRef = React.createRef();
    this.lastNameRef = React.createRef();
    this.emailRef = React.createRef();
    this.emailCheckRef = React.createRef();
    this.zipCodeRef = React.createRef();
    this.phoneRef = React.createRef();
    this.creditCardHolderRef = React.createRef();
    this.creditCardRef = React.createRef();
    this.ccvRef = React.createRef();
    this.expirationDateRef = React.createRef();
    this.creditCardZipCodeRef = React.createRef();
    this.acceptTermsRef = React.createRef();
    this.flightDateRef = React.createRef();
    this.returnDateRef = React.createRef();
    this.travelPurposeRef = React.createRef();
    this.shuttleDestinationRef = React.createRef();
    this.shuttleOriginRef = React.createRef();
    this.shuttleTravelRef = React.createRef();


    this.nameRefDesktop = React.createRef();
    this.lastNameRefDesktop = React.createRef();
    this.emailRefDesktop = React.createRef();
    this.emailCheckRefDesktop = React.createRef();
    this.zipCodeRefDesktop = React.createRef();
    this.phoneRefDesktop = React.createRef();
    this.creditCardHolderRefDesktop = React.createRef();
    this.creditCardRefDesktop = React.createRef();
    this.ccvRefDesktop = React.createRef();
    this.expirationDateRefDesktop = React.createRef();
    this.creditCardZipCodeRefDesktop = React.createRef();
    this.acceptTermsRefDesktop = React.createRef();
    this.flightDateRefDesktop = React.createRef();
    this.returnDateRefDesktop = React.createRef();
    this.travelPurposeRefDesktop = React.createRef();
    this.shuttleDestinationRefDesktop = React.createRef();
    this.shuttleOriginRefDesktop = React.createRef();
    this.shuttleTravelRefDesktop = React.createRef();

    const { user, translations } = props;

    const name = getKey(user, 'name', '');
    const lastName = getKey(user, 'lastName', '');
    const email = getKey(user, 'email', '');
    const zipCode = getKey(user, 'zipCode', '');
    const phone = getKey(user, 'phone', '');
    const hasPayment = getKey(user, 'payment', false) && Object.keys(user.payment).length > 0;

    const today = new Date(
      moment()
        .tz('America/Tijuana')
        .valueOf()
      + moment()
        .tz('America/Tijuana')
        .utcOffset()
      * 60
      * 1000
    );
    const nextYear = new Date(today.getTime() + 364 * 24 * 3600 * 1000);
    const tomorrow = new Date(today.getTime() + 1000 * 3600 * 24);

    let hours = today.getHours();
    if (hours < 10) {
      hours = "0" + hours;
    }
    let minutes = today.getMinutes();
    minutes = Math.floor(minutes / 15);
    minutes *= 15;
    if (minutes < 10) {
      minutes = "0" + minutes;
    }


    let savedCards = hasPayment
      && Object.keys(user.payment).map((key) => {
        const item = user.payment[key] || {};
        const isAmex = item.brand === 'AMEX';
        const creditCardNumber = Array.from({ length: isAmex ? 11 : 12 }, _ => '· ').reduce(
          (acc, i) => i + acc
        );

        return {
          creditCardHolder: item.creditCardHolder,
          creditCard: `${creditCardNumber}${item.lastDigits}`,
          ccv: isAmex ? '····' : '···',
          creditCardZipCode: item.creditCardZipCode,
          expirationDate: item.expirationDate,
          token: item.token,
          brand: item.brand,
          name: `${item.brand || '_'} - ${translations.endingIn} ${item.lastDigits}`,
          value: key
        };
      });

    savedCards = hasPayment && [
      ...savedCards,
      {
        name: translations.anotherCard,
        value: 'manual'
      }
    ];

    const defaultCard = hasPayment && savedCards[0];

    const isTijuana = props.locale === 'es';
    this.resetPaymentInformation = {
      creditCard: {
        value: hasPayment ? defaultCard.creditCard : '',
        status: exists(hasPayment) ? 1 : 0,
        brand: hasPayment ? defaultCard.brand : ''
      },
      creditCardHolder: {
        value: hasPayment ? defaultCard.creditCardHolder : '',
        status: exists(hasPayment) ? 1 : 0,
        edited: hasPayment
      },
      ccv: {
        value: hasPayment ? defaultCard.ccv : '',
        status: exists(hasPayment) ? 1 : 0
      },
      creditCardZipCode: {
        value: hasPayment ? defaultCard.creditCardZipCode : '',
        status: exists(hasPayment) ? 1 : 0,
        edited: hasPayment
      },
      expirationDate: {
        value: hasPayment ? defaultCard.expirationDate : '',
        status: exists(hasPayment) ? 1 : 0
      },
      acceptTerms: {
        checked: false,
        status: 0,
        color: PURPLE_LIGHT
      },
      storeCard: {
        checked: false,
        status: 0,
        color: PURPLE_LIGHT
      },
      token: hasPayment ? defaultCard.token : null,
      acceptMailInfo: {
        checked: getKey(user, 'newsletter', false)
      },
      savedCards,
      currentCard: hasPayment ? defaultCard.token : null
    };

    this.requiredField = [
      'name',
      'lastName',
      'email',
      'emailCheck',
      'zipCode',
      'phone',
      'creditCardHolder',
      'creditCard',
      'ccv',
      'creditCardZipCode',
      'expirationDate',
      'acceptTerms'
    ];
    let defaultSelector = "Ticket";
    if (typeof window !== 'undefined' && window.location.pathname.includes(`/parking`)) defaultSelector = 'Parking';
    if (typeof window !== 'undefined' && window.location.pathname.includes('/cbx-shuttle')) defaultSelector = 'Shuttle';
    this.initialState = {
      hasPayment,
      hasMoveSingle: false,
      formPercentage: 0,
      ticketNumber: '0',
      isSavingMoney: false,
      selectorItem: defaultSelector,
      nameShuttle: '',
      lastNameShuttle: '',
      emailShuttle: '',
      baggageShuttle: '',
      price: {
        products: [],
        total: ' ',
        amount: 0
      },
      name: {
        value: name,
        status: exists(name) ? 1 : 0
      },
      lastName: {
        value: lastName,
        status: exists(lastName) ? 1 : 0
      },
      email: {
        value: email,
        status: exists(email) ? 1 : 0
      },
      emailCheck: {
        value: email,
        status: exists(email) ? 1 : 0
      },
      zipCode: {
        value: zipCode,
        status: exists(zipCode) ? 1 : 0
      },
      phone: {
        value: phone,
        status: exists(phone) ? 1 : 0
      },
      promoCode: {
        value: ''
      },
      validateButton: {
        status: 'disabled'
      },
      acceptDonate: {
        checked: false,
        amount: null
      },
      hasQueue: false,
      isPromoFetchingDisabled: false,
      hasValidPromo: false,
      promoCodeData: null,
      ...this.resetPaymentInformation,
      origin: isTijuana ? props.south : props.north,
      destination: isTijuana ? props.north : props.south,
      quantityPersons: this.quantityOptions,
      quantityBaggage: this.quantityOptionsBaggage,
      activeTicketType: '2',
      isFamily: false,
      company: isTijuana ? 1 : 2,
      isRoundTrip: true,
      activeTravelType: 'roundtrip',
      packages: props.packages ? JSON.parse(JSON.stringify(props.packages)) : null,
      isProcessing: false,
      foundSpot: true,
      isLoading: false,
      showDownloadApp: true,
      differentDates: false,
      isSucess: false,
      ticketDownloaded: false,
      ticketURL: '',
      disableButton: false,
      hasError: false,
      errorMessage: '',
      isBuyingActive: false,
      isBuying: false,
      disclaimer: '',
      donationDisclaimer: '',
      flightDate: '',
      returnDate: '',
      minDate: today.toISOString().substring(0, 10),
      maxDate: nextYear.toISOString().substring(0, 10),
      travelPurpose: '',
      shuttleTravelType: 'oneway',
      shuttleDestination: '',
      shuttleOrigin: '',
      shuttleOrigins: { data: [] },
      shuttleDestinations: { data: [] },
      shuttleStartDate: '',
      shuttleEndDate: '',
      shuttlePassengers: 1,
      shuttleTravel: '',
      showModal: false,
      showSurvey: false,
      showAddTicket: false,
      lot: '',
      startDate: '',
      endDate: '',
      startTime: '',
      endTime: '',
      brand: '',
      model: '',
      year: 2021,
      color: '',
      vehicles: [],
      shuttles: [],
      vehicleState: '',
      plate: '',
      showStartDateCalendar: false,
      showEndDateCalendar: false,
      ws: null,
      counterParking: 1,
      counterShuttle: 1,
      enableSendToCart: false,
      enableSendToCartShuttle: false,
      enableSendToCartShuttleABC: false,
      dataLot: [],
      callParkingApi: false,
      isCallingParkingApi: false,
      boughtTicket: {},
      shortId: null,
      sportsNotAvailable: false,

      //assist-pass passenger data

      assistPassName: '',
      assistPassLastName: '',
      assistPassGender: '',
      assistPassPhone: '',
      assistPassAge: '',

      //assist-pass flight description data

      assistPassDate: '',
      assistPassFightNumber: '',
      assistPassAirline: '',
      assistPassOrigin: '',
      assistPassDestination: '',

      //assist-pass tutor data

      assistPassTutorName: '',
      assistPassTutorLastName: '',
      assistPassTutorPhone: '',
      assistPassTutorEmail: '',
      assistPassNationality: '',

      //assist-pass TempFileId
      assistPassTempId: createUUID(),
      shuttleNotAvailable: false,
      isSelectedTrip: '',
      selectedSeat: [],
      selectedSeatRound: [],
      showModalSelectedSeats: true,
      showModalMissingSeats: false,
      emailShuttleStatus: false,
      nontIncludeShow: false,
      showScales: false,
      detailSelected: "",
      isCallingShuttleApi: false,
      isCallingShuttleDetailsApi: false,
      callShuttleApi: false,
      selectedCounter: 0,
      modalMarginTop: 0,
      selectedBundle: null
    };

    this.state = Object.assign({}, this.initialState);
  }

  /**
   /**
   * Component did mount method
   */
  componentDidMount() {
    const { user, page } = this.props;
    const { hasPayment } = this.state;
    const quickData = getQuickData();
    const cartData = getCartItems();
    const ticketData = window.localStorage.getItem('CBX_Ticket');
    const shortId = window.localStorage.getItem('shortId');
    let currentFlow = window.localStorage.getItem('currentFlow');
    if (!currentFlow) {
      if (page === 'shuttleSelectTrip') {
        window.localStorage.setItem('currentFlow', 'Shuttle');
        currentFlow = 'Shuttle';
      }
      if (page === 'lot') {
        window.localStorage.setItem('currentFlow', 'Parking');
        currentFlow = 'Parking';
      }

      if (page === 'configTicket') {
        window.localStorage.setItem('currentFlow', 'Ticket');
        currentFlow = 'Ticket';
      }
    }
    if (!currentFlow) {
      currentFlow = this.initialState.selectorItem;
    }

    let ticketBought;
    let currentStepTicket = getCurrentStepTicket();
    let currentStepParking = getCurrentStepParking();
    let pageIndex = 1;

    if (page === 'cart') {
      this.verifySpotsAvailability();
    }

    this.getShuttleLocations();

    switch (page) {
      case 'configTicket':
      case 'personalInfo':
        pageIndex = 2;
        break;

      case 'addOns':
        pageIndex = 3;
        break;

      default:
        break;
    };

    if (currentFlow === 'Ticket' && pageIndex > currentStepTicket) {
      setCurrentStepTicket(pageIndex);
      currentStepTicket = pageIndex;
    }
    if (currentFlow === 'Parking' && pageIndex > currentStepParking) {
      setCurrentStepParking(pageIndex);
      currentStepParking = pageIndex;
    }

    if (ticketData) {
      ticketBought = JSON.parse(ticketData);
    }
    const parkingData = JSON.parse(window.localStorage.getItem('parking'));
    let selectedLot = 30;
    if (parkingData) {
      selectedLot = parkingData.data.lot[0].id;
    }
    const parkingEvt = {
      target: {
        value: selectedLot
      }
    };

    let ticketType = '2';
    let travelType = 'roundtrip';
    let travelPurpose = '';
    let shuttleOrigin = '';
    let shuttleDestination = '';
    let shuttleTravel = 'round';
    let localShowAddTicket = true;
    if (quickData) {
      if (quickData.activeTicketType) {
        ticketType = quickData.activeTicketType;
        localShowAddTicket = false;
      }
      if (quickData.activeTravelType) travelType = quickData.activeTravelType;
      if (quickData.activeTravelPurpose) travelPurpose = quickData.activeTravelPurpose;
    }
    const e = {
      target: {
        value: ticketType
      }
    };

    const eventTravelType = {
      target: {
        value: travelType
      }
    };

    const eventTravelPurpose = {
      target: {
        value: travelPurpose
      }
    };

    const eventshuttleDestination = {
      target: {
        value: shuttleDestination
      }
    };
    const eventshuttleOrigin = {
      target: {
        value: shuttleOrigin
      }
    };
    const eventshuttleTravel = {
      target: {
        value: shuttleTravel
      }
    };
    const {
      name,
      lastName,
      email,
      zipCode,
      phone
    } = getContactInformation();

    let contactData = {};
    if (exists(name)) {
      contactData.name = {
        value: name,
        status: 1
      };
    }
    if (exists(lastName)) {
      contactData.lastName = {
        value: lastName,
        status: 1
      };
    }
    if (exists(email)) {
      contactData.email = {
        value: email,
        status: 1
      };
      contactData.emailCheck = {
        value: email,
        status: 1
      };
    }
    if (exists(phone)) {
      contactData.phone = {
        value: phone,
        status: 1
      };
    }
    if (exists(zipCode)) {
      contactData.zipCode = {
        value: zipCode,
        status: 1
      };
    }

    let nameOnCard = `${name} ${lastName}`.toUpperCase();
    if (nameOnCard.length > 25) nameOnCard = ``;
    let paymentData = hasPayment ? {} : {
      creditCardHolder: {
        edited: false,
        value: nameOnCard,
        status: (exists(nameOnCard)) ? 1 : 2
      },
      creditCardZipCode: {
        edited: false,
        value: zipCode,
        status: exists(zipCode) ? 1 : 2
      }
    };
    // objeto con las fechas que se deben
    // asignar a un TIX cuando ya hay TIX en el carrito
    let eventFlightDate = {
      process: false
    };
    let eventReturnDate = {
      process: false
    }
    let eventShuttleStartDate = {
      process: false
    };
    let eventShuttleEndDate = {
      process: false
    }

    const setDates = {};
    // startDateExtractor (product) y regresa el startdate o null si no tiene
    const startDatePropertyByType = {
      'ticket': 'flightDate',
      'parking': 'start_time',
      'shuttle': 'departureDate'
    };

    const endDatePropertyByType = {
      'ticket': 'returnDate',
      'parking': 'end_time',
      'shuttle': 'departureDate'
    };

    const fechas = {
      start: null,
      end: null
    };

    cartData.forEach((product) => {
      if (!product.type in startDatePropertyByType) return;
      const productStart = product[startDatePropertyByType[product.type]];
      const productEnd = product[endDatePropertyByType[product.type]];
      if (productStart) {
        fechas.start = productStart.substring(0, 10);
      }
      if (productEnd) {
        fechas.end = productEnd.substring(0, 10);
      }
    });

    if (fechas.start) {
      setDates.flightDate = fechas.start;
      setDates.startDate = fechas.start;
      setDates.shuttleStartDate = fechas.start;
      eventFlightDate.process = true;
      eventFlightDate.target = {
        value: fechas.start
      }
      eventShuttleStartDate.process = true;
      eventShuttleStartDate.target = {
        value: fechas.start
      }
    }
    if (fechas.end && fechas.end >= fechas.start) {
      setDates.returnDate = fechas.end;
      setDates.endDate = fechas.end;
      setDates.shuttleEndDate = fechas.end;
      eventReturnDate.process = true;
      eventReturnDate.target = {
        value: fechas.end
      }
      eventShuttleEndDate.process = true;
      eventShuttleEndDate.target = {
        value: fechas.end
      }
    }

    if (parkingData) {
      this.setState({
        lot: selectedLot,
        selectorItem: currentFlow ? currentFlow : 'Ticket',
        currentStep:
          currentFlow === "Ticket" ? currentStepTicket : currentStepParking
      },
        () => {
          this.lotHandler(parkingEvt);
        });
    }
    let checkIfBundled = false;

    if (page === 'cart') {
      const bundleTickets = cartData
        .filter((product) => (product.type === 'ticket'))
        .filter((ticket) => {
          return (ticket.origin.abbreviatedPlace.toUpperCase() === 'TJX'
            && ticket.NuPersonQuant === 1
            && ticket.NuProdQuant === 1
            && ticket.IdProdClassification === 1
            && ticket.IdCrossingType === 2
            && ticket.flightDate >= '2024-01-30'
            && ticket.flightDate <= '2024-03-31'
          );
        })

      const bundledShuttle = cartData
        .filter((product) => (product.type === 'shuttle'))
        .filter((shuttle) => {
          return (shuttle.typeId === 1
            && shuttle.passengersQ === 1
            && [
              "Cross Border Xpress"
            ].includes(shuttle.destinationText)
            && [
              "Anaheim(1440 S Anaheim Blvd)",
              "El Monte (11850 Valley Blvd #306)",
              "Huntington Park (2470 E Florence Ave)",
              "Las Vegas (1100 S Main St)",
              "Los Angeles (260 E 6th St)",
              "San Bernardino (620 W Mill St Suite A)",
            ].includes(shuttle.originText)
            && shuttle.provider === 'abc'
            && shuttle.departureDate >= '2024-01-30'
            && shuttle.departureDate <= '2024-03-31'
          );
        });

      checkIfBundled = bundleTickets.length > 0 && bundledShuttle.length > 0;
      console.log("bundledTickets", bundleTickets);
      console.log("bundledShuttle", bundledShuttle);
      console.log("bundled", checkIfBundled);
      // Apply discount to first elements only
      if (checkIfBundled) {
        bundleTickets[0].Discount = bundleTickets[0].Amount * .25;
        bundleTickets[0].DiscountAmount = bundleTickets[0].Amount * .75;
        bundleTickets[0].bundle = '25% TIX + Shuttle';

        bundledShuttle[0].Discount = bundledShuttle[0].price * .25;
        bundledShuttle[0].DiscountAmount = bundledShuttle[0].price * .75;
        bundledShuttle[0].bundle = '25% TIX + Shuttle';

      }
    }

    console.log('cart', cartData);

    const selectedTripData = JSON.parse(localStorage.getItem('shuttle_data'));
    if (quickData || cartData) {

      this.setState({
        ...setDates,
        ...quickData,
        ...contactData,
        ...paymentData,
        cart: cartData,
        boughtTicket: ticketBought,
        shortId,
        showAddTicket: localShowAddTicket,
        selectorItem: currentFlow ? currentFlow : 'Ticket',
        isBundled: checkIfBundled,
        currentStep:
          currentFlow === "Ticket" ? currentStepTicket : currentStepParking
      },
        () => {
          console.log('cart after init', this.state.cart);
          if (page === 'cart') return;
          this.ticketTypeHandler(e);
          this.travelTypeHandler(eventTravelType);
          this.travelPurposeHandler(eventTravelPurpose);
          this.shuttleTravelHandler(eventshuttleTravel);
          if (eventFlightDate.process) {
            this.flightDateHandler({
              target: {
                value: this.state.flightDate
              }
            });
          }
          if (eventReturnDate.process) {
            this.returnDateHandler({
              target: {
                value: this.state.returnDate
              }
            });
          }
          if (eventShuttleStartDate.process) {
            this.shuttleStartDateHandler({
              target: {
                value: this.state.shuttleStartDate
              }
            });
          }
          if (eventShuttleEndDate.process) {
            this.shuttleEndDateHandler({
              target: {
                value: this.state.shuttleEndDate
              }
            });
          }
        });
    }

    const shuttleData = JSON.parse(window.localStorage.getItem('shuttle'));
    const shuttleTrip = JSON.parse(window.localStorage.getItem('shuttle_data'));
    if (shuttleData && shuttleTrip) {
      if (this.isValidShuttleInfo(shuttleData, shuttleTrip.data)) {
        this.setState({
          enableSendToCartShuttle: true,
          enableSendToCartShuttleABC: true
        });
      }
    }
    setTimeout(() => { window.scrollTo(0, 0); }, 250);
    this.getDisclaimer();
  }

  /**
   * component did update method, fix mobile focus
   * @param {Object} prevProps - previous props
   * @param {Object} prevState - previous state
   */
  componentDidUpdate(prevProps, prevState) {
    const { page } = this.props;
    const {
      isBuying,
      startDate,
      endDate,
      startTime,
      endTime,
      lot,
      shuttleOrigin,
      shuttleDestination,
      shuttlePassengers
    } = this.state;
    if (!prevState.isBuying && isBuying) {
      this.focusField();
    }

    const quickShuttleData = JSON.parse(window.localStorage.getItem('CBX_Quick_Data'));

    if (page === 'lot') {
      if (startDate !== '' && endDate !== '' && startTime !== '' && endTime !== '') {
        if (prevState.startDate !== startDate
          || prevState.endDate !== endDate
          || prevState.startTime !== startTime
          || prevState.endTime !== endTime
          || prevState.lot !== lot) {
          this.setState({ callParkingApi: true });
        }
      }
    }

    let checkIfBundled = false;

    if (page === 'cart') {
      const cartData = this.state.cart;
      const bundleTickets = cartData
        .filter((product) => (product.type === 'ticket'))
        .filter((ticket) => {
          return (ticket.origin.abbreviatedPlace.toUpperCase() === 'TJX'
            && ticket.NuPersonQuant === 1
            && ticket.NuProdQuant === 1
            && ticket.IdProdClassification === 1
            && ticket.IdCrossingType === 2
            && ticket.flightDate >= '2024-01-30'
            && ticket.flightDate <= '2024-03-31'
          );
        })

      const bundledShuttle = cartData
        .filter((product) => (product.type === 'shuttle'))
        .filter((shuttle) => {
          return (shuttle.typeId === 1
            && shuttle.passengersQ === 1
            && [
              "Cross Border Xpress"
            ].includes(shuttle.destinationText)
            && [
              "Anaheim(1440 S Anaheim Blvd)",
              "El Monte (11850 Valley Blvd #306)",
              "Huntington Park (2470 E Florence Ave)",
              "Las Vegas (1100 S Main St)",
              "Los Angeles (260 E 6th St)",
              "San Bernardino (620 W Mill St Suite A)",
            ].includes(shuttle.originText)
            && shuttle.provider === 'abc'
            && shuttle.departureDate >= '2024-01-30'
            && shuttle.departureDate <= '2024-03-31'
          );
        });

      checkIfBundled = bundleTickets.length > 0 && bundledShuttle.length > 0;
      console.log("bundledTickets", bundleTickets);
      console.log("bundledShuttle", bundledShuttle);
      console.log("bundled", checkIfBundled);
      // Apply discount to first elements only
      if (checkIfBundled) {
        bundleTickets[0].Discount = bundleTickets[0].Amount * .25;
        bundleTickets[0].DiscountAmount = bundleTickets[0].Amount * .75;
        bundleTickets[0].bundle = '25% TIX + Shuttle';
        bundledShuttle[0].Discount = bundledShuttle[0].price * .25;
        bundledShuttle[0].DiscountAmount = bundledShuttle[0].price * .75;
        bundledShuttle[0].bundle = '25% TIX + Shuttle';
        this.setState({ cart: cartData, isBundled: true });
      }
    }
  }

  /**
   * Send analytics product view event
   */
  setProductView() {
    const products = this.state.price.products.map((product) => {
      return {
        name: product.DsPublicAlias,
        id: product.IdProduct,
        price: product.Amount,
        quantity: product.NuProdQuant
      };
    });
    if (window && window.dataLayer) {
      window.dataLayer.push({
        event: 'productClick',
        ecommerce: {
          click: {
            actionField: { list: 'Ticket Selection' },
            products
          }
        }
      });
    }
    if (this.state.isBuying && window && window.dataLayer) {
      window.dataLayer.push({
        event: 'addToCart',
        ecommerce: {
          add: {
            products
          }
        }
      });
    }
  }
  /**
   * Removes current product from cart.
   */
  removeCart() {
    // const products = this.state.price.products.map((product) => {
    //   return {
    //     name: product.DsPublicAlias,
    //     id: product.IdProduct,
    //     price: product.Amount,
    //     quantity: product.NuProdQuant
    //   };
    // });
    // window.dataLayer.push({
    //   event: 'removeFromCart',
    //   ecommerce: {
    //     remove: {
    //       products
    //     }
    //   }
    // });
  }

  /**
   * Edits element from cart
   * @param {number} index - index of element to edit from cart
   */
  editElementFromCart(index) {
    const { locale } = this.props;
    const { cart } = this.state;
    const currentCart = [...cart];
    const item = currentCart[index];
    if (item.type === 'ticket') {
      const cartTicketInfo = new Object();
      cartTicketInfo.activeTicketType = item.IdProdClassification;
      cartTicketInfo.activeTravelPurpose = item.travelPurpose;
      cartTicketInfo.activeTravelType = item.travelType;
      cartTicketInfo.company = item.origin.place === 'Tijuana' ? 1 : 2;
      cartTicketInfo.destination = item.destination;
      cartTicketInfo.flightDate = item.flightDate;
      cartTicketInfo.origin = item.origin;
      cartTicketInfo.returnDate = item.returnDate;
      cartTicketInfo.ticketNumber = (item.NuPassenger * item.NuProdQuant).toString(10);
      cartTicketInfo.ticketType = item.IdProdClassification;
      cartTicketInfo.travelPurpose = item.travelPurpose;
      cartTicketInfo.travelType = item.travelType;
      saveQuickData(cartTicketInfo);
      deleteCartItem(index);
      window.location.href = `/${locale}/configTicket`;
    }
    if (item.type === 'parking') {
      instance.post(
        process.env.GATSBY_API_POST_PARKING_PRICE,
        {
          from_time: item.start_time,
          to_time: item.end_time,
          quantity_spots: 1,
          location_id: item.lot
        }, {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      )
        .then(({ data }) => {
          saveQuickData({
            startDate: item.start_time.split('T')[0],
            startTime: item.start_time.split('T')[1].substr(0, 5),
            endDate: item.end_time.split('T')[0],
            endTime: item.end_time.split('T')[1].substr(0, 5)
          });
          const curData = {
            ...data.data,
            from: item.start_time,
            to: item.end_time
          };
          window.localStorage.setItem('parking', JSON.stringify({
            data: curData,
            vehicles: [{
              brand: item.brand,
              model: item.model,
              year: item.year,
              color: item.color,
              state: item.state,
              license: item.vehicleLicense
            }]
          }));
          deleteCartItem(index);
          window.location.href = `/${locale}/lot`;
        })
        .catch((error) => {
          console.error(error);
        });
    }

    if (item.type === 'shuttle') {
      const cartShuttleInfo = new Object();
      cartShuttleInfo.shuttleDestination = item.shuttleDestination,
        cartShuttleInfo.shuttleOrigin = item.shuttleOrigin,
        cartShuttleInfo.shuttleStartDate = item.shuttleStartDate,
        cartShuttleInfo.shuttleEndDate = item.shuttleEndDate,
        cartShuttleInfo.shuttlePassengers = item.shuttlePassengers,
        cartShuttleInfo.isSelectedTrip = item.isSelectedTrip,
        saveQuickData(cartShuttleInfo);
      deleteCartItem(index);
      window.location.href = `/${locale}/shuttleSelectTrip`;
    }

  }

  /**
   * Removes element from cart
   * @param {number} index - index of element to delete from cart
   */
  removeElementFromCart(index) {
    const { cart } = this.state;
    const currentCart = [...cart];
    currentCart.splice(index, 1);
    deleteCartItem(index);
    this.verifySpotsAvailability();
    window.dispatchEvent(new Event('storage'));
    /* window.dataLayer.push({
      event: 'removeFromCart',
      ecommerce: {
        remove: {
          products
        }
      }
    }); */
  }
  /**
     * Edits element from stepper
     * @param {number} index - index of element to edit from cart
     */

  editElementFromCartUsingStepper(index) {
    const { locale } = this.props;
    const { cart } = this.state;
    const currentCart = [...cart];
    const item = currentCart[index];
    if (item.type === 'ticket') {
      const cartTicketInfo = new Object();
      cartTicketInfo.activeTicketType = item.IdProdClassification;
      cartTicketInfo.activeTravelPurpose = item.travelPurpose;
      cartTicketInfo.activeTravelType = item.travelType;
      cartTicketInfo.company = item.origin.place === 'Tijuana' ? 1 : 2;
      cartTicketInfo.destination = item.destination;
      cartTicketInfo.flightDate = item.flightDate;
      cartTicketInfo.origin = item.origin;
      cartTicketInfo.returnDate = item.returnDate;
      cartTicketInfo.ticketNumber = (item.NuPassenger * item.NuProdQuant).toString(10);
      cartTicketInfo.ticketType = item.IdProdClassification;
      cartTicketInfo.travelPurpose = item.travelPurpose;
      cartTicketInfo.travelType = item.travelType;
      saveQuickData(cartTicketInfo);
      //deleteCartItem(index);
      window.location.href = `/${locale}/configTicket`;
    }
    if (item.type === 'parking') {
      instance.post(
        process.env.GATSBY_API_POST_PARKING_PRICE,
        {
          from_time: item.start_time,
          to_time: item.end_time,
          quantity_spots: 1,
          location_id: item.lot
        }, {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      )
        .then(({ data }) => {
          saveQuickData({
            startDate: item.start_time.split('T')[0],
            startTime: item.start_time.split('T')[1].substr(0, 5),
            endDate: item.end_time.split('T')[0],
            endTime: item.end_time.split('T')[1].substr(0, 5)
          });
          const curData = {
            ...data.data,
            from: item.start_time,
            to: item.end_time
          };
          window.localStorage.setItem('parking', JSON.stringify({
            data: curData,
            vehicles: [{
              brand: item.brand,
              model: item.model,
              year: item.year,
              color: item.color,
              state: item.state,
              license: item.vehicleLicense
            }]
          }));
          //deleteCartItem(index);
          window.location.href = `/${locale}/lot`;
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  /**
   * Contact information
   * @param {boolean} isDesktop - true if it's not mobile
   * @param {boolean} isParkingFlow - true if it's parking purchase flow
   * @returns {JSX}
   */
  getContactInformation(isDesktop, isParkingFlow, isMobile, isShuttle = false, isWheels = false) {
    const {
      state: {
        name, lastName, email, emailCheck, zipCode, phone, isLoading, travelPurpose, flightDate, returnDate, activeTravelType
      },
      props: { translations, page, locale }
    } = this;

    let shouldAdjustStyles = isParkingFlow || isShuttle || isWheels;

    /**
     * Verify button disabled state
     * @returns {boolean|*}
     */
    const isDisabled = name.status !== 1
      || lastName.status !== 1
      || phone.status !== 1
      || zipCode.status !== 1
      || emailCheck.status !== 1
      || email.status !== 1;

    const ticketDisabled = !travelPurpose || !flightDate || (activeTravelType === 'roundtrip' && !returnDate);
    const isSelectingTicket = page === `configTicket`;

    return (
      <>
        <ContentWrapperInputs style={{ width: '100%' }}>
          <Fragment>
            <InputsField
              placeHolder={translations.name.placeHolder}
              label={translations.name.label}
              labelWarn={`${translations.name.label}${name.value.length === 0 ? translations.isIncomplete : translations.isInvalid}`}
              className="col-12"
              reference={isDesktop ? this.nameRefDesktop : this.nameRef}
              onChange={this.handleChange}
              value={name.value}
              name="name"
              status={name.status}
              labelOnTop
            />
            <InputsField
              placeHolder={translations.lastName.placeHolder}
              label={translations.lastName.label}
              labelWarn={`${translations.lastName.label}${lastName.value.length === 0 ? translations.isIncomplete : translations.isInvalid}`}
              className="col-12"
              reference={isDesktop ? this.lastNameRefDesktop : this.lastNameRef}
              onChange={this.handleChange}
              value={lastName.value}
              name="lastName"
              status={lastName.status}
              labelOnTop
            />
            <InputsField
              placeHolder={translations.email.placeHolder}
              label={translations.email.label}
              labelWarn={`${translations.email.label}${email.value.length === 0 ? translations.isIncomplete : translations.isInvalid}`}
              className="col-12"
              reference={isDesktop ? this.emailRefDesktop : this.emailRef}
              type="email"
              onChange={this.handleChange}
              value={email.value}
              name="email"
              status={email.status}
              labelOnTop
            />
            <InputsField
              placeHolder={translations.emailCheck.placeHolder}
              label={translations.emailCheck.label}
              labelWarn={`${translations.emailCheck.label}${emailCheck.value.length === 0 ? translations.isIncomplete : translations.isInvalid}`}
              type="email"
              className="col-12"
              reference={isDesktop ? this.emailCheckRefDesktop : this.emailCheckRef}
              onChange={this.handleChange}
              value={emailCheck.value}
              name="emailCheck"
              status={emailCheck.status}
              disableAutocomplete
              labelOnTop
              onPaste={(e) => { e.preventDefault(); return false; }}
            />
          </Fragment>
        </ContentWrapperInputs>
        <ContentWrapperInputsSmall style={{ width: isDesktop ? '100%' : 'auto' }}>
          <Fragment>
            <InputsField
              placeHolder={translations.zipCode.placeHolder}
              label={translations.zipCode.label}
              labelWarn={`${translations.zipCode.label}${zipCode.value.length === 0 ? translations.isIncomplete : translations.isInvalid}`}
              className="col-6"
              reference={isDesktop ? this.zipCodeRefDesktop : this.zipCodeRef}
              type="tel"
              onChange={this.handleChange}
              value={zipCode.value}
              name="zipCode"
              status={zipCode.status}
              labelOnTop
            />
            <InputsField
              placeHolder={translations.phone.placeHolder}
              label={translations.phone.label}
              labelWarn={`${translations.phone.label}${phone.value.length === 0 ? translations.isIncomplete : translations.isInvalid}`}
              className="col-6"
              reference={isDesktop ? this.phoneRefDesktop : this.phoneRef}
              type="tel"
              onChange={this.handleChange}
              value={phone.value}
              name="phone"
              status={phone.status}
              labelOnTop
              maxLength={16}
            />
          </Fragment>
        </ContentWrapperInputsSmall>
        <div
          style={{
            padding: '25px',
            margin: shouldAdjustStyles ? 0 : 'auto',
            justifyContent: 'center',
            maxWidth: shouldAdjustStyles ? '100%' : '300px',
            width: shouldAdjustStyles ? '100%' : 'auto'
          }}
        >
          {
            !isParkingFlow && !isShuttle && isWheels && (
              <ButtonsContainer style={{ flexDirection: isMobile ? 'column' : 'row' }}>
                <ValidateButton
                  disabled={isDisabled}
                  isLoading={isLoading}
                  action={() => {
                    if (!isLoading) this.addWheelsCart(true);
                  }}
                  message={translations.continueParking}
                  backgroundColor="#3F2A55"
                />
                {isMobile && <br />}
                <ValidateButton
                  disabled={isDisabled}
                  isLoading={isLoading}
                  action={() => {
                    if (!isLoading) this.addWheelsCart();
                  }}
                  message={translations.proceedCheckout}
                />
              </ButtonsContainer>
            )
          }
          {!isParkingFlow && !isShuttle && !isWheels && (
            <ValidateButton
              disabled={isDisabled || (isSelectingTicket && ticketDisabled)}
              isLoading={isLoading}
              action={() => {
                if (!isLoading) this.addToCart();
              }}
              message={translations.addToCart}
            />
          )}
          {isParkingFlow && !isShuttle && !isWheels && (
            <ButtonsContainer style={{ flexDirection: isMobile ? 'column' : 'row' }}>
              <ValidateButton
                disabled={isDisabled}
                isLoading={isLoading}
                action={() => {
                  if (!isLoading) this.addParkingCart(true);
                }}
                message={translations.continueParking}
                backgroundColor="#3F2A55"
              />
              {isMobile && !isShuttle && <br />}
              <ValidateButton
                disabled={isDisabled}
                isLoading={isLoading}
                action={() => {
                  if (!isLoading) this.addParkingCart();
                }}
                message={translations.proceedCheckout}
              />
            </ButtonsContainer>
          )}
          {isShuttle && !isParkingFlow && !isWheels && (
            <ButtonsContainer style={{ flexDirection: isMobile ? 'column' : 'row' }}>
              <ValidateButton
                disabled={isDisabled}
                isLoading={isLoading}
                action={() => {
                  if (!isLoading) this.addShuttleCart(true);
                }}
                message={translations.continueParking}
                backgroundColor="#3F2A55"
              />
              {isMobile && !isShuttle && <br />}
              <ValidateButton
                disabled={isDisabled}
                isLoading={isLoading}
                action={() => {
                  if (!isLoading) this.addShuttleCart();
                }}
                message={translations.proceedCheckout}
              />
            </ButtonsContainer>
          )}
        </div>
      </>
    );
  }

  /**
   * Shuttle contact information
   * @param {boolean} isDesktop - true if it's not mobile
   * @param {boolean} isParkingFlow - true if it's parking purchase flow
   * @returns {JSX}
   */
  getPassengerInformation(isDesktop, isParkingFlow, isMobile, isShuttle) {
    const {
      state: {
        name, lastName, email, emailCheck, baggage
      },
      props: { translations, page, locale, buyingToggle, ticketNumber, hasBlackTheme, quantityPersons, isLoading }
    } = this;

    /**
     * Verify button disabled state
     * @returns {boolean|*}
     */
    const isDisabled =
      name.status !== 1
      || lastName.status !== 1
      || emailCheck.status !== 1
      || email.status !== 1;

    return (
      <>
        <ContentWrapperInputs style={{ width: '100%' }}>
          <Fragment>
            <InputsField
              placeHolder={translations.name.placeHolder}
              label={translations.name.label}
              className="col-12"
              reference={isDesktop ? this.nameRefDesktop : this.nameRef}
              onChange={this.handleChange}
              value={name.value}
              name="name"
              status={name.status}
            />
            <InputsField
              placeHolder={translations.lastName.placeHolder}
              label={translations.lastName.label}
              className="col-12"
              reference={isDesktop ? this.lastNameRefDesktop : this.lastNameRef}
              onChange={this.handleChange}
              value={lastName.value}
              name="lastName"
              status={lastName.status}
            />
            <InputsField
              placeHolder={translations.email.placeHolder}
              label={translations.email.label}
              className="col-12"
              reference={isDesktop ? this.emailRefDesktop : this.emailRef}
              type="email"
              onChange={this.handleChange}
              value={email.value}
              name="email"
              status={email.status}
            />
            <Select
              onChange={buyingToggle}
              value={ticketNumber}
              hasBlackTheme={hasBlackTheme}
            >
              {quantityPersons && quantityPersons.map(option => (
                <option value={option.value} key={`inputValue${name}${option.value}`}>
                  {option.name}
                </option>
              ))}
            </Select>
            <LabelInput>{translations.shoppingLabels.passengers}</LabelInput>
          </Fragment>
        </ContentWrapperInputs>
        <div
          style={{
            padding: '25px',
            margin: isParkingFlow ? 0 : 'auto',
            justifyContent: 'center',
            maxWidth: isParkingFlow ? '100%' : '300px',
            width: isParkingFlow ? '100%' : 'auto'
          }}
        >

          {isShuttle && (
            <ValidateButton
              disabled={isDisabled || (isSelectingTicket && ticketDisabled)}
              isLoading={isLoading}
              action={() => {
                if (!isLoading) window.location.href = `/${locale}/addOns`
              }}
              message={translations.addToCart}
            />
          )}
        </div>
      </>
    );
  }

  /**
   * Payment information
   * @param {boolean} isDesktop - true if its not mobile
   * @returns {JSX}
   */
  getPaymentInformation(isDesktop) {
    const {
      state: {
        acceptDonate,
        storeCard,
        creditCardHolder,
        ccv,
        creditCardZipCode,
        expirationDate,
        creditCard,
        promoCode,
        validateButton,
        hasPayment,
        savedCards,
        currentCard,
        ticketType,
        isProcessing,
        acceptTerms,
        flightDate,
        returnDate,
        startDate,
        endDate,
        differentDates,
        cart,
        token,
        hasValidPromo,
        promoError
      },
      props: { translations, locale }
    } = this;

    let unavailableProducts = false;

    cart.forEach((i) => {
      if (i.hasOwnProperty('noAvailability')) {
        unavailableProducts = true;
      }
    });

    let promoLabel = translations.ticketPromo.label;
    if (promoError) {
      promoLabel = locale === 'es' ? 'Código inválido' : 'Invalid Code';
    }
    if (hasValidPromo) {
      promoLabel = translations.ticketPromo.status.valid;
    }

    return (
      <>
        {false && <div className="row" style={{ display: 'flex', marginTop: '2rem', flexDirection: 'row', alignItems: 'flex-end', width: '100%', justifyContent: 'center' }}>
          <InputCheckBox
            label={[
              <span>
                {translations.checkboxDonate}<a href="https://icfdn.org/" style={{ color: PURPLE }} rel="noreferrer noopener" target="_blank">ICF</a>.
              </span>
            ]}
            name="acceptDonate"
            className="col-3 col-6-sm"
            onChange={this.handleChange}
            checked={acceptDonate.checked}
            color={WHITE}
            backgroundColor="#F9AA23"
          />
        </div>}
        {!this.state.isBundled && <div className="row" style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', width: '100%', justifyContent: 'center' }}>
          <InputsField
            placeHolder={translations.ticketPromo.placeHolder}
            label={promoLabel}
            disabled={this.state.hasValidPromo}
            onChange={(e) => { if (this.state.hasValidPromo) return; this.handleChangePromo(e); }}
            value={promoCode.value}
            style={{ marginBottom: 0 }}
            name="promoCode"
            status={promoCode.status || 2}
            fixAutofill="#fafafa"
            labelOnTop
          />

          <ValidateButton
            action={() => {
              if (this.state.isLoading) return;
              if (this.state.differentDates) return;
              if (this.state.hasValidPromo) {
                this.removePromo();
              } else {
                this.fetchPromo();
              }
            }}
            isLoading={this.state.isLoading}
            disabled={!promoCode.value}
            className="col-1 col-1-md col-1-sm"
            message={this.state.hasValidPromo ? translations.remove : translations.apply}
          />
        </div>}

        <PaymentInformationWrapper style={{ width: '100%' }}>
          <div className="row">
            <Fragment>
              {hasPayment && (
                <Fragment>
                  <Info className="col-12">{translations.accountSettings.savedPaymments}</Info>
                  <OptionsInput
                    className="col-12"
                    options={savedCards}
                    value={currentCard}
                    onChange={this.handleSavedCards}
                    name={translations.accountSettings.chooseACreditCard}
                    hasBlackTheme
                  />
                </Fragment>
              )}
              <Info className="col-12">{translations.paymentInformation}</Info>
              {
                hasPayment && !token && this.getCheckBoxes()
              }
              <InputsField
                placeHolder={translations.creditCardHolder.placeHolder}
                label={translations.creditCardHolder.label}
                labelWarn={`${translations.creditCardHolder.label}${creditCardHolder.value.length === 0 ? translations.isIncomplete : translations.isInvalid}`}
                className="col-12"
                reference={isDesktop ? this.creditCardHolderRefDesktop : this.creditCardHolderRef}
                onChange={this.handleChange}
                value={creditCardHolder.value}
                name="creditCardHolder"
                status={creditCardHolder.status}
                fixAutofill="#fafafa"
                autoComplete="cc-name"
                isRequired
                labelOnTop
              />
              {hasPayment && token && <InputsField
                placeHolder={translations.creditCard.placeHolder}
                label={translations.creditCard.label}
                labelWarn={`${translations.creditCard.label}${creditCard.value.length === 0 ? translations.isIncomplete : translations.isInvalid}`}
                className="col-12"
                reference={isDesktop ? this.creditCardRefDesktop : this.creditCardRef}
                type="tel"
                onChange={this.handleChange}
                value={creditCard.value}
                name="creditCard"
                status={creditCard.status}
                fixAutofill="#fafafa"
                autoComplete="cc-number"
                isRequired
                labelOnTop
              />}
              {hasPayment && token && <InputsField
                placeHolder={translations.expirationDate.placeHolder}
                label={translations.expirationDate.label}
                labelWarn={`${translations.expirationDate.label}${expirationDate.value.length === 0 ? translations.isIncomplete : translations.isInvalid}`}
                className="col-12"
                reference={isDesktop ? this.expirationDateRefDesktop : this.expirationDateRef}
                type="tel"
                onChange={this.handleChange}
                value={expirationDate.value}
                name="expirationDate"
                status={expirationDate.status}
                fixAutofill="#fafafa"
                disableAutocomplete
                isRequired
                labelOnTop
              />}
              {hasPayment && token && <InputsField
                placeHolder={translations.creditCardZipCode.placeHolder}
                label={translations.creditCardZipCode.label}
                labelWarn={`${translations.creditCardZipCode.label}${creditCardZipCode.value.length === 0 ? translations.isIncomplete : translations.isInvalid}`}
                className="col-12"
                reference={isDesktop ? this.creditCardZipCodeRefDesktop : this.creditCardZipCodeRef}
                type="tel"
                onChange={this.handleChange}
                value={creditCardZipCode.value}
                name="creditCardZipCode"
                status={creditCardZipCode.status}
                fixAutofill="#fafafa"
                isRequired
                labelOnTop
              />}
            </Fragment>
          </div>
        </PaymentInformationWrapper>
      </>
    );
  }

  /**
   * checkBoxes
   * @param {boolean} isDesktop - true if it's not mobile
   * @returns {JSX}
   */
  getCheckBoxes(isDesktop) {
    const {
      state: { acceptTerms, acceptDonate, storeCard, acceptMailInfo },
      props: { translations, user, locale }
    } = this;
    return (
      <CheckBoxesWrapper>
        {false && <InputCheckBox
          label={translations.acceptTerms.label}
          name="acceptTerms"
          className="col-12"
          onChange={this.handleChange}
          checked={acceptTerms.checked}
          reference={isDesktop ? this.acceptTermsRefDesktop : this.acceptTermsRef}
          color={acceptTerms.color}
        />}
        {!user && (
          <InputCheckBox
            label={translations.acceptMailInfo.label}
            name="acceptMailInfo"
            className="col-12"
            onChange={this.handleChange}
            checked={acceptMailInfo.checked}
          />
        )}

        <InputCheckBox
          label={locale == 'es' ? 'Deseo guardar los detalles de la tarjeta para la próxima vez.' : 'Save payment method for future purchases.'}
          name="storeCard"
          className="col-12"
          onChange={this.handleChange}
          checked={storeCard.checked}
          color={PINK}
        />

      </CheckBoxesWrapper>
    );
  }

  /**
   * Success message
   * @returns {JSX}
   */
  getSuccessMessage() {
    const {
      props: { translations, locale },
      state: { email, ticketURL, ticketDownloaded }
    } = this;
    let TicketImage = TicketImage_en;

    if (ticketDownloaded) {
      TicketImage = TicketImageDownloaded;
    } else if (locale === 'es') {
      TicketImage = TicketImage_es;
    }

    return (
      <ShowTicketWrapper>
        <CloseIconWrapper onClick={this.closeBuyedTicket}>
          <CloseIcon />
        </CloseIconWrapper>
        <Info tag="p" maxWidth="90%" textAlign="center" style={{ padding: '0.5em', color: BLACK }}>
          {locale === 'es'
            ? 'Con excepción de ciudadanos o residentes estadounidenses, si eres extranjero viajando a más de 25 millas (aprox. 40 km) de la frontera o permaneciendo más de 30 días en los Estados Unidos es necesario prepagar tu permiso I-94 antes de realizar tu cruce.'
            : 'With the exception of U.S. citizens and residents, If you are traveling more than 25 miles from the border or stay longer than 30 days an I-94 permit is required before you cross into the US through CBX'}
        </Info>
        <DownloadTicket
          onClick={() => {
            trackCustomEvent({
              category: 'Purchase completed',
              action: 'E-ticket Download',
              label: 'E-Ticket download link clicked'
            });
            this.setState({
              ticketDownloaded: true
            });
          }}
          href={ticketURL}
          target="blank"
        >
          <TicketImage />
        </DownloadTicket>
        <DownloadTicket style={{ flexDirection: 'row', marginTop: '2em' }}>
          <img alt="" src={ticketMail} style={{ height: '3em' }} />
          <Info tag="p" maxWidth="90%" textAlign="center" style={{ padding: '0.5em', color: PINK }}>
            {translations.downloadTicketInfo}
            {email.value}
          </Info>
        </DownloadTicket>
      </ShowTicketWrapper>
    );
  }

  /**
   * Switch state when its a valid buying
   * @param {Object} isDesktop - true if it's not mobile
   * @param {Object} event - synthetic event
   * @param {boolean} isPurchaseButton - button is to start purchase
   */
  buyingActiveToggle = (isDesktop, event, isPurchaseButton) => {
    event.preventDefault();
    const {
      formPercentage,
      ticketNumber,
      isProcessing,
      promoCode,
      validateButton,
      isPromoFetchingDisabled
    } = this.state;
    let doShoppingOnce = !isProcessing && !isPromoFetchingDisabled ? this.doShopping : null;

    let hasQueue = false;
    if (promoCode.value.length >= 2 && validateButton.status === 'normal') {
      doShoppingOnce = !isProcessing && !isPromoFetchingDisabled ? this.fetchTrigger : null;
      hasQueue = true;
    }

    if (ticketNumber >= 1) {
      this.setState(
        ({ isBuyingActive }) => ({
          isBuying: isBuyingActive && true,
          hasQueue
        }),
        formPercentage === 1 ? doShoppingOnce : this.focusField(isDesktop)
      );
      if (!isPurchaseButton) {
        trackCustomEvent({
          category: 'Purchase intent',
          action: 'Continue button',
          label: 'Purchase Continue button clicked'
        });
        const products = this.state.price.products.map((product) => {
          return {
            name: product.DsPublicAlias,
            id: product.IdProduct,
            price: product.Amount,
            quantity: product.NuProdQuant
          };
        });
        window.dataLayer.push({
          event: 'addToCart',
          ecommerce: {
            add: {
              products
            }
          }
        });

        window.dataLayer.push({
          event: 'checkout',
          ecommerce: {
            checkout: {
              actionField: { step: 'Continuar' },
              products
            }
          }
        });
      }
    }
  };

  /**
   * check desktop quantity in desktop and set it to one
   * when the component mounts or it gets reset
   */
  getDisclaimer() {
    /* global window */
    const {
      disclaimer
    } = this.state;
    if (disclaimer && disclaimer.enabled) return;
    axios
      .get(`${process.env.GATSBY_CMSV2_URL}/disclaimers`)
      .then((data) => {
        const disclaimerData = data.data.filter(currentDisclaimer => currentDisclaimer.name === 'buyTicketDisclaimer' && currentDisclaimer.enabled && currentDisclaimer.forWeb)[0];
        const popupDisclaimer = data.data.filter(currentDisclaimer => currentDisclaimer.name === 'popupDisclaimer' && currentDisclaimer.enabled && currentDisclaimer.forWeb && window && ['/en/', '/es/'].includes(window.location.pathname))[0];
        const donationDisclaimer = data.data.filter(currentDisclaimer => currentDisclaimer.name === 'DonationsDisclaimer' && currentDisclaimer.enabled && currentDisclaimer.forWeb)[0];
        if (!disclaimerData && !popupDisclaimer) return;
        const disclaimers = {};
        if (disclaimerData) {
          this.initialState.disclaimer = disclaimerData;
          disclaimers.disclaimer = disclaimerData;
        }
        if (donationDisclaimer) {
          this.initialState.donationDisclaimer = donationDisclaimer;
          disclaimers.donationDisclaimer = donationDisclaimer;
        }
        if (popupDisclaimer) {
          try {
            let lastPopupSeenTime = window.localStorage.getItem("CBX_POPUP_DISCLAIMER");
            if (!lastPopupSeenTime) {
              lastPopupSeenTime = 0;
            }
            const lastPopupSeen = new Date(parseInt(lastPopupSeenTime));
            const currentPopupUpdate = new Date(popupDisclaimer.updatedAt);
            if (lastPopupSeen.getTime() < currentPopupUpdate.getTime()) {
              this.initialState.popupDisclaimer = false;
              disclaimers.popupDisclaimer = popupDisclaimer;
              window.localStorage.setItem("CBX_POPUP_DISCLAIMER", '' + new Date().getTime());
            }
          } catch (e) {
            console.log("Error popup", e);
          }
        }
        this.setState(disclaimers);
      });
  }


  /**
   * check desktop quantity in desktop and set it to one
   * when the component mounts or it gets reset
   */
  checkDesktopQuantity() {
    /* global window */
    if (window && window.innerWidth >= 768) {
      const {
        isFamily,
        isRoundTrip,
        company,
        packages,
        ticketNumber,
        activeTicketType: ticketType,
        flightDate,
        returnDate,
        acceptDonate
      } = this.state;

      this.setState({
        isBuyingActive: true,
        ticketNumber: Math.max(ticketNumber, 1),
        price: this.constructor.calculateValue({
          ticketNumber: Math.max(ticketNumber, 1),
          packages,
          isFamily,
          isRoundTrip,
          company,
          ticketType,
          flightDate,
          returnDate,
          acceptDonate
        })
      });
    }
    this.getDisclaimer();
  }

  /**
   * validate fields
   * @param {string} value - value to validate
   * @param {string} type - input type
   * @param {string} name - field name
   * @param {string} cardLength - credit card length
   * @returns {boolean}
   */
  validateField(value, type, name, cardLength) {
    switch (type) {
      default:
      case 'text':
        return value.replace(/^\s+$/gi, '').length >= 2;
      case 'tel': {
        if (name === 'zipCode' || name === 'creditCardZipCode') {
          return value.length === 5 && !this.nonDigit.test(value);
        }
        if (name === 'phone') {
          return this.phoneCheck.test(value) && value.length >= 8;
        }

        if (name === 'creditCard') {
          return value.replace(this.nonDigit, '').length === cardLength;
        }

        if (name === 'expirationDate') {
          const values = value.match(/\d+/g, '');
          const test = values ? values.join('').length === 4 : false;
          return test;
        }

        if (name === 'ccv') {
          const {
            creditCard: { brand }
          } = this.state;
          const ccvLength = brand === 'AMEX' ? 4 : 3;
          return value.length === ccvLength && !this.nonDigit.test(value);
        }

        return false;
      }
      case 'email': {
        const {
          email: { value: emailValue }
        } = this.state;
        return name === 'email'
          ? value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)
          : value === emailValue;
      }
      case 'checkbox': {
        if (name === 'acceptTerms') {
          return value;
        }

        return true;
      }
    }
  }

  /**
   * fill percentage of the form
   */
  formPercentage() {
    const { formPercentage: currentProgress } = this.state;
    const completeSteps = this.requiredField.reduce((acc, step) => {
      const {
        [step]: { status: valueStep }
      } = this.state;
      return acc + (valueStep === 1 ? 1 : 0);
    }, 0);

    const progress = completeSteps / this.requiredField.length;

    if (progress !== currentProgress) {
      this.setState({
        formPercentage: progress
      });
    }
  }

  /**
   * calculate promo discount
   * @param {Object} promoCodeData - promo code data
   * @param {Object} cart - cart items
   */
  calculateDiscount(promoCodeData, promo, cart) {
    const discountType = getKey(promoCodeData, 'IdPromoCodeType');
    const products = getKey(promoCodeData, 'lsProducts');
    const MaxProducts = getKey(promoCodeData, 'NuMaxProductPurchase');
    const promoCodeDataClone = JSON.parse(JSON.stringify(promoCodeData));

    let newCart = cart.sort((a, b) => {
      return parseFloat(b.Amount) - parseFloat(a.Amount);
    });

    const {
      packages,
      ticketNumber,
      isFamily,
      isRoundTrip,
      company,
      activeTicketType: ticketType,
      flightDate,
      returnDate,
      acceptDonate,
      price: { amount: oldGlobalPrice },
      hasQueue: itHasQueue
    } = this.state;
    let clonedPackage = JSON.parse(JSON.stringify(packages));

    if (discountType === 1) {
      const dontHaveDiscount = products.filter(p => getKey(p, 'BoExcluded') === true);

      let keysWithoutDiscount;
      if (isValidArray(dontHaveDiscount)) {
        keysWithoutDiscount = dontHaveDiscount.map(p => p.IdProduct);
      }

      const discountPercentage = parseFloat(getKey(promoCodeData, 'Discount', 0), 10);
      let prodsApplied = 0;
      const missingProducts = {
        flag: false
      };
      newCart = newCart.map((product) => {
        if (product.type !== `ticket`) {
          return product;
        }
        const currentProductID = product.IdProduct;
        const price = product.Amount;
        const newProduct = {
          ...product
        };
        if (!isValidArray(keysWithoutDiscount)
          || !keysWithoutDiscount.includes(currentProductID)
        ) {
          const toApply = Math.min(product.NuProdQuant, MaxProducts - prodsApplied);
          let unitDiscount = (price * (discountPercentage / 100)).toFixed(2);
          newProduct.Discount = toApply * unitDiscount;
          newProduct.DiscountAmount = price - unitDiscount;
          console.log(newProduct.DiscountAmount);
          const prodsLeft = MaxProducts - prodsApplied;
          if (prodsLeft > 0 && prodsLeft < product.NuProdQuant) {
            missingProducts.flag = true;
            missingProducts.product = {
              ...product,
              NuProdQuant: product.NuProdQuant - (MaxProducts - prodsApplied)
            };
            newProduct.NuProdQuant = MaxProducts - prodsApplied;
          }
          prodsApplied += toApply;
        }
        return newProduct;
      });
      if (missingProducts.flag) {
        newCart.push(missingProducts.product);
      }
      this.setState({
        cart: newCart,
        promoError: false,
        isPromoFetchingDisabled: false,
        hasValidPromo: true,
        hasQueue: false,
        promoCodeData: promoCodeDataClone,
        isLoading: false,
      });
    } else if (discountType === 2) {
      const hasSomeDiscount = products.filter(p => getKey(p, 'BoExcluded') === false);

      if (hasSomeDiscount.length > 0) {
        const productDiscount = hasSomeDiscount.reduce(
          (result, p) => ({
            [`discountPrice${p.IdProduct}`]: p.DcSpecialPrice,
            ...result
          }),
          {}
        );
        const keysWithDiscount = hasSomeDiscount.map(p => p.IdProduct);
        let prodsApplied = 0;
        const missingProducts = {
          flag: false
        };

        newCart = newCart.map((product) => {
          const currentProductID = product.IdProduct;
          const price = product.Amount;
          const newProduct = {
            ...product
          };
          if (keysWithDiscount.includes(currentProductID)) {
            const toApply = Math.min(product.NuProdQuant, MaxProducts - prodsApplied);
            const priceDifference = price - productDiscount[`discountPrice${currentProductID}`];
            if (priceDifference <= 0) {
              return product;
            }
            newProduct.Discount = toApply * (priceDifference);
            newProduct.DiscountAmount = productDiscount[`discountPrice${currentProductID}`];
            const prodsLeft = MaxProducts - prodsApplied;
            if (prodsLeft > 0 && prodsLeft < product.NuProdQuant) {
              missingProducts.flag = true;
              missingProducts.product = {
                ...product,
                NuProdQuant: product.NuProdQuant - (MaxProducts - prodsApplied)
              };
              newProduct.NuProdQuant = MaxProducts - prodsApplied;
            }
            prodsApplied += toApply;
          }
          return newProduct;
        });
        if (missingProducts.flag) {
          newCart.push(missingProducts.product);
        }

        this.setState({
          cart: newCart,
          isPromoFetchingDisabled: false,
          hasValidPromo: true,
          hasQueue: false,
          promoError: false,
          promoCodeData: promoCodeDataClone,
          isLoading: false,
        });
      } else {
        this.setState({
          isPromoFetchingDisabled: false,
          promoError: true,
          isSavingMoney: false,
          hasQueue: false,
          promoCodeData: null,
          isLoading: false,
        });
      }
    }
  }

  removePromo() {
    const {
      cart
    } = this.state;
    const cartData = getCartItems();
    this.setState({
      cart: cartData,
      hasValidPromo: false,
      promoCode: this.initialState.promoCode,
      isPromoFetchingDisabled: false,
      isSavingMoney: false,
      hasQueue: false,
      promoCodeData: null,
      isLoading: false,
    });
  }


  /**
   * request the promo validation
   * @param {boolean} [hasQueue = false] - true if has queue
   */
  requestPromocode(hasQueue = false) {
    const {
      promoCode: { value: promo }
    } = this.state;
    const {
      position
    } = this.props;
    const promoQuery = {
      coupon: promo
    };
    if (position) {
      console.log(position);
      promoQuery.location = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude
      };
    }
    axios
      .get(`${process.env.GATSBY_PROMO_URL}?PromoCode=${promo}`)
      .then(({ data }) => {
        const hasResult = getKey(data, 'PromoCodeModel');
        if (hasResult) {
          this.calculateDiscount(hasResult, promo, getCartItems());
        } else {
          this.setState(
            {
              isLoading: false,
              isPromoFetchingDisabled: false,
              validateButton: {
                status: 'error'
              },
              hasQueue: false,
              promoError: true
            },
            hasQueue ? this.doShopping : null
          );
        }
      })
      .catch(() => {
        this.setState(
          {
            isLoading: false,
            isPromoFetchingDisabled: false,
            validateButton: {
              status: 'error'
            },
            hasQueue: false,
          },
          hasQueue ? this.doShopping : null,

        );
      });
  }

  /**
   * Fetch promo actions
   * @param {Object} event - synthetic event
   */
  fetchTrigger() {
    const {
      validateButton: { status },
      promoCode: { value: promoCodeValue },
      isPromoFetchingDisabled,
      hasQueue
    } = this.state;

    if (isPromoFetchingDisabled || promoCodeValue.length === 0 || status === 'valid') return;

    this.setState(
      {
        isPromoFetchingDisabled: true
      },
      this.requestPromocode(hasQueue)
    );
  }

  /**
   * Fetch promo trigger
   * @param {Object} event - synthetic event
   */
  fetchPromo(event) {
    this.setState({ isLoading: true });
    if (event) event.preventDefault();
    this.fetchTrigger();
  }

  /**
   * Validate fields for promo
   * @param {Object} event - synthethic event
   */
  handleChangePromo(event) {
    const {
      target: { value }
    } = event;

    const {
      validateButton: { status: lastStatus },
      isPromoFetchingDisabled
    } = this.state;

    if (isPromoFetchingDisabled || lastStatus === 'valid') return;

    const currentStatus = value.length === 0 ? 'disabled' : lastStatus;

    this.setState({
      promoCode: {
        value
      },
      validateButton: {
        status: lastStatus === 'disabled' ? 'normal' : currentStatus
      }
    });
  }

  /**
   * Handles saved cards options
   * @param {Object} event - synthetic event
   */
  handleSavedCards(event) {
    const { value } = event.target;
    const { savedCards } = this.state;

    const isOtherCard = value === 'manual';
    const creditCardInfo = !isOtherCard && savedCards.filter(card => card.value === value)[0];

    this.setState({
      currentCard: value,
      creditCard: {
        value: !isOtherCard ? creditCardInfo.creditCard : '',
        status: isOtherCard ? 0 : 1,
        brand: !isOtherCard ? creditCardInfo.brand : ''
      },
      creditCardHolder: {
        value: !isOtherCard ? creditCardInfo.creditCardHolder : '',
        status: isOtherCard ? 0 : 1,
        edited: !isOtherCard
      },
      ccv: {
        value: !isOtherCard ? creditCardInfo.ccv : '',
        status: isOtherCard ? 0 : 1
      },
      creditCardZipCode: {
        value: !isOtherCard ? creditCardInfo.creditCardZipCode : '',
        status: isOtherCard ? 0 : 1,
        edited: !isOtherCard
      },
      expirationDate: {
        value: !isOtherCard ? creditCardInfo.expirationDate : '',
        status: isOtherCard ? 0 : 1
      },
      token: isOtherCard ? null : creditCardInfo.token
    });

    event.preventDefault();
  }

  handleParkingChange(field, value) {
    this.setState({
      [field]: value
    });
  }

  /**
   * Handle changes in donation selection
   * @param {number} amount - donation amount
   */
  handleDonationChange(newAmount) {
    const {
      cart,
      acceptDonate: {
        amount
      }
    } = this.state;
    const checked = newAmount > 0;
    if (newAmount === amount) return;
    let newCart = [...cart];
    newCart = newCart.filter(product => (!product.donation));
    if (checked) {
      newCart.push({
        IdProduct: 18000271,
        NuPersonQuant: 0,
        NuProdQuant: newAmount,
        Amount: 1,
        DcMex: 0,
        DcUsa: 0,
        IdPricing: 2526,
        IdHierarchy: 10,
        type: 'ticket',
        donation: true,
        flightDate: new Date().toISOString(),
        DsPublic: 'Donation',
        DsPublicEn: 'Donation',
        origin: { abbreviatedPlace: 'Donation', place: 'Donation' },
        destination: { abbreviatedPlace: 'Donation', place: 'Donation' }
      });
    }

    this.setState({
      acceptDonate: {
        checked,
        amount: newAmount
      },
      cart: newCart
    });
  }

  /**
   * Validate fields
   * @param {Object} event - synthethic event
   */
  handleChange(event) {
    const {
      target: { name, value, type }
    } = event;
    const newState = {};
    switch (name) {
      case 'emailCheck':
      case 'email': {
        const {
          emailCheck: { value: emailCheckValue }
        } = this.state;

        Object.assign(newState, {
          [name]: {
            value,
            status: this.validateField(value, type, name) ? 1 : 2
          }
        });

        if (name === 'email' && emailCheckValue.length > 0) {
          Object.assign(newState, {
            emailCheck: { value: emailCheckValue, status: emailCheckValue === value ? 1 : 2 }
          });
        }
        break;
      }
      case 'ccv':
      case 'creditCardZipCode':
      case 'zipCode': {
        const newValue = value.replace(this.nonDigit, '').substring(0, name === 'ccv' ? 4 : 5);
        const {
          creditCardZipCode: { edited }
        } = this.state;

        if (name === 'zipCode' && !edited) {
          Object.assign(newState, {
            creditCardZipCode: {
              value: newValue,
              status: this.validateField(newValue, type, name) ? 1 : 2
            }
          });
        }

        if (name === 'creditCardZipCode') {
          Object.assign(newState, {
            [name]: {
              value: newValue,
              status: this.validateField(newValue, type, name) ? 1 : 2,
              edited: true
            }
          });
        } else {
          Object.assign(newState, {
            [name]: {
              value: newValue,
              status: this.validateField(newValue, type, name) ? 1 : 2
            }
          });
        }

        break;
      }
      case 'creditCard': {
        const { brand, length } = this.constructor.checkCreditCard(value);
        const {
          ccv: { value: ccvValue }
        } = this.state;
        const isAmex = brand === 'AMEX';
        let newValue;

        if (isAmex) {
          const tempVal = value.replace(this.nonDigit, '');
          newValue = (
            tempVal.slice(0, 4).replace(/(.{4})/g, '$1 ')
            + tempVal.slice(4, 10).replace(/(.{6})/g, '$1 ')
            + tempVal.slice(10, 15)
          ).trim();
        } else {
          newValue = value
            .replace(this.nonDigit, '')
            .replace(/(.{4})/g, '$1 ')
            .trim()
            .substring(0, 19);
        }

        Object.assign(newState, {
          creditCard: {
            value: newValue,
            status: this.validateField(newValue, type, 'creditCard', length) ? 1 : 2,
            brand
          }
        });

        const ccvLength = ccvValue.length;
        if (ccvLength > 0) {
          const numberValidation = isAmex ? ccvLength === 4 : ccvLength === 3;
          Object.assign(newState, {
            ccv: { value: ccvValue, status: numberValidation ? 1 : 2 }
          });
        }

        break;
      }
      case 'name':
      case 'lastName': {
        const newValue = value.replace(/^\s+$/gi, '').length === 0 ? '' : value;
        Object.assign(newState, {
          [name]: {
            value: newValue,
            status: this.validateField(newValue, type, name) ? 1 : 2
          }
        });
        const {
          name: { value: nameStateValue },
          lastName: { value: lastNameStateValue },
          creditCardHolder: { edited }
        } = this.state;
        const isName = name === 'name';

        if (!edited) {
          const nameValue = isName ? newValue.split(' ') : nameStateValue.split(' ');
          const lastNameValue = !isName ? newValue.split(' ') : lastNameStateValue.split(' ');
          const firstName = isValidArray(nameValue) ? nameValue[0].trim() : '';
          const middleName = isValidArray(nameValue) && nameValue.length > 1 && nameValue[1].length > 0
            ? ` ${nameValue[1].substring(0, 1).toUpperCase()}`
            : '';
          const firstLastName = isValidArray(lastNameValue) ? ` ${lastNameValue[0].trim()}` : '';
          const secondLastName = isValidArray(lastNameValue) && lastNameValue.length > 1
            ? ` ${lastNameValue[1].substring(0, 1).toUpperCase()}`
            : '';

          const fullName = `${firstName}${middleName}${firstLastName}${secondLastName}`;

          Object.assign(newState, {
            creditCardHolder: { value: fullName, status: value.length >= 2 ? 1 : 0 }
          });
        }

        break;
      }
      case 'creditCardHolder': {
        let newValue = value.replace(/^\s+$/gi, '').length === 0 ? '' : value;
        newValue = newValue.substring(0, 25);
        Object.assign(newState, {
          creditCardHolder: {
            value: newValue,
            status: this.validateField(newValue, type, 'creditCardHolder') ? 1 : 2,
            edited: true
          }
        });
        break;
      }
      case 'expirationDate': {
        const tempVal = value.replace(/[^0-9]/g, '').substring(0, 4);
        let newValue = tempVal;

        if (tempVal.length === 1) {
          if (tempVal === '0' || tempVal === '1') {
            newValue = tempVal;
          } else {
            newValue = '';
          }
        } else if (tempVal.length === 2) {
          const previousVal = tempVal.substring(0, 1);
          const thisVal = tempVal.substring(1, 2);

          if (previousVal === '1') {
            newValue = thisVal > 2 ? '1' : tempVal;
          } else {
            newValue = thisVal !== '0' ? tempVal : '0';
          }
        } else if (tempVal.length >= 3) {
          const month = tempVal.substring(0, 2);
          let year = tempVal.substring(2, tempVal.length);
          year = tempVal.length === 3 && year < 1 ? '1' : year;
          year = tempVal.length === 4 && year < this.currentYear ? this.currentYear : year;

          newValue = `${month} / ${year}`;
        }

        Object.assign(newState, {
          [name]: {
            value: newValue,
            status: this.validateField(newValue, type, name) ? 1 : 2
          }
        });

        break;
      }
      case 'acceptTerms': {

        const {
          acceptTerms: { checked: currentStatus }
        } = this.state;
        Object.assign(newState, {
          [name]: {
            checked: !currentStatus,
            status: this.validateField(!currentStatus, type, name) ? 1 : 2,
            color: !currentStatus === true ? PURPLE_LIGHT : 'red'
          },
          showModal: !currentStatus
        });
        break;
      }
      case 'acceptDonate': {
        const {
          acceptDonate: { checked: currentStatus },
          cart
        } = this.state;
        this.checkDesktopQuantity();
        const newStatus = !currentStatus;
        let newCart = [...cart];

        if (newStatus) {
          newCart.push({
            IdProduct: 18000271,
            NuPersonQuant: 0,
            NuProdQuant: 1,
            Amount: 1,
            DcMex: 0,
            DcUsa: 0,
            IdPricing: 2526,
            IdHierarchy: 10,
            type: 'ticket',
            donation: true,
            flightDate: new Date().toISOString(),
            DsPublic: 'Donation',
            DsPublicEn: 'Donation',
            origin: { abbreviatedPlace: 'Donation', place: 'Donation' },
            destination: { abbreviatedPlace: 'Donation', place: 'Donation' }
          });
        } else {
          newCart = newCart.filter(product => (!product.donation));
        }
        Object.assign(newState, {
          [name]: {
            checked: newStatus,
            status: this.validateField(!currentStatus, type, name) ? 1 : 2,
            color: !currentStatus === true ? PURPLE_LIGHT : 'red'
          },
          cart: newCart
        });
        break;
      }
      case 'storeCard': {
        const {
          storeCard: { checked: currentStatus },
        } = this.state;
        const newStatus = !currentStatus;
        Object.assign(newState, {
          [name]: {
            checked: newStatus,
            status: this.validateField(!currentStatus, type, name) ? 1 : 2,
            color: !currentStatus === true ? PURPLE_LIGHT : 'red'
          },
        });
        break;
      }
      case 'acceptMailInfo': {
        const {
          acceptMailInfo: { checked: currentStatus }
        } = this.state;
        Object.assign(newState, {
          [name]: {
            checked: !currentStatus
          }
        });
        break;
      }
      case 'phone': {
        if (this.phoneCheck.test(value)) {
          Object.assign(newState, {
            [name]: {
              value,
              status: this.validateField(value, type, name) ? 1 : 2
            }
          });
        }
        break;
      }
      default: {
        Object.assign(newState, {
          [name]: {
            value,
            status: this.validateField(value, type, name) ? 1 : 2
          }
        });
        break;
      }
    }

    this.setState(newState, () => {
      this.formPercentage();
      this.checkDesktopQuantity();
    });
  }

  /**
   * focus the name field
   * @param {boolean} isDesktop - true if it's not mobile
   */
  focusField(isDesktop) {
    const { isBuying } = this.state;

    if (isBuying) {
      const pendingFields = this.requiredField.filter((field) => {
        const {
          [field]: { status: valueStep }
        } = this.state;

        return valueStep !== 1;
      });

      if (isValidArray(pendingFields)) {
        const pendingField = pendingFields[0];
        if (pendingField === 'acceptTerms') {
          this.setState({
            acceptTerms: {
              checked: false,
              status: 2,
              color: 'red'
            }
          });
        } else if (exists(this[`${pendingField}Ref${isDesktop ? 'Desktop' : ''}`].current)) {
          this[`${pendingField}Ref${isDesktop ? 'Desktop' : ''}`].current.focus();
        }
      }
    }
  }

  /**
   * Cancel action
   */
  cancelAction() {
    trackCustomEvent({
      category: 'Purchase intent',
      action: 'Cancel button',
      label: 'Cancel button clicked'
    });
    this.setState(Object.assign({}, this.initialState), () => this.checkDesktopQuantity());
  }

  /**
   * Close the buyed ticket
   */
  closeBuyedTicket() {
    this.setState(Object.assign({}, this.initialState), () => this.checkDesktopQuantity());
  }

  /**
   * Switch buying activity
   * @param {Object} event - synthetic event type
   */
  buyingToggle(event) {
    event.preventDefault();
    const {
      isBuying,
      isFamily,
      isRoundTrip,
      company,
      packages,
      hasValidPromo,
      activeTicketType: ticketType,
      flightDate,
      returnDate,
      acceptDonate
    } = this.state;
    const { packages: oldPackages } = this.props;
    const { value } = event.target;
    const status = value > 0;

    const price = this.constructor.calculateValue({
      ticketNumber: value,
      packages,
      isFamily,
      isRoundTrip,
      company,
      ticketType,
      flightDate,
      returnDate,
      acceptDonate
    });

    let oldPrice;

    if (hasValidPromo) {
      const oldPackage = JSON.parse(JSON.stringify(oldPackages));
      oldPrice = this.constructor.calculateValue({
        ticketNumber: value,
        packages: oldPackage,
        isFamily,
        isRoundTrip,
        company,
        ticketType,
        flightDate,
        returnDate,
        acceptDonate
      });
    }
    if (isBuying) {
      this.removeCart();
    }
    this.setState(
      {
        hasMoveSingle: true,
        ticketNumber: value,
        price,
        isBuyingActive: status,
        isBuying: !status ? false : isBuying,
        isSavingMoney:
          hasValidPromo && this.constructor.calculateCurrentDiscount(oldPrice.amount, price.amount)
      },
      () => {
        this.setProductView();
      }
    );
  }

  /**
   * Travel Purpose handler
   * @param {Object} event - synthetic event
   */
  travelPurposeHandler(event) {
    this.setState({
      travelPurpose: event.target.value
    });
  }
  /**
   * shuttle Destination handler
   * @param {Object} event - synthetic event
   */
  /**
   * shuttle Origin handler
   * @param {Object} event - synthetic event
   */

  /**
     * shuttle travel way handler
     * @param {Object} event - synthetic event
     */
  shuttleTravelHandler(event) {
    this.setState({
      shuttleTravel: event.target.value,
    });
  }
  updateShuttleQuickData(shuttleData) {
    const qData = getQuickData();
    window.localStorage.setItem('CBX_Quick_Data', JSON.stringify({ ...qData, ...shuttleData }));
  };

  shuttleStartDateHandler(evt) {
    const {
      isSelectedTrip,
      shuttleDestination,
      shuttleOrigin,
      shuttlePassengers,
      shuttleTravelType,
      shuttleEndDate
    } = this.state;
    const newState = {
      shuttleStartDate: evt.target.value
    };
    if (shuttleEndDate < newState.shuttleStartDate) {
      console.log("Updating .... ", shuttleEndDate);
      newState.shuttleEndDate = "";
    }
    console.log("Setting ", newState);
    this.setState(newState);
    this.updateShuttleQuickData({
      isSelectedTrip: isSelectedTrip,
      shuttleDestination: shuttleDestination,
      shuttleEndDate: newState.shuttleEndDate,
      shuttleOrigin: shuttleOrigin,
      shuttlePassengers: shuttlePassengers,
      shuttleStartDate: newState.shuttleStartDate,
      shuttleTravelType: shuttleTravelType
    });
  }

  shuttleEndDateHandler(evt) {
    console.log(evt);
    const {
      isSelectedTrip,
      shuttleDestination,
      shuttleOrigin,
      shuttlePassengers,
      shuttleTravelType,
      shuttleStartDate,
    } = this.state;
    if (evt.target.value < '2022-03-20') return;
    this.setState({
      shuttleEndDate: evt.target.value
    });
    this.updateShuttleQuickData({
      isSelectedTrip: isSelectedTrip,
      shuttleDestination: shuttleDestination,
      shuttleEndDate: evt.target.value,
      shuttleOrigin: shuttleOrigin,
      shuttlePassengers: shuttlePassengers,
      shuttleStartDate: shuttleStartDate,
      shuttleTravelType: shuttleTravelType
    });
  }

  /**
   * Ticket type handler
   * @param {Object} event - synthetic event
   */
  ticketTypeHandler(event) {
    const {
      state: {
        isFamily: isFamilyState,
        ticketNumber: ticketNumberState,
        isRoundTrip,
        company,
        hasMoveSingle,
        packages,
        hasValidPromo,
        flightDate,
        returnDate,
        acceptDonate
      },
      props: { packages: oldPackages }
    } = this;
    const { value } = event.target;
    const isFamily = parseInt(value, 10) === 3;
    const ticketNumberSingle = ticketNumberState;
    const ticketNumber = isFamily && parseInt(ticketNumberState, 10) < 4 ? '4' : ticketNumberSingle;
    const price = this.constructor.calculateValue({
      ticketNumber,
      packages,
      isFamily,
      isRoundTrip,
      company,
      ticketType: value,
      flightDate,
      returnDate,
      acceptDonate
    });

    let oldPrice;

    if (hasValidPromo) {
      const oldPackage = JSON.parse(JSON.stringify(oldPackages));
      oldPrice = this.constructor.calculateValue({
        ticketNumber,
        packages: oldPackage,
        isFamily,
        isRoundTrip,
        company,
        ticketType: value,
        flightDate,
        returnDate,
        acceptDonate
      });
    }
    if (this.state.isBuying) {
      this.removeCart();
    }

    this.setState(
      {
        activeTicketType: value,
        isFamily,
        ticketNumber,
        isBuyingActive: true,
        price,
        quantityPersons: isFamily ? this.personsOptions : this.quantityOptions,
        quantityBaggage: this.quantityOptionsBaggage,
        isSavingMoney:
          hasValidPromo && this.constructor.calculateCurrentDiscount(oldPrice.amount, price.amount)
      },
      () => {
        this.setProductView();
      }
    );
  }

  /**
   * Handles travel type
   * @param {Object} event - synthetic event
   */
  travelTypeHandler(event) {
    const {
      isRoundTrip: isRoundTripState,
      company,
      ticketNumber: ticketNumberState,
      isFamily,
      packages,
      hasValidPromo,
      activeTicketType: ticketTypeState,
      flightDate,
      returnDate,
      acceptDonate
    } = this.state;
    const { packages: oldPackages, ticketType: ticketTypes } = this.props;
    const isRoundTrip = event.target.value === 'roundtrip';

    const validProductPackages = packages.filter((productPack) => {
      if (isRoundTrip) {
        return productPack.IdCompany === company && productPack.IdCrossingType === 3;
      }
      return productPack.IdCompany === company && productPack.IdCrossingType !== 3;
    });
    const validProds = validProductPackages.map((productPack) => {
      return productPack.IdProdClassification;
    });
    const ticketType = (() => {
      if (!validProds.includes(parseInt(ticketTypeState, 10))) {
        let returnProduct = validProds[0];
        const currentName = ticketTypes.options.find(
          option => option.value === parseInt(ticketTypeState, 10)
        ).name;
        ticketTypes.options.forEach((ticketOption) => {
          if (validProds.includes(ticketOption.value) && ticketOption.name === currentName) {
            returnProduct = ticketOption.value;
          }
        });
        return returnProduct;
      }
      return ticketTypeState;
    })();

    const ticketNumber = parseInt(ticketNumberState, 10) === 0 ? '1' : ticketNumberState;

    const price = this.constructor.calculateValue({
      ticketNumber,
      packages,
      isFamily,
      isRoundTrip,
      company,
      ticketType,
      flightDate,
      returnDate,
      acceptDonate
    });

    let oldPrice;

    if (hasValidPromo) {
      const oldPackage = JSON.parse(JSON.stringify(oldPackages));
      oldPrice = this.constructor.calculateValue({
        ticketNumber,
        packages: oldPackage,
        isFamily,
        isRoundTrip,
        company,
        ticketType,
        flightDate,
        returnDate,
        acceptDonate
      });
    }
    if (this.state.isBuying) {
      this.removeCart();
    }

    this.setState(
      {
        ticketNumber,
        activeTicketType: `${ticketType}`,
        activeTravelType: event.target.value,
        isRoundTrip,
        isBuyingActive: true,
        price,
        isSavingMoney:
          hasValidPromo && this.constructor.calculateCurrentDiscount(oldPrice.amount, price.amount)
      },
      () => {
        this.setProductView();
      }
    );
  }

  lotHandler = (evt) => {
    this.setState({ lot: evt.target.value });
  }

  /**
   * toggle between places
   */
  switchPlaces() {
    const {
      origin,
      destination,
      company: companyValue,
      ticketNumber,
      isFamily,
      isRoundTrip,
      packages,
      hasValidPromo,
      flightDate,
      returnDate,
      activeTicketType: ticketType,
      acceptDonate
    } = this.state;
    const { packages: oldPackages } = this.props;
    const company = companyValue === 1 ? 2 : 1;

    const price = this.constructor.calculateValue({
      ticketNumber,
      packages,
      isFamily,
      isRoundTrip,
      company,
      ticketType,
      flightDate,
      returnDate,
      acceptDonate
    });

    let oldPrice;

    if (hasValidPromo) {
      const oldPackage = JSON.parse(JSON.stringify(oldPackages));
      oldPrice = this.constructor.calculateValue({
        ticketNumber,
        packages: oldPackage,
        isFamily,
        isRoundTrip,
        company,
        ticketType,
        flightDate,
        returnDate,
        acceptDonate
      });
    }
    if (this.state.isBuying) {
      this.removeCart();
    }

    this.setState(
      {
        origin: destination,
        destination: origin,
        company,
        price,
        isSavingMoney:
          hasValidPromo && this.constructor.calculateCurrentDiscount(oldPrice.amount, price.amount)
      },
      () => {
        this.setProductView();
      }
    );
  }

  /**
   * Sets toggle destination to grow
   */
  toggleGrow() {
    const { isToggleFocused } = this.state;
    if (!isToggleFocused) {
      this.setState({ isToggleFocused: true });
    }
  }

  /**
   * Sets toggle destination to shring
   */
  toggleShrink() {
    const { isToggleFocused } = this.state;
    if (isToggleFocused) {
      this.setState({ isToggleFocused: false });
    }
  }

  /**
   * Handles change on flightDate input control
   * @param {Object} event - Event of change to control
   */
  flightDateHandler(event) {
    const {
      company,
      ticketNumber,
      isFamily,
      isRoundTrip,
      packages,
      hasValidPromo,
      returnDate: currentReturnDate,
      activeTicketType: ticketType,
      activeTravelType,
      isBuying,
      minDate,
      acceptDonate
    } = this.state;
    const { packages: oldPackages } = this.props;
    const newDate = event.target.value;
    if (newDate < minDate) {
      return;
    }
    let newReturnDate = currentReturnDate;
    if (newDate > currentReturnDate && activeTravelType === 'roundtrip') {
      newReturnDate = newDate;
    }

    const price = this.constructor.calculateValue({
      ticketNumber,
      packages,
      isFamily,
      isRoundTrip,
      company,
      ticketType,
      flightDate: newDate,
      returnDate: newReturnDate,
      acceptDonate
    });

    let oldPrice;

    if (hasValidPromo) {
      const oldPackage = JSON.parse(JSON.stringify(oldPackages));
      oldPrice = this.constructor.calculateValue({
        ticketNumber,
        packages: oldPackage,
        isFamily,
        isRoundTrip,
        company,
        ticketType,
        flightDate: newDate,
        returnDate: newReturnDate,
        acceptDonate
      });
      this.setState({ isLoading: false });
    } else {
      this.setState({ isLoading: false });
    }

    if (isBuying) {
      this.removeCart();
    }

    this.setState(
      {
        flightDate: newDate,
        returnDate: this.initialState.returnDate,
        price,
        isSavingMoney:
          hasValidPromo && this.constructor.calculateCurrentDiscount(oldPrice.amount, price.amount)
      },
      () => {
        this.setProductView();
      }
    );
  }

  openSurvey(widgetToken, surveyName) {
    const e = 'ss-widget';

    const t = 'script';

    const a = document;

    const r = window;
    let s;
    let n;
    let c;
    r.SS_WIDGET_TOKEN = widgetToken;
    r.SS_ACCOUNT = 'cbx.surveysparrow.com';
    r.SS_SURVEY_NAME = surveyName;
    if (!a.getElementById(e)) {
      var S = function() {
        S.update(arguments);
      };
      S.args = [];
      S.update = function(e) {
        S.args.push(e);
      };
      r.SparrowLauncher = S;
      s = a.getElementsByTagName(t);
      c = s[s.length - 1];
      n = a.createElement(t);
      n.type = 'text/javascript';
      n.async = !0;
      n.id = e;
      n.src = ['https://', 'cbx.surveysparrow.com/widget/', r.SS_WIDGET_TOKEN].join('');
      c.parentNode.insertBefore(n, c);
    }
  }

  /**
   * Handles change on flightDate input control
   * @param {Object} event - Event of change to control
   */
  returnDateHandler(event) {
    const {
      company,
      ticketNumber,
      isFamily,
      isRoundTrip,
      packages,
      hasValidPromo,
      flightDate,
      activeTicketType: ticketType,
      isBuying,
      minDate,
      acceptDonate
    } = this.state;
    const { packages: oldPackages } = this.props;

    const newReturnDate = event.target.value;
    const compareDate = flightDate || minDate;
    if (newReturnDate < compareDate) return;
    const price = this.constructor.calculateValue({
      ticketNumber,
      packages,
      isFamily,
      isRoundTrip,
      company,
      ticketType,
      flightDate,
      returnDate: newReturnDate,
      acceptDonate
    });

    let oldPrice;

    if (hasValidPromo) {
      const oldPackage = JSON.parse(JSON.stringify(oldPackages));
      oldPrice = this.constructor.calculateValue({
        ticketNumber,
        packages: oldPackage,
        isFamily,
        isRoundTrip,
        company,
        ticketType,
        flightDate,
        returnDate: newReturnDate,
        acceptDonate
      });
    }

    if (isBuying) {
      this.removeCart();
    }

    this.setState(
      {
        returnDate: newReturnDate,
        price,
        isSavingMoney:
          hasValidPromo && this.constructor.calculateCurrentDiscount(oldPrice.amount, price.amount)
      },
      () => {
        this.setProductView();
      }
    );
  }

  /**
   * Adds new Item to Cart
   */
  addToCart() {
    const {
      name: { value: name },
      lastName: { value: lastName },
      email: { value: email },
      zipCode: { value: zipCode },
      phone: { value: phone },
      company,
      ticketNumber,
      origin,
      destination,
      isFamily,
      isRoundTrip,
      packages,
      hasValidPromo,
      flightDate,
      returnDate,
      ticketType,
      activeTicketType,
      travelType,
      activeTravelType,
      isBuying,
      minDate,
      travelPurpose,
      acceptDonate,
    } = this.state;
    const {
      locale
    } = this.props;
    insertContactInfo({
      name,
      lastName,
      email,
      zipCode,
      phone
    });
    const price = this.constructor.calculateValue({
      ticketNumber,
      packages,
      isFamily,
      isRoundTrip,
      company,
      ticketType: activeTicketType,
      flightDate,
      returnDate,
      acceptDonate,
      groupId: uuid.v4()
    });
    this.setState({
      isLoading: true
    });
    if (price.products.length === 0) {
      alert("Ocurrió un error agregando el elemento al carrito");
      return;
    }
    const assisted_data = JSON.parse(window.localStorage.getItem('assisted_data'));
    price.products.forEach((product) => {
      const cartItem = {
        origin,
        destination,
        flightDate,
        returnDate,
        ticketType: activeTicketType,
        travelType: activeTravelType,
        travelPurpose,
        type: 'ticket',
        groupId: uuid.v4(),
        ...product,
        assisted_data
      };
      cartItem.item_name = product.DsPublicAlias;
      cartItem.item_id = product.IdProduct;
      cartItem.price = product.Amount;
      cartItem.quantity = product.NuProdQuant;
      insertCartItem(cartItem);
      window.dataLayer.push({
        event: 'addToCart',
        ecommerce: {
          currency: 'USD',
          value: product.NuProdQuant * product.Amount,
          items: [
            {
              item_name: cartItem.item_name,
              item_id: cartItem.item_id,
              price: cartItem.price,
              quantity: cartItem.quantity
            }
          ]
        }
      });
    });
    removeQuickData();
    this.setState({
      isLoading: false,
      assistPassTempId: createUUID
    });

    if (typeof window !== "undefined" && window.localStorage.getItem('currentFlow') === 'Bundles') {
      window.location.href = `/${locale}/shuttleSelectTrip`
    } else {
      window.location.href = `/${locale}/addOns`;
    }
  }

  /**
   * @function connect
   * This function establishes the connect with the websocket and also ensures constant reconnection if connection closes
   */
  connect = (uuid) => {
    const ws = new WebSocket(`${process.env.GATSBY_SOCK_URL}?uuid=${uuid}`);
    const that = this; // cache the this
    let connectInterval;

    // websocket onopen event listener
    ws.onopen = () => {
      console.log('connected websocket component');
      this.setState({ ws });

      that.timeout = 2500; // reset timer to 250 on open of websocket connection
      clearTimeout(connectInterval); // clear Interval on on open of websocket connection
    };

    // websocket onclose event listener
    ws.onclose = (e) => {
      connectInterval = setTimeout(() => { this.check(uuid); }, 5000); // Call check function after timeout
    };

    // websocket onerror event listener
    ws.onerror = (err) => {
      console.error('ERRR');
      console.error(err);
      ws.close();
    };
    ws.onmessage = (msg) => {
      const {
        cart
      } = that.state;
      const {
        locale
      } = that.props;
      const message = JSON.parse(msg.data);

      if (message.error) {
        clearData();
        window.localStorage.setItem('shortId', message.shortId);
        window.location.href = `/${locale}/error?ControlNumber=${uuid}`;
        return;
      }
      const data = {};
      if (message.tixResult && !message.voucher) {
        data.link = message.tixResult.urlTicket;
        data.data = {
          transactionID: message.tixResult.UidTransaction
        };
      }
      if (message.voucher && !message.tixResult) {
        data.link = message.voucher.urlTicket;
        data.data = {
          transactionID: message.voucher.parkingPdf[0].id
        };
      }
      if (message.shuttleResponse) {
        data.shuttleLink = message.shuttleResponse.urlTicket;
        data.data = {
          transactionID: uuid
        };

      }
      if (message.wheelsResponse) {
        data.wheelsLink = message.wheelsResponse.urlTicket;
        data.data = {
          transactionID: uuid
        };
      }
      if (message.voucher && message.tixResult) {
        data.cbxLink = message.tixResult.urlTicket;
        data.parkingLink = message.voucher.urlTicket;
        data.data = {
          transactionID: message.tixResult.UidTransaction
        };
      }
      if (message.shortId) {
        data.shortId = message.shortId;
        window.localStorage.setItem('shortId', message.shortId);
      }

      this.setState({
        ticketURL: data.link || data.cbxLink || data.parkingLink || data.shuttleLink || data.wheelsLink,
        isSucess: true,
        ticketDownloaded: false
      });
      trackCustomEvent({
        category: 'Purchase completed',
        action: 'Successful Purchase Notification',
        label: 'Successful Purchase Notification'
      });
      let amount = 0;
      cart.forEach((product) => {
        amount += product.price * product.quantity;
        if (product.Discount) amount -= product.Discount;
      });
      const actionField = {
        transaction_id: message.shortId,
        value: amount
      };
      if (this.state.hasValidPromo) {
        actionField.coupon = this.state.promoCode.value;
      }
      window.dataLayer.push({
        event: 'purchase',
        ecommerce: {
          ...actionField,
          items: cart.map((product) => {
            return {
              item_name: product.item_name,
              item_id: product.item_id,
              price: product.price,
              quantity: product.quantity
            };
          })
        }
      });

      clearData();
      window.localStorage.setItem('CBX_Ticket', JSON.stringify(data));
      window.location.href = `/${locale}/thankyou`;
      setTimeout(() => {
        this.openSurvey('tt-56ceb5', '8-DIGITAL-Sales-Channel--Website');
        this.setState({ showSurvey: true });
      }, 3000);
    };
  };

  /**
   * utilited by the @function connect to check if the connection is close, if so attempts to reconnect
   */
  check = (uuid) => {
    const { ws } = this.state;
    if (!ws || ws.readyState == WebSocket.CLOSED) this.connect(uuid); //check if websocket instance is closed, if so call `connect` function.
  };

  saveParkingInfo = () => {
    const { locale } = this.props;
    window.location.href = `/${locale}/personalInfo`;
  }

  saveWheelsInfo = (data) => {
    const { locale } = this.props;
    window.localStorage.setItem('wheels', JSON.stringify(data));
    window.location.href = `/${locale}/personalInfo`;
  }


  saveShuttleInfo = () => {
    const { locale } = this.props;
    window.location.href = `/${locale}/cart`;
  }


  addParkingCart(goToAddOns = false) {
    const {
      name: { value: name },
      lastName: { value: lastName },
      email: { value: email },
      zipCode: { value: zipCode },
      phone: { value: phone },
      isParkingFlow
    } = this.state;
    const {
      locale
    } = this.props;

    insertContactInfo({
      name,
      lastName,
      email,
      zipCode,
      phone
    });

    this.setState({
      isLoading: true
    });

    const parkingData = JSON.parse(window.localStorage.getItem('parking'));

    if (!parkingData) {
      this.getParkingPrice({ startDate, startTime, endDate, endTime, isCallingParkingApi }, 3)
      window.location.href = goToAddOns ? `/${locale}/addOns` : `/${locale}/cart`
    }

    const { vehicles, data } = parkingData;

    vehicles.map(vehicle => {
      const { brand, model, year, color, license, state } = vehicle;
      const cartItem = {
        location: data.lot[0].location_name,
        reservation: Math.random().toString(36).replace(/[^a-z]+/g, '').substring(0, 16),
        status: 'valid',
        customer_paid: data.price,
        Amount: data.price,
        NuProdQuant: 1,
        vehicleLicense: license,
        vehicleDescription: `${brand} ${model} ${year} color ${color}`,
        instructions: `Valid for one use`,
        doNotBurn: 0,
        type: 'parking',
        start_time: `${data.from}`,
        end_time: `${data.to}`,
        brand,
        model,
        year,
        color,
        state,
        lot: data.lot[0].id,
      };
      cartItem.item_name = `Parking ${cartItem.location}`;
      cartItem.item_id = `Parking ${cartItem.location}`;
      cartItem.price = cartItem.customer_paid;
      cartItem.quantity = 1;
      insertCartItem(cartItem);
      window.dataLayer.push({
        event: 'addToCart',
        ecommerce: {
          currency: 'USD',
          value: data.price,
          items: [
            {
              item_name: cartItem.item_name,
              item_id: cartItem.item_id,
              price: cartItem.price,
              quantity: cartItem.quantity
            }
          ]
        }
      });
    });
    removeQuickData();

    window.location.href = goToAddOns ? `/${locale}/addOns` : `/${locale}/cart`;

    this.setState({
      isLoading: false
    });
    window.localStorage.removeItem('parking');
  }

  addWheelsCart(goToAddOns = false) {
    const {
      name: { value: name },
      lastName: { value: lastName },
      email: { value: email },
      zipCode: { value: zipCode },
      phone: { value: phone },
      isParkingFlow
    } = this.state;
    const {
      locale
    } = this.props;

    insertContactInfo({
      name,
      lastName,
      email,
      zipCode,
      phone
    });

    this.setState({
      isLoading: true
    });

    const wheelsData = JSON.parse(window.localStorage.getItem('wheels'));

    if (!wheelsData) {
      return window.location.href = `/${locale}/wheels`;
    }

    const cartItem = {
      Amount: wheelsData.price,
      NuProdQuant: 1,
      ...wheelsData
    };
    cartItem.item_name = `Wheels ${cartItem.vehicle} ${cartItem.zone}`;
    cartItem.item_id = `Wheels_${cartItem.vehicle}_${cartItem.zone}`;
    cartItem.price = cartItem.Amount;
    cartItem.quantity = 1;

    insertCartItem(cartItem);

    window.dataLayer.push({
      event: 'addToCart',
      ecommerce: {
        currency: 'USD',
        value: cartItem.price,
        items: [
          {
            item_name: cartItem.item_name,
            item_id: cartItem.item_id,
            price: cartItem.price,
            quantity: cartItem.quantity
          }
        ]
      }
    });
    removeQuickData();

    window.location.href = goToAddOns ? `/${locale}/addOns` : `/${locale}/cart`;

    this.setState({
      isLoading: false
    });
    window.localStorage.removeItem('wheels');
  }

  addShuttleCart(goToAddOns = false) {
    const {
      name: { value: name },
      lastName: { value: lastName },
      email: { value: email },
      zipCode: { value: zipCode },
      phone: { value: phone }
    } = this.state;
    const {
      locale
    } = this.props;

    insertContactInfo({
      name,
      lastName,
      email,
      zipCode,
      phone
    });

    this.setState({
      isLoading: true
    });

    const shuttleData = JSON.parse(window.localStorage.getItem('CBX_Quick_Data'));
    const shuttleTripData = JSON.parse(window.localStorage.getItem('shuttle_data'));
    const shuttleInfo = JSON.parse(window.localStorage.getItem('shuttle'));
    const shuttleDetails = JSON.parse(window.localStorage.getItem('CBX_Shuttle_Details')).data;
    const shuttleTripDataRound = JSON.parse(window.localStorage.getItem('shuttle_data_round'));

    const isBaggageEnabled = shuttleDetails && shuttleDetails.baggageMapEnabled;
    const isSeatsEnabled = shuttleDetails && shuttleDetails.seatsMapEnabled;
    let baggageMap = {};
    let extraBaggageCharge = 0.0;
    if (isBaggageEnabled) {
      baggageMap = shuttleDetails.baggageMap[0];
      extraBaggageCharge = parseFloat(baggageMap.extraFee);
    }

    let shuttleSeats = JSON.parse(window.localStorage.getItem('shuttle_seats'));
    let shuttleSeatsRound = JSON.parse(window.localStorage.getItem('shuttle_seats_round'));

    if (!shuttleSeats) shuttleSeats = [];
    const passengerinfoFormat = [];
    const passengerInfo = shuttleInfo.shuttles;
    let totalExtraBaggages = 0;
    let totalExtraBaggagesCharges = 0.0;
    for (let i in passengerInfo) {
      let item = passengerInfo[i];
      const extraBaggages = Math.max(0, item.baggageShuttle - baggageMap.maxQtyWithoutCharge);
      const baggagesCharge = extraBaggages * extraBaggageCharge;
      passengerinfoFormat.push({
        "firstName": item.nameShuttle,
        "lastName": item.lastNameShuttle,
        "email": item.emailShuttle,
        "baggageQ": item.baggageShuttle,
        extraBaggages,
        baggagesCharge,
      });
      totalExtraBaggages += extraBaggages;
      totalExtraBaggagesCharges += baggagesCharge;
    };

    if (!shuttleData) {
      window.location.href = goToAddOns ? `/${locale}/addOns` : `/${locale}/cart`
    }
    const passengersQ = parseInt(shuttleTripData.data.passengersQ, 10);
    const passengersQRound = shuttleData.shuttleTravelType === "round" && parseInt(shuttleTripDataRound.data.passengersQ, 10);
    const groupID = uuid.v4();
    const cartItems = [{
      type: "shuttle",
      originId: shuttleTripData.data.originId,
      destinationId: shuttleTripData.data.destinationId,
      originText: capitalize(shuttleTripData.data.originText),
      destinationText: capitalize(shuttleTripData.data.destinationText),
      rideId: shuttleTripData.data.rideId,
      passengersQ: passengersQ,
      hasSeats: isSeatsEnabled,
      hasBaggage: isBaggageEnabled,
      passengersS: shuttleSeats,
      passengersInfo: passengerinfoFormat.slice(0, passengersQ),
      typeId: shuttleData.shuttleTravelType === "round" ? 2 : 1,
      departureDate: shuttleData.shuttleStartDate,
      price: shuttleTripData.data.price,
      arrivalDateTime: shuttleTripData.data.arrivalDateTime,
      departureDateTime: shuttleTripData.data.departureDateTime,
      provider: shuttleTripData.data.provider,
      totalExtraBaggages,
      totalExtraBaggagesCharges,
      groupId: groupID,
    }];
    if (shuttleData.shuttleTravelType === "round" && shuttleTripDataRound) {
      cartItems.push({
        type: "shuttle",
        originId: shuttleTripDataRound.data.originId,
        destinationId: shuttleTripDataRound.data.destinationId,
        originText: capitalize(shuttleTripDataRound.data.originText),
        destinationText: capitalize(shuttleTripDataRound.data.destinationText),
        rideId: shuttleTripDataRound.data.rideId,
        passengersQ: passengersQRound,
        hasSeats: isSeatsEnabled,
        hasBaggage: isBaggageEnabled,
        passengersS: shuttleSeatsRound,
        typeId: shuttleData.shuttleTravelType === "round" ? 2 : 1,
        passengersInfo: passengerinfoFormat.slice(0, passengersQ),
        departureDate: shuttleData.shuttleEndDate,
        price: shuttleTripDataRound.data.price,
        arrivalDateTime: shuttleTripDataRound.data.arrivalDateTime,
        departureDateTime: shuttleTripDataRound.data.departureDateTime,
        provider: shuttleTripDataRound.data.provider,
        totalExtraBaggages,
        totalExtraBaggagesCharges,
        groupId: groupID,
      });
    }
    cartItems.forEach((cartItem) => {
      cartItem.item_name = `Shuttle ${cartItem.originText} to ${cartItem.destinationText}`;
      cartItem.item_id = `Shuttle ${cartItem.provider}`;
      cartItem.price = cartItem.price;
      cartItem.quantity = cartItem.passengersQ;
      insertCartItem(cartItem);
      window.dataLayer.push({
        event: 'addToCart',
        ecommerce: {
          currency: 'USD',
          value: cartItem.price * cartItem.quantity,
          items: [
            {
              item_name: cartItem.item_name,
              item_id: cartItem.item_id,
              price: cartItem.price,
              quantity: cartItem.quantity
            }
          ]
        }
      });
    });

    removeQuickData();

    if (goToAddOns) {
      window.location.href = `/${locale}/addOns`;
    } else {
      window.location.href = `/${locale}/cart`;
    }

    this.setState({
      isLoading: false
    });
    window.localStorage.removeItem('CBX_Quick_Data');
    window.localStorage.removeItem('shuttle_data');
    window.localStorage.removeItem('shuttle_seats');
    window.localStorage.removeItem('shuttle_data_round');
    window.localStorage.removeItem('shuttle_seats_round');
    window.localStorage.removeItem('CBX_Shuttle_Routes');
    window.localStorage.removeItem('CBX_Shuttle_Return_Routes');
  }
  /**
   * Calls the api for payment validatiion
   */
  doShopping(props) {
    const {
      creditCard: { value: creditCard },
      creditCardHolder: { value: creditCardHolder },
      ccv: { value: ccv },
      creditCardZipCode: { value: creditCardZipCode },
      expirationDate: { value: expirationDateState },
      acceptMailInfo: { checked: newsletter },
      promoCodeData: promoCode,
      token,
      travelPurpose,
      acceptDonate,
      storeCard,
      cart,
      hasPayment,
    } = this.state;
    const {
      locale,
      translations
    } = this.props;
    const {
      name,
      lastName,
      email,
      zipCode,
      phone
    } = getContactInformation();
    if (props === 'modal') {
      this.setState({ differentDates: false })
    }
    if (!creditCardHolder) {
      alert(`${translations.creditCardHolder.label} ${locale === 'es' ? 'es requerido.' : 'is required.'}`)
      return;
    }
    const products = cart.map((prod) => {
      if (prod.type === 'parking') {
        const parkingProd = { ...prod };
        parkingProd.location = parkingProd.lot;
        delete parkingProd.lot;
        return parkingProd;
      }

      if (prod.type === 'shuttle') {
        const shuttleProd = { ...prod };
        return shuttleProd;
      }

      if (prod.type === 'wheels') {
        const wheelsProd = { ...prod };
        return wheelsProd;
      }
      if (prod.donation) return { ...prod };

      let {
        travelType,
        ticketType
      } = prod;
      if (!travelType) {
        if (prod.IdDestiny === 3) {
          travelType = 'roundtrip';
        } else {
          travelType = 'oneway';
        }
      }
      if (!ticketType) {
        if (prod.NuPersonQuant >= 4) {
          ticketType = 'family';
        } else {
          ticketType = 'single';
        }
      }
      prod.DtStart = null;
      prod.DtEnd = null;
      return {
        ...prod,
        travelType: prod.travelType,
        ticketType: prod.ticketType === 3 ? 'family' : 'single',
        travelDestination: `${prod.origin.abbreviatedPlace.toUpperCase()} > ${prod.destination.abbreviatedPlace.toUpperCase()}`,
        passengers: parseInt(prod.NuPersonQuant, 10)
      };
    });

    let amount = 0;
    products.forEach((product) => {
      if (product.type === "shuttle") {
        product.Amount = product.price;
        product.NuProdQuant = product.passengersQ;
        if (product.totalExtraBaggages) {
          amount += product.totalExtraBaggagesCharges;
        }
      }
      amount += product.Amount * product.NuProdQuant;

      if (product.Discount && (this.state.hasValidPromo || this.state.isBundled)) {
        amount -= product.Discount;
        product.Amount = product.DiscountAmount;
      }
      product.Amount = parseFloat(product.Amount.toFixed(2));
    });
    const { uid } = this.props;
    const expirationDate = expirationDateState.replace(' / ', '');

    const today = new Date();
    const dateYear = today.getFullYear().toString(10);
    const dateMonth = (today.getMonth() + 1).toString(10).length > 1 ? today.getMonth() + 1 : `0${today.getMonth() + 1}`;
    const dateDay = today.getDate().toString(10);
    let travelType = 'roundtrip';
    let ticketType = '2';
    let flightDate = `${dateYear}-${dateMonth}-${dateDay}`;
    let returnDate = `${dateYear}-${dateMonth}-${dateDay}`;
    let passengers = '1';

    const tickets = products.filter((product) => { return !(["parking", "shuttle", "wheels"].includes(product.type)) });

    if (tickets.length > 0) {
      travelType = tickets.filter((ticket) => { return ticket.type === 'ticket'; })[0].travelType;
      ticketType = tickets.filter((ticket) => { return ticket.type === 'ticket'; })[0].ticketType;
      flightDate = tickets.filter((ticket) => { return ticket.type === 'ticket'; })[0].flightDate;
      returnDate = tickets.filter((ticket) => { return ticket.type === 'ticket'; })[0].returnDate;
      passengers = tickets.filter((ticket) => { return ticket.type === 'ticket'; })[0].passengers;
    }

    const ticketPrice = `$${amount.toFixed(2)} USD`;
    this.setState({
      isProcessing: true,
      disableButton: true,
      hasError: false,
      errorMessage: ''
    });
    window.scrollTo(0, 0);
    trackCustomEvent({
      category: 'Purchase intent',
      action: 'Buy button',
      label: 'Purchase Buy button clicked'
    });
    let tokenInfo = false;
    if (this.state.currentCard && this.state.currentCard !== 'manual') {
      tokenInfo = { token: this.state.token, expMonth: this.state.expirationDate.value.split('/')[0], expYear: this.state.expirationDate.value.split('/')[1] };
    }
    axios
      .post(
        process.env.GATSBY_API_PAYMENT_URL,
        {
          PaymentKey: props.paymentKeyData.paymentKeys.pop(),
          payment: this.state.currentCard ? { CardIssuer: this.state.creditCard.brand, MaskedCardNumber: `${this.state.creditCard.value}` } : props.paymentKeyData.attributes,
          paymentType: props.paymentType,
          tokenInfo,
          name,
          lastName,
          email,
          zipCode,
          phone,
          creditCard,
          creditCardHolder,
          ccv,
          creditCardZipCode,
          expirationDate,
          amount: parseFloat(amount.toFixed(2)),
          newsletter,
          products,
          promoCode,
          passengers,
          travelType,
          ticketType,
          // travelDestination,
          ticketPrice,
          uid,
          token,
          ticketDate: new Date(`${flightDate}T10:00:00.000-08:00`),
          returnDate: new Date(`${returnDate}T10:00:00.000-08:00`),
          travelPurpose,
          version: 'v4',
          storeCard: hasPayment && storeCard.checked
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${props.sessionKey}`
          }
        }
      )
      .then(({ data }) => {
        window.scrollTo(0, 0);
        if (!data.error) {
          if (data.uuid) {
            clearData();
            this.connect(data.uuid);
          }
        } else {
          window.scrollTo(0, 0);
          const { errorCode = 'errorMessage' } = data || {};
          const errorMessage = getKey(translations, errorCode, translations.errorMessage);
          this.setState(
            {
              isProcessing: false,
              hasError: true,
              disableButton: false,
              errorMessage,
              ...this.resetPaymentInformation
            },
            () => this.formPercentage()
          );
          if (errorMessage) {
            alert(errorMessage);
          } else {
            alert("Ocurrió un error procesando la compra. Por favor inténtelo de nuevo más tarde.");
          }
          trackCustomEvent({
            category: 'Purchase intent',
            action: 'Purchase Error / Not successful',
            label: 'Purchase Error / Not successful'
          });
        }
      })
      .catch((error) => {
        window.scrollTo(0, 0);
        console.error('error', error);
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
          const errorMessage = error.response.data[`error_${locale}`] || translations.errorCreditCard;
          if (errorMessage) {
            alert(errorMessage);
          } else {
            alert(translations.errorCreditCard)
          }
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          alert(translations.errorConnection)
        } else {
          // Something happened in setting up the request that triggered an Error
          alert(translations.errorConnection)
        }
        trackCustomEvent({
          category: 'Purchase intent',
          action: 'Purchase Error / Not successful',
          label: 'Purchase Error / Not successful'
        });
        this.setState(
          {
            isProcessing: false,
            hasError: true,
            disableButton: false,
            errorMessage: translations.errorConnection,
            ...this.resetPaymentInformation
          },
          () => this.formPercentage()
        );
      });
  }

  emailShuttleCheck(emailShuttle) {
    return emailShuttle.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
  }

  /**
   * Returns all passengers with completed data from a shuttleInfo.
   * if includeBaggage is set then data will check that baggage is selected.
   * @param {object} shuttleInfo
   * @param {boolean} includeBaggage
   * @returns {array}
   */
  validShuttlePassengers(shuttleInfo, includeBaggage) {
    return shuttleInfo.shuttles.filter((shuttle) => {
      if (!shuttle) return false;
      const namesRegex = /^(?:[A-Za-zÀ-ÖØ-öø-ÿ]+\s*)+$/;
      let isCorrectEmail = shuttle.emailShuttle && this.emailShuttleCheck(shuttle.emailShuttle);
      let isCorrectName = shuttle.nameShuttle && shuttle.nameShuttle.match(namesRegex);
      let isCorrectLastName = shuttle.lastNameShuttle && shuttle.lastNameShuttle.match(namesRegex);
      let isCorrectBaggage = !includeBaggage || shuttle && shuttle.baggageShuttle >= 0;
      return isCorrectEmail && isCorrectName && isCorrectLastName && isCorrectBaggage;
    });
  }

  /**
   * Determines if data held on shuttleInfo and shuttleTrip is valid.
   * Data is valid if shuttle passenger data in shuttleInfo is valid for all
   * passengers and if there are the same amount of shuttleInfo than passengers selected.
   * @param {object} shuttleInfo
   * @param {object} shuttleTrip
   * @returns {boolean}
   */
  isValidShuttleInfo(shuttleInfo, shuttleTrip) {
    const shuttlePassengers = parseInt(shuttleTrip.passengersQ, 10);
    if (shuttleInfo.shuttles.length < shuttlePassengers) return false;
    // Nos aseguramos de comparar solo los primeros shuttlePassengers del array.
    const shuttleInfoComparable = {
      shuttles: shuttleInfo.shuttles.slice(0, shuttlePassengers)
    };
    const completePassengers = this.validShuttlePassengers(shuttleInfoComparable, shuttleTrip.provider === 'damaris');
    return (completePassengers.length === shuttlePassengers);
  }

  /**
   * Render method
   * @returns {JSX}
   */
  render() {
    const {
      props: {
        ticketType,
        travelType,
        translations,
        travelPurposes,
        locale,
        page,
        url,
        position
      },
      state: {
        activeTicketType,
        isBuyingActive,
        isBuying,
        formPercentage,
        ticketNumber,
        price,
        origin,
        destination,
        quantityPersons,
        quantityBaggage,
        activeTravelType,
        isProcessing,
        isLoading,
        isSucess,
        disableButton,
        hasError,
        errorMessage,
        isFamily,
        isRoundTrip,
        isSavingMoney,
        hasValidPromo,
        savedCards,
        isToggleFocused,
        company,
        packages,
        disclaimer,
        popupDisclaimer,
        donationDisclaimer,
        showDownloadApp,
        flightDate,
        returnDate,
        minDate,
        maxDate,
        travelPurpose,
        shuttleDestination,
        shuttleOrigin,
        shuttleTravel,
        showModal,
        showModalDonate,
        showSurvey,
        cart,
        boughtTicket,
        shortId,
        showAddTicket,
        selectorItem,
        enable,
        currentStep,
        acceptTerms,
        lot,
        startDate,
        endDate,
        startTime,
        endTime,
        brand,
        model,
        year,
        color,
        vehicleState,
        plate,
        showStartDateCalendar,
        showEndDateCalendar,
        counterParking,
        vehicles,
        shuttles,
        enableSendToCart,
        dataLot,
        callParkingApi,
        isCallingParkingApi,
        differentDates,
        sportsNotAvailable,
        acceptDonate,
        assistPassName,
        assistPassLastName,
        assistPassGender,
        assistPassPhone,
        assistPassAge,
        assistPassDate,
        assistPassFightNumber,
        assistPassAirline,
        assistPassOrigin,
        assistPassDestination,
        assistPassTutorName,
        assistPassTutorLastName,
        assistPassTutorPhone,
        assistPassTutorEmail,
        assistPassTempId,
        shuttleNotAvailable,
        baggageShuttle,
        counterShuttle,
        isSelectedTrip,
        selectedSeat,
        showModalSelectedSeats,
        showModalMissingSeats,
        emailShuttleStatus,
        enableSendToCartShuttle,
        enableSendToCartShuttleABC,
        nontIncludeShow,
        showScales,
        detailSelected,
        shuttleTravelType,
        shuttleStartDate,
        shuttleEndDate,
        shuttlePassengers,
        isCallingShuttleApi,
        callShuttleApi,
        selectedCounter,
        shuttleDestinations,
        shuttleOrigins,
        modalMarginTop,
        selectedSeatRound,
        assistPassNationality,
        name,
        selectedBundle,
        currentFlow
        // selectionRange
      }
    } = this;
    console.log("Render cart", cart);
    let detailsData = {};
    if (typeof window != "undefined") {
      if (page === `shuttleSelectTrip`) {
        detailsData = JSON.parse(window.localStorage.getItem('CBX_Shuttle_Routes'));
      }
      if (page === `shuttleSelectRoundTrip`) {
        detailsData = JSON.parse(window.localStorage.getItem('CBX_Shuttle_Return_Routes'));
      }
    }

    const ticketLabel = locale == "es" ? "Boletos" : "Tickets";
    /**
     * handles changes on start date input
     * @param {Object} evt - date change event
     */
    const startDateHandler = (evt) => {
      if (evt.target.value < '2022-03-20') return;
      let newStateObj = {
        startDate: evt.target.value
      };

      if (evt.target.value >= endDate) {
        newStateObj.endDate = this.initialState.endDate;
        newStateObj.endTime = this.initialState.endTime;
      }
      this.setState(newStateObj);
    };

    /**
     * handles changes on start time select
     * @param {Object} evt - date change event
     */
    const startTimeHandler = (evt) => {
      let newStateObj = {
        startTime: evt.target.value
      };
      if (`${startDate}T${evt.target.value}` >= `${endDate}T${endTime}`) {
        newStateObj.endDate = this.initialState.endDate;
        newStateObj.endTime = this.initialState.endTime;
      }
      this.setState(newStateObj);
    };

    /**
     * handles changes on end date input
     * @param {Object} evt - date change event
     */
    const endDateHandler = (evt) => {
      if (evt.target.value < '2022-03-20') return;
      this.setState({
        endDate: evt.target.value,
        endTime: this.initialState.endTime
      });
    };

    /**
     * handles changes on end time select
     * @param {Object} evt - date change event
     */
    const endTimeHanlder = (evt) => {
      this.setState({
        endTime: evt.target.value
      });
    };

    const onVehicleUpdate = (i, field, val) => {
      let v = null;
      let copyRows = [...vehicles];
      const parkingInfo = JSON.parse(window.localStorage.getItem('parking'));
      const savedVehicles = parkingInfo.vehicles;
      if (savedVehicles) {
        copyRows = [...savedVehicles];
      }
      if (typeof copyRows[i] !== 'object') {
        copyRows[i] = {};
        v = copyRows[i];
      }
      copyRows[i][field] = val;
      this.setState({ vehicles: copyRows });
      parkingInfo.vehicles = copyRows;
      window.localStorage.setItem('parking', JSON.stringify(parkingInfo));
      v = typeof vehicles[i] !== 'undefined'
        ? vehicles[i]
        : {
          brand: '', model: '', year: '', color: '', plate: '', state: ''
        };

      if (v) {
        if (v.brand.length > 0 && v.model.length > 0 &&
          v.color.length > 0 && v.state.length > 0 && v.year.length > 0) {
          this.setState({ enableSendToCart: true });
        }
      }
    };
    const onShuttleUpdate = (i, field, val) => {
      let shuttleRoutesData = [];
      shuttleRoutesData = JSON.parse(window.localStorage.getItem('shuttle_data')).data;
      this.setState({ emailShuttleStatus: false });
      this.setState({ enableSendToCartShuttle: false });
      let v = null;
      let copyRows = [...shuttles];
      let shuttleInfo = JSON.parse(window.localStorage.getItem('shuttle'));
      if (shuttleInfo != undefined) {
        const savedShuttles = shuttleInfo.shuttles;
        if (savedShuttles) {
          copyRows = [...savedShuttles];
        }
      }
      if (typeof copyRows[i] !== 'object' || copyRows[i] === null) {
        copyRows[i] = {};
        v = copyRows[i];
      }
      copyRows[i][field] = val;
      this.setState({ shuttles: copyRows });
      shuttleInfo = { shuttles: copyRows }
      window.localStorage.setItem('shuttle', JSON.stringify(shuttleInfo));

      const isValidInfo = this.isValidShuttleInfo(shuttleInfo, shuttleRoutesData);
      this.setState({
        enableSendToCartShuttle: isValidInfo,
        enableSendToCartShuttleABC: isValidInfo
      });

    };


    const changeData = (field, val) => {
      this.setState({ [field]: val });
    }

    const openParking = () => {
      const {
        startDate,
        endDate,
        startTime,
        endTime,
        lot
      } = this.state;
      const start = moment(new Date(`${startDate} ${startTime}`)).format('llll');
      const end = moment(new Date(`${endDate} ${endTime}`)).format('llll');
      let url = `https://go.lazparking.com/hello/#buynow?l=35138&t=r&wt=tmd&isocode=EN&wk=c863ae599da24391b2ca5468dc4df0f9&start=${start}&end=${end}`;
      if (lot === 'lot3') {
        url = `https://go.lazparking.com/hello/#buynow?l=112957&t=r&wt=tmd&isocode=EN&wk=f1c1457ef0a74dcab931e6197c79b80a&start=${start}&end=${end}`;
      } else {
        url = `https://go.lazparking.com/hello/#buynow?l=35138&t=r&wt=tmd&isocode=EN&wk=c863ae599da24391b2ca5468dc4df0f9&start=${start}&end=${end}`;
      }
      // eslint-disable-next-line no-undef
      // window.open(url, '_blank');
      window.location.href = `/${locale}/lot`;
    }

    // Qty Label wasn't properly updated when doing a language toggle
    const quantityPersonsLabel = isFamily ? translations.people : translations.quantity;
    let promoOffset = 30;
    const validProductPackages = packages.filter((productPack) => {
      if (isRoundTrip) {
        return productPack.IdCompany === company && productPack.IdCrossingType === 3;
      }
      return productPack.IdCompany === company && productPack.IdCrossingType !== 3;
    });
    const validProds = validProductPackages.map((productPack) => {
      return productPack.IdProdClassification;
    });
    const ticketOptions = ticketType.options.filter((option) => {
      return option.company === company && validProds.includes(option.value);
    });
    promoOffset = savedCards ? promoOffset + 75 : promoOffset;
    let cartTotal = 0.0;
    let totalDiscount = 0.0;
    if (cart) {
      cart.forEach((product) => {
        if (product.type === "shuttle") {
          cartTotal += product.passengersQ * product.price;
          if (product.totalExtraBaggages) {
            cartTotal += product.totalExtraBaggagesCharges;
          }
        } else {
          cartTotal += product.Amount * product.NuProdQuant;
        }
        if (product.Discount) {
          cartTotal -= product.Discount;
        }
      });
    }

    if (hasValidPromo || this.state.isBundled) {
      cart.forEach((product) => {
        if (!product.Discount) return;
        totalDiscount += product.Discount;
      });
    }
    const changeQuickItemParking = (e) => {
      this.setState({ selectorItem: "Parking" })
    }

    const changeQuickTicket = (e) => {
      this.setState({ selectorItem: "Ticket" })
    }

    const changeQuickItemShuttle = (e) => {
      this.setState({ selectorItem: "Shuttle" })
    }

    const changeQuickItemBundles = (e) => {
      this.setState({ selectorItem: "Bundles" })
    }

    const changeQuickItemWheels = (e) => {
      this.setState({ selectorItem: "Wheels" })
    }

    const continueShopping = () => {
      window.location.href = `/${locale}/configTicket`;
    }

    const continueParking = () => {
      window.localStorage.removeItem('parking');
      window.location.href = `/${locale}/lot`;
    }

    const continueCart = () => {
      window.location.href = `/${locale}/cart`;
    }

    const openAddOns = () => {
      window.location.href = `/${locale}/addOns`;
    }

    const openLot = () => {
      window.location.href = `/${locale}/lot`;
    }

    const openHome = () => {
      window.location.href = `/${locale}/`;
    }

    const openConfigTicket = () => {
      window.location.href = `/${locale}/configTicket`;
    }

    const openPersonalInfo = () => {
      window.location.href = `/${locale}/personalInfo`;
    }

    const getSeats = (rideId, page) => {
      getShuttleDetails(rideId, page)
    }

    const pushSeats = (seatsKey, seats) => {
      let currentSeats = JSON.parse(window.localStorage.getItem(seatsKey));
      if (!currentSeats || currentSeats.length == 0 || !Array.isArray(currentSeats[0])) {
        currentSeats = [];
        seats.forEach(() => {
          currentSeats.push([])
        });
      }
      console.log(currentSeats);
      seats.forEach((seat, idx) => {
        if (currentSeats[idx].length > seat.segment) {
          currentSeats[idx][seat.segment] = seat;
        } else {
          currentSeats[idx].push(seat);
        }
      });
      return currentSeats;
    }

    const openShuttleForm = () => {
      let newSeats;
      let segments = [];
      if (page === 'shuttleSelectSeats') {
        newSeats = pushSeats('shuttle_seats', this.state.selectedSeat);
        const data = JSON.parse(window.localStorage.getItem('CBX_Shuttle_Details')).data.someDetails;
        if (data.trip && data.trip.segments) {
          segments = data.trip.segments;
        }
        window.localStorage.setItem('shuttle_seats', JSON.stringify(pushSeats('shuttle_seats', this.state.selectedSeat)));
      }
      if (page === 'shuttleSelectSeatsReturn') {
        newSeats = pushSeats('shuttle_seats_round', this.state.selectedSeatRound);
        const data = JSON.parse(window.localStorage.getItem('CBX_Shuttle_Return_Details')).data.someDetails;
        if (data.trip && data.trip.segments) {
          segments = data.trip.segments;
        }
        window.localStorage.setItem('shuttle_seats_round', JSON.stringify(pushSeats('shuttle_seats_round', this.state.selectedSeatRound)));
      }
      const segmentsAdded = newSeats[0].length;
      console.log("SEgmentsAdded", segmentsAdded);
      console.log("seats %j", newSeats);
      console.log("Segments: %j", segments);
      if (segmentsAdded < segments.length) {
        return window.location.href = `/${locale}/${page}?segment=${segmentsAdded}`;
      }
      window.location.href = `/${locale}/passengerInfoShuttle`;
    }

    const openShuttleSelectTrip = () => {
      window.location.href = `/${locale}/shuttleSelectTrip`;
    }

    const openShuttleSelectSeats = () => {
      window.location.href = `/${locale}/shuttleSelectSeats`
    }

    const goToPersonalInfo = () => {
      if (!['shuttleSelectSeats', 'shuttleSelectSeatsReturn'].includes(page)) {
        return window.location.href = `/${locale}/personalInfo`;
      }
      let newSeats;
      let segments;
      console.log(page);
      if (page === 'shuttleSelectSeats') {
        newSeats = pushSeats('shuttle_seats', this.state.selectedSeat);
        segments = JSON.parse(window.localStorage.getItem('CBX_Shuttle_Details')).data.someDetails.trip.segments;
        window.localStorage.setItem('shuttle_seats', JSON.stringify(pushSeats('shuttle_seats', this.state.selectedSeat)));
      }
      if (page === 'shuttleSelectSeatsReturn') {
        newSeats = pushSeats('shuttle_seats_round', this.state.selectedSeatRound);
        segments = JSON.parse(window.localStorage.getItem('CBX_Shuttle_Return_Details')).data.someDetails.trip.segments;
        window.localStorage.setItem('shuttle_seats_round', JSON.stringify(pushSeats('shuttle_seats_round', this.state.selectedSeatRound)));
      }
      const segmentsAdded = newSeats[0].length;
      console.log("SEgmentsAdded", segmentsAdded);
      console.log("seats %j", newSeats);
      console.log("Segments: %j", segments);
      if (segmentsAdded < segments.length) {
        return window.location.href = `/${locale}/${page}?segment=${segmentsAdded}`;
      }

      if (!this.state.name.value) {
        const shuttlesItem = window.localStorage.getItem('shuttle');
        if (shuttlesItem) {
          const shuttles = JSON.parse(shuttlesItem).shuttles[0];
          insertContactInfo({
            name: shuttles.nameShuttle,
            lastName: shuttles.lastNameShuttle,
            email: shuttles.emailShuttle
          })
        }
      }
      window.location.href = `/${locale}/personalInfo`;
    };

    const showCalendar = (props) => {
      this.setState({ showEndDateCalendar: false })
      this.setState({ showStartDateCalendar: !showStartDateCalendar })
    }

    const showRangeCalendar = (props) => {
      this.setState({ showStartDateCalendar: false })
      this.setState({ showEndDateCalendar: !showEndDateCalendar })
    }

    const selectionRange = {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    }

    const handleSelect = (ranges) => {
      this.setState({
        returnDate: ranges.selection.endDate,
      })
      this.setState({ showEndDateCalendar: false })
    }

    const handleSelectStartDate = (ranges) => {
      this.setState({
        flightDate: ranges,
      })
      this.setState({ showStartDateCalendar: false })
    }

    const initializeCounter = (n) => {
      this.setState({ counterParking: n });
    };

    const increment = () => {
      const MAX_PARKING_PER_CHECKOUT = 5;
      const parkingInfo = JSON.parse(window.localStorage.getItem('parking'));
      const MAX_SPOTS = parkingInfo.data.spots;
      if (counterParking >= Math.min(MAX_PARKING_PER_CHECKOUT, MAX_SPOTS)) {
        return alert("No se pueden agregar más espacios");
      }
      this.setState({ counterParking: counterParking + 1 });

    };

    const decrement = () => {
      if (counterParking > 1) {
        this.setState({ counterParking: counterParking - 1 });
        const parkingInfo = JSON.parse(window.localStorage.getItem('parking'));
        const carsCopy = [...parkingInfo.vehicles];
        carsCopy.splice(carsCopy.length < counterParking ? carsCopy.length : carsCopy.length - 1);
        parkingInfo.vehicles = carsCopy;
        window.localStorage.setItem('parking', JSON.stringify(parkingInfo));
      }
    };

    const incrementShuttle = () => {
      this.setState({ shuttlePassengers: parseInt(shuttlePassengers, 10) + 1 });
    };

    const decrementShuttle = () => {
      if (shuttlePassengers > 1) {
        this.setState({ shuttlePassengers: parseInt(shuttlePassengers, 10) - 1 });
      }
    };

    const verifyAvailability = (data, redirect) => {
      const lotPromises = [];
      const lotsWithAvailability = [];
      data.data.forEach((lotData) => {
        lotPromises.push(instance.post(
          process.env.GATSBY_API_POST_PARKING_PRICE,
          {
            from_time: new Date(`${startDate}T${startTime}:00.000+00:00`),
            to_time: new Date(`${endDate}T${endTime}:00.000+00:00`),
            quantity_spots: 1,
            location_id: lotData.id
          }, {
          headers: {
            'Content-Type': 'application/json'
          }
        }
        ));
      });

      Promise.all(lotPromises)
        .then((lotsDetails) => {
          lotsDetails.forEach((lotDetails) => {
            if (lotDetails.data.data.spots > 0) {
              lotsWithAvailability.push(lotDetails.data.data);
            }
          });
          if (redirect && lotsWithAvailability.length > 0) {
            window.location.href = redirect;
          } else if (lotsWithAvailability.length === 0) { this.setState({ sportsNotAvailable: true }); }
          this.setState({ isCallingParkingApi: false });
        })
        .catch((error) => {
          this.setState({ isCallingParkingApi: false });
          alert(locale === 'es'
            ? 'Ocurrió un error obteniendo disponibilidad. Por favor inténtelo de nuevo más tarde.'
            : 'There was an error getting available spots. Try again later');
          return error;
        });
    };

    const getLots = (redirect = `/${locale}/lot`) => {
      this.setState({ isCallingParkingApi: true });
      instance.get(process.env.GATSBY_API_GET_PARKING_LOTS)
        .then(({ data }) => {
          window.localStorage.setItem('CBX_Parking_Lots', JSON.stringify(data.data));
          if (startDate && endDate && startTime && endTime) {
            verifyAvailability(data, redirect);
          } else {
            this.setState({ isCallingParkingApi: false });
            window.location.href = redirect;
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({ isCallingParkingApi: false });
          alert(locale === 'es'
            ? 'Ocurrió un error obteniendo lotes. Por favor inténtelo de nuevo más tarde.'
            : 'There was an error fetching parking lots. Try again later');
          return error;
        });
    };


    //parkingPrice

    const getParkingPrice = (locationID) => {

      this.setState({ isCallingParkingApi: true });
      instance.post(
        process.env.GATSBY_API_POST_PARKING_PRICE,
        {
          from_time: new Date(`${startDate}T${startTime}:00.000+00:00`),
          to_time: new Date(`${endDate}T${endTime}:00.000+00:00`),
          quantity_spots: 1,
          location_id: locationID
        }, {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      )
        .then(({ data }) => {
          const savedParkingInfo = window.localStorage.getItem('parking');
          const curData = {
            ...data.data,
            from: `${startDate}T${startTime}:00`,
            to: `${endDate}T${endTime}:00`
          };
          if (!savedParkingInfo) {
            window.localStorage.setItem('parking', JSON.stringify({
              ...data,
              data: curData,
            }));
          } else {
            const parkingInfo = JSON.parse(savedParkingInfo);
            const newParkingInfo = {
              data: curData,
              vehicles: parkingInfo.vehicles ? parkingInfo.vehicles : []
            };

            window.localStorage.setItem('parking', JSON.stringify(newParkingInfo));
          }
          this.setState({ callParkingApi: false, isCallingParkingApi: false });
        })
        .catch((error) => {
          console.error('error', error);
          if (callParkingApi) {
            this.setState({ callParkingApi: false, isCallingParkingApi: false });
          }
          //clearData();
        });
    };

    const hideParkingAddOn = /*((cart && cart.length === 1) && cart[0].type === 'parking') || */ false;
    const hideTicketAddOn = /*((cart && cart.length === 1) && cart[0].type === 'ticket') || */ false;

    let windowWidth = 768;
    let isMobile = windowWidth < 768;

    if (typeof window !== 'undefined') {
      windowWidth = window.innerWidth;
      isMobile = windowWidth < 768;
    }

    const getShuttleRoutes = () => {
      this.setState({ isCallingShuttleApi: true });
      window.localStorage.removeItem('shuttle_data');
      let prevSingleTrip = window.localStorage.getItem('CBX_Shuttle_Routes');
      let prevRoundTrip = window.localStorage.getItem('CBX_Shuttle_Return_Routes');

      if (prevSingleTrip) {
        window.localStorage.removeItem('CBX_Shuttle_Routes');
      }

      if (prevRoundTrip) {
        window.localStorage.removeItem('CBX_Shuttle_Return_Routes');
      }

      let destinationId = shuttleDestinations.data[shuttleDestination];
      let originId = shuttleOrigins.data[shuttleOrigin];
      let shuttleCalls = [];

      shuttleCalls.push(
        instance.get(process.env.GATSBY_GET_SHUTTLE_ROUTES,
          {
            params: {
              originId: originId,
              destinationId: destinationId,
              departureDate: shuttleStartDate,
              typeId: 1,
              passengersQ: shuttlePassengers
            }
          })
      );

      if (shuttleTravelType === "round") {
        shuttleCalls.push(
          instance.get(process.env.GATSBY_GET_SHUTTLE_ROUTES,
            {
              params: {
                originId: destinationId,
                destinationId: originId,
                departureDate: shuttleEndDate,
                typeId: 1,
                passengersQ: shuttlePassengers
              }
            })
        );
      } else {
        shuttleCalls.push(Promise.resolve({ data: null }));
      }
      const parseRouteData = (data, shuttleOrigin, shuttleDestination) => {
        const routes = data.data;

        const routesData = routes.map((route) => {
          if (!route.arrivalDateTime) route.arrivalDateTime = route.arrivingDateTime;
          if (route.arrivalDateTime.includes('+00:00')) route.arrivalDateTime = route.arrivalDateTime.split('+')[0];
          if (route.departureDateTime.includes('+00:00')) route.departureDateTime = route.departureDateTime.split('+')[0];
          route.originText = shuttleOrigin;
          route.destinationText = shuttleDestination

          this.setState({ callShuttleApi: false, isCallingShuttleApi: false });
          setCleanShuttleRoutes(0);
          return route;
        });

        return routesData;
      }

      Promise.all(shuttleCalls).then(([{ data }, { data: returnData }]) => {

        let shuttleRoutes = parseRouteData(data, shuttleOrigin, shuttleDestination);
        window.localStorage.setItem('CBX_Shuttle_Routes', JSON.stringify({ data: shuttleRoutes }));

        if (returnData) {
          let shuttleReturnRoutes = parseRouteData(returnData, shuttleDestination, shuttleOrigin);
          window.localStorage.setItem('CBX_Shuttle_Return_Routes', JSON.stringify({ data: shuttleReturnRoutes }));
        }
        this.setState({ callShuttleApi: false, isCallingShuttleApi: false });

        window.location.href = `/${locale}/shuttleSelectTrip`;
      })
        .catch((error) => {
          window.localStorage.setItem('CBX_Shuttle_Routes', JSON.stringify({ data: '' }));
          window.localStorage.setItem('CBX_Shuttle_Return_Routes', JSON.stringify({ data: '' }));

          this.setState({ callShuttleApi: false, isCallingShuttleApi: false, shuttleNotAvailable: true });

          return error;
        });
    };

    const getShuttleDetails = (rideId, page) => {
      this.setState({ isCallingShuttleApi: true });
      const {
        name: { value: name },
        lastName: { value: lastName },
        email: { value: email },
        zipCode: { value: zipCode },
        phone: { value: phone },
        isParkingFlow
      } = this.state;
      const {
        locale
      } = this.props;

      let destinationId = shuttleDestinations.data[shuttleDestination];
      let originId = shuttleOrigins.data[shuttleOrigin];

      insertContactInfo({
        name,
        lastName,
        email,
        zipCode,
        phone
      });
      this.setState({ isCallingShuttleDetailsApi: true });
      let saveStorageKey = 'CBX_Shuttle_Details';

      let reqParams = {
        params:
        {
          originId: originId,
          destinationId: destinationId,
          departureDate: shuttleStartDate,
          typeId: 1,
          passengersQ: shuttlePassengers,
          rideId: rideId,
        }
      }

      if (page === "shuttleSelectRoundTrip") {
        saveStorageKey = 'CBX_Shuttle_Return_Details';
        reqParams = {
          params:
          {
            originId: destinationId,
            destinationId: originId,
            departureDate: shuttleEndDate,
            typeId: 1,
            passengersQ: shuttlePassengers,
            rideId: rideId,
          }
        }
      }


      instance.get(process.env.GATSBY_GET_SHUTTLE_DETAILS, reqParams)
        .then(({ data }) => {
          window.localStorage.setItem(saveStorageKey, JSON.stringify(data));
          this.setState({ isCallingShuttleApi: false });
          if (shuttleTravelType === 'round' && page === "shuttleSelectTrip") {
            window.location.href = `/${locale}/shuttleSelectSeats`
          } else if (shuttleTravelType === 'round' && page === "shuttleSelectRoundTrip") {
            window.location.href = `/${locale}/shuttleSelectSeatsReturn`
          }
          else {
            window.location.href = `/${locale}/shuttleSelectSeats`
          }
        })
        .catch((error) => {
          this.setState({ isCallingShuttleDetailsApi: false });
          alert(locale === 'es'
            ? 'Ocurrió un error obteniendo las rutas. Por favor inténtelo de nuevo más tarde.'
            : 'There was an error fetching shuttle routes. Try again later');
          return error;
        });
    };


    const closeModalDates = () => {
      this.setState({ differentDates: false })
    }

    const closeModalLots = () => {
      this.setState({ sportsNotAvailable: false })
    }

    const closeModalShuttle = () => {
      this.setState({ shuttleNotAvailable: false })
    }

    const changeTripSelect = (id) => {
      this.setState({ isSelectedTrip: id })
    }

    const showModalFeet = () => {
      this.setState({ nontIncludeShow: !nontIncludeShow })
    }

    const handlerModalPosition = (event) => {
      this.setState({ modalMarginTop: event.clientY })
    }

    const showModalScales = (event) => {
      handlerModalPosition(event);
      this.setState({ showScales: !showScales })
    }

    const handleDetailSelected = (id) => {
      this.setState({ detailSelected: id })
    }

    const openModalSelectedSeats = () => {
      this.setState({ showModalSelectedSeats: !showModalSelectedSeats })
      if (selectedSeat.length < 5) {
        this.setState({ showModalMissingSeats: !showModalMissingSeats })
      }

    }

    const openModalMissingSeats = () => {
      this.setState({ showModalSelectedSeats: false })
      this.setState({ showModalMissingSeats: !showModalMissingSeats })
    }

    const shuttleOriginHandler = (event) => {
      const changeDestinationData = {};
      if (event.target.value !== "CROSS BORDER XPRESS") {
        changeDestinationData.shuttleDestination = "CROSS BORDER XPRESS";
      }
      if (event.target.value == this.state.shuttleDestination) {
        changeDestinationData.shuttleDestination = "";
      }
      this.setState({
        shuttleOrigin: event.target.value,
        ...changeDestinationData
      });
      this.updateShuttleQuickData({
        isSelectedTrip: isSelectedTrip,
        shuttleDestination: shuttleDestination,
        shuttleEndDate: shuttleEndDate,
        shuttleOrigin: event.target.value,
        shuttlePassengers: shuttlePassengers,
        shuttleStartDate: shuttleStartDate,
        shuttleTravelType: shuttleTravelType,
        ...changeDestinationData
      });
    }

    const shuttleDestinationHandler = (event) => {
      const changeOriginData = {};
      if (event.target.value !== "CROSS BORDER XPRESS") {
        changeOriginData.shuttleOrigin = "CROSS BORDER XPRESS";
      }
      if (event.target.value == this.state.shuttleOrigin) {
        changeOriginData.shuttleOrigin = "";
      }
      this.setState({
        shuttleDestination: event.target.value,
        ...changeOriginData
      });
      this.updateShuttleQuickData({
        isSelectedTrip: isSelectedTrip,
        shuttleDestination: event.target.value,
        shuttleEndDate: shuttleEndDate,
        shuttleOrigin: shuttleOrigin,
        shuttlePassengers: shuttlePassengers,
        shuttleStartDate: shuttleStartDate,
        shuttleTravelType: shuttleTravelType,
        ...changeOriginData
      });
    }

    const onSelectedSeat = (seat) => {
      const {
        selectedCounter
      } = this.state;
      console.log(selectedSeat);
      this.setState({ selectedSeat: seat, selectedCounter: selectedCounter + 1 });
    }

    const onSelectedSeatRound = (seat) => {
      const {
        selectedCounter
      } = this.state;
      this.setState({ selectedSeatRound: seat, selectedCounter: selectedCounter + 1 });
    }

    const changeTravelType = (type) => {
      this.setState({ shuttleTravelType: type })
    }

    const shuttleTravelTypeHandler = (evt) => {
      this.setState({
        shuttleTravelType: evt.target.value
      });
      this.updateShuttleQuickData({
        isSelectedTrip: isSelectedTrip,
        shuttleDestination: shuttleDestination,
        shuttleEndDate: shuttleEndDate,
        shuttleOrigin: shuttleOrigin,
        shuttlePassengers: shuttlePassengers,
        shuttleStartDate: shuttleStartDate,
        shuttleTravelType: evt.target.value
      });
    };

    const shuttlePassengersHandler = (evt) => {
      this.setState({
        shuttlePassengers: evt.target.value
      });
      this.updateShuttleQuickData({
        isSelectedTrip: isSelectedTrip,
        shuttleDestination: shuttleDestination,
        shuttleEndDate: shuttleEndDate,
        shuttleOrigin: shuttleOrigin,
        shuttlePassengers: evt.target.value,
        shuttleStartDate: shuttleStartDate,
        shuttleTravelType: shuttleTravelType
      });
    };

    const saveShuttleTripData = (data, selectedId) => {
      saveQuickData({
        shuttleDestination,
        shuttleOrigin,
        shuttleStartDate,
        shuttleEndDate,
        shuttlePassengers,
        shuttleTravelType,
        isSelectedTrip: selectedId
      });

      saveTripShutleData({
        isSelectedTrip: selectedId,
        data
      })


    };

    const saveTripShuttleDataRound = (data, selectedId) => {
      saveQuickData({
        shuttleDestination,
        shuttleOrigin,
        shuttleStartDate,
        shuttleEndDate,
        shuttlePassengers,
        shuttleTravelType,
        isSelectedTrip: selectedId
      });

      saveTripShuttleRoundData({
        isSelectedTrip: selectedId,
        data
      })


    };

    const selectRoundTrip = () => {
      this.updateShuttleQuickData({
        isSelectedTrip: ''
      });
      window.location.href = `/${locale}/shuttleSelectRoundTrip`
    }

    const goToCart = () => {
      ;
      this.addShuttleCart(true)
    };

    const cap = (str, split = true) => {
      let res = str.trim()
        .toLowerCase()
        .replace(/\w\S*/g, w => (w.replace(/^\w/, c => c.toUpperCase())));
      return split ? res.split(`(`)[0] : res.replace(`(`, `\n  -(`);
    };

    const getHours = (dateStr) => dateStr.split(`T`)[1].substring(0, 5);
    const closeDownloadApp = () => {
      this.setState({ showDownloadApp: false })
    }

    const changeAssistPassData = (field, val) => {
      console.log(val.target.value, 'vale');
      this.setState({ [field]: val.target.value });
    }

    const selectBundle = (bundle) => {
      this.setState({ selectedBundle: bundle })
    }

    return (
      <Fragment>
        {!showModalSelectedSeats && selectedSeat.length < 5 && showModalMissingSeats && (
          <ModalWrapper>
            <Dialog>
              <div style={{
                display: 'flex', justifyContent: 'flex-end', marginRight: 15,
                marginTop: "10px", cursor: 'pointer'
              }} onClick={openModalMissingSeats} >
                <img alt="Close" src={cbxCloseIcon} />
              </div>
              <Header border style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Title className="cbx-bold" style={{ textAlign: 'right', cursor: 'pointer' }}
                >{translations.attention}</Title>
                <Text style={{ marginTop: "25px" }}>{translations.warnText}</Text>
              </Header>
              <Footer className="modal-footer">
                <Button className="btn-continue primary" onClick={openModalSelectedSeats} >
                  {translations.continueLabel}
                </Button>
              </Footer>
            </Dialog>
          </ModalWrapper>
        )}
        {showScales && (
          <ModalWrapper onClick={showModalScales} style={{ justifyContent: "end", backgroundColor: "transparent" }}>
            <Dialog onClick={(event) => { event.stopPropagation(); event.preventDefault(); }} style={{ marginTop: modalMarginTop }}>
              <div style={{ display: 'flex', justifyContent: 'flex end', marginLeft: "20px", marginTop: "15px", cursor: 'pointer' }} onClick={showModalScales} >
                <img alt="Close" src={cbxCloseIcon} />
              </div>
              <Header border style={{ display: 'flex', justifyContent: "center", columnCount: 3 }}>
                <img
                  alt=""
                  width={detailsData.data[detailSelected].provider === "damaris" ? "50px" : "40%"}
                  height="50px"
                  src={detailsData.data[detailSelected].provider === "damaris" ? damaris_logo : losLimousines}
                />
                <div>
                  <Text style={{ color: "#3F2A55", fontSize: "16px", textAlign: "start", fontWeight: "bold", marginBottom: "5px" }}>{cap(moment(detailsData.data[detailSelected].departureDateTime).format('MMMM DD, YYYY '))}</Text>
                </div>
                <Text style={{ color: "#FF3094", fontSize: "16px", marginLeft: "30px", fontWeight: "bold" }}>${detailsData.data[detailSelected].price} {translations.person}</Text>
              </Header>
              {detailsData.data[detailSelected] && detailsData.data[detailSelected].scales.map((scala, index) => (
                detailsData.data[detailSelected].provider === "damaris" && (
                  <div style={{ marginTop: "20px", marginBotom: "20px", marginInline: "40px" }}>
                    <div style={{ display: "flex" }}>
                      {i === 0 && <Text style={{ color: "#3F2A55", fontWeight: "bold" }}>○</Text> ||
                        <img
                          alt=""
                          width="10px"
                          height="10px"
                          src={CBX_purpleUbication}
                          style={{ marginRight: "5px", marginTop: "7px" }}
                        />
                      }
                      <Text
                        style={{ color: "#3F2A55", textAlign: "flex-start", fontWeight: "bold" }}
                      >{detailsData.data[detailSelected] && `${cap(detailsData.data[detailSelected].scales[index].from)} to ${cap(detailsData.data[detailSelected].scales[index].to)}`} </Text>
                    </div>
                    {scala.stops.map((step, i) => (<>
                      {step.minsWaiting != "0m" &&
                        <Text style={{ fontSize: "12px", color: "#FF3094", fontWeight: "bold", alignSelf: "center", marginLeft: "15px" }}>  {step.minsWaiting} Wait</Text>
                      }

                      <div style={{ display: "flex" }}>
                        {index === detailsData.data[detailSelected].scales.length - 1 && <img
                          alt=""
                          width="10px"
                          height="10px"
                          src={CBX_pinkUbication}
                          style={{ marginTop: "7px" }}
                        /> || <Text style={{ color: "#3F2A55", fontWeight: "bold" }}>•</Text>}
                        <div style={{ backgroundColor: "#FF3094", height: "auto", width: "2px", marginInline: "5px" }}></div>
                        <div>
                          <Text style={{ fontSize: "12px", color: "#ACACAC", fontWeight: "bold", alignSelf: "center" }}>{`${cap(step.name, false)} (${getHours(step.departureDatetime)})`}</Text>
                          <Text style={{ fontSize: "12px", color: "#ACACAC", fontWeight: "bold", alignSelf: "center" }}>{`${cap(step.toStation, false)} (${getHours(step.arrivalDatetime)})`}</Text>
                        </div>
                      </div>
                    </>

                    ))
                    }
                  </div>)

              ))}
              {detailsData.data[detailSelected].provider != "damaris" &&
                <div style={{ marginTop: "20px", marginBotom: "20px", marginInline: "40px" }}>
                  <Text style={{ color: "#3F2A55", textAlign: "flex-start", fontWeight: "bold" }}>
                    {detailsData.data[detailSelected] && `${cap(detailsData.data[detailSelected].originText)}(${getHours(detailsData.data[detailSelected].departureDateTime)}) to ${cap(detailsData.data[detailSelected].destinationText)} (${getHours(detailsData.data[detailSelected].arrivalDateTime)})`} </Text>
                  {detailsData.data[detailSelected].scales.length > 0 && (
                    <div style={{ display: "flex" }}>
                      <img
                        alt=""
                        width="10px"
                        height="10px"
                        src={CBX_pinkUbication}
                        style={{ marginTop: "7px" }}
                      />
                      <div style={{ backgroundColor: "#FF3094", height: "auto", width: "2px", marginInline: "5px" }}></div>
                      <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                        {detailsData.data[detailSelected].scales.map((scale, scaleIndex) => {
                          console.log(scale);
                          return (
                            <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }} key={`scale_${detailSelected}_${scaleIndex}`}>
                              <Text style={{ fontSize: "12px", color: "#ACACAC", fontWeight: "bold", alignSelf: "center" }}>{`${scale.from} => ${scale.to}`}</Text>
                            </div>
                          )
                        }
                        )}
                      </div>
                    </div>)}
                </div>}
              <Footer className="modal-footer">
              </Footer>
            </Dialog>
          </ModalWrapper>
        )}
        {false && showDownloadApp && <GotoApp locale={locale} close={closeDownloadApp} />}
        {popupDisclaimer && (
          <ModalWrapper>
            <Dialog>
              <Header border style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }}>
                <Title className="cbx-bold" style={{ textAlign: 'right', cursor: 'pointer' }} onClick={() => { this.setState({ popupDisclaimer: false }) }}>X</Title>
              </Header>
              <Body>
                <img src={popupDisclaimer[`text_${locale}`]} style={{ width: '100%' }} />
              </Body>
              <Footer className="modal-footer">
                <Button className="btn-continue primary" onClick={() => { this.setState({ popupDisclaimer: false }); }}>
                  {translations.continueLabel}
                </Button>
              </Footer>
            </Dialog>
          </ModalWrapper>
        )}

        {disclaimer && showModal && (
          <ModalWrapper>
            <Dialog>
              <Header border>
                <Title className="cbx-bold" style={{ textAlign: 'right', cursor: 'pointer' }} onClick={() => { this.setState({ disclaimer: false }) }}>
                  <img
                    alt=""
                    width="20px"
                    height="20px"
                    style={{ marginInline: 'auto' }}
                    src={CBX_Recurso_X}
                  />
                </Title>
              </Header>
              <Body dangerouslySetInnerHTML={{ __html: disclaimer[`text_${locale}`] }} />
              <Footer className="modal-footer">
                <Button className="btn-continue primary" onClick={() => { this.setState({ showModal: false }); }}>
                  {translations.continueLabel}
                </Button>
              </Footer>
            </Dialog>
          </ModalWrapper>
        )}
        {showModalDonate && (
          <ModalWrapper>
            <Dialog>
              <Header border>
                <Title className="cbx-bold"></Title>
              </Header>
              <Body>
                <p>{translations.modalDonate}</p>
              </Body>
              <Footer className="modal-footer">
                <Button className="btn-continue primary" onClick={() => { this.setState({ showModalDonate: false }); }}>
                  {translations.continueLabel}
                </Button>
              </Footer>
            </Dialog>
          </ModalWrapper>
        )}

        {shuttleNotAvailable && (
          <div
            id="map-popup"
            style={{
              position: 'fixed',
              backgroundColor: 'white',
              width: '350px',
              borderRadius: '12px',
              padding: '5px 15px 5px',
              border: '1px solid #726C79 ',
              top: "50%",
              left: "50%",
              transform: 'translate(-50%, -50%)',
              margin: "auto",
              right: "35%",
              zIndex: 2000,
              textAlign: "center",
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 5, cursor: 'pointer' }} onClick={closeModalShuttle} >
              <img alt="Close" src={cbxCloseIcon} />
            </div>
            <div
              style={{
                padding: '2%',
                width: '100%',
                margin: 'auto',
                justifyContent: 'center'
              }}
            >
              <div
                style={{
                  width: '100%',
                  margin: 'auto',
                  justifyContent: 'center'
                }}
              />
              <img
                alt=""
                style={{ margin: 'auto', display: 'block', padding: "0px 0px 10px" }}
                width="150px"
                height="auto"
                src={shuttle_unavailable}
              />
              <PurpleLabel style={{ fontSize: "25px", padding: "0px 0px 10px" }}>{translations.shuttleNotAvailableTitle}</PurpleLabel>
              <PurpleLabel>{translations.shuttleNotAvailableLabel}</PurpleLabel>
              <div style={{ padding: "15px 0px 10px", margin: "auto", width: "150px" }} />
              <ValidateButton
                action={() => { closeModalShuttle() }}
                width="30px !important"
                disabled={false}
                message={translations.ok}
              />
            </div>
          </div>
        )}
        {page === 'cart' && differentDates && (
          <ModalWrapper>
            <Dialog style={{ marginTop: "350px" }}>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 15, marginRight: 15, cursor: 'pointer' }} onClick={closeModalDates} >
                <img alt="Close" src={cbxCloseIcon} />
              </div>
              <div
                style={{
                  padding: '5%',
                  width: '100%',
                  margin: 'auto',
                  justifyContent: 'center'
                }}
              >
                <div
                  style={{
                    width: '100%',
                    margin: 'auto',
                    justifyContent: 'center'
                  }}
                >
                  <PurpleLabel style={{ fontSize: "25px", padding: "0px 0px 10px" }}>{translations.diferentDatesLabel}</PurpleLabel>
                  <PurpleLabel>{translations.diferentDatesSubTitle}</PurpleLabel>
                  <div style={{ display: "flex", margin: "auto", justifyContent: "space-between" }}>
                    <ValidateButton
                      action={() => { closeModalDates() }}
                      width="30px !important"
                      disabled={false}
                      backgroundColor={"#3F2A55"}
                      message={translations.edit}
                    />
                    <ValidateButton
                      action={() => { if (!isProcessing) this.doShopping('modal'); }}
                      status={isProcessing ? "disabled" : "active"}
                      message={translations.purchase}
                      isLoading={isProcessing}
                    />
                  </div>
                </div>
              </div>
            </Dialog>
          </ModalWrapper>
        )}
        {sportsNotAvailable && (
          <div
            id="map-popup"
            style={{
              position: 'fixed',
              backgroundColor: 'white',
              width: '350px',
              borderRadius: '12px',
              padding: '5px 15px 5px',
              border: '1px solid #726C79 ',
              top: "50%",
              left: "50%",
              transform: 'translate(-50%, -50%)',
              margin: "auto",
              right: "35%",
              zIndex: 2000,
              textAlign: "center",
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 5, cursor: 'pointer' }} onClick={closeModalLots} >
              <img alt="Close" src={cbxCloseIcon} />
            </div>
            <div
              style={{
                padding: '2%',
                width: '100%',
                margin: 'auto',
                justifyContent: 'center'
              }}
            >
              <div
                style={{
                  width: '100%',
                  margin: 'auto',
                  justifyContent: 'center'
                }}
              >
                <img
                  alt=""
                  style={{ margin: 'auto', display: 'block', padding: "0px 0px 10px" }}
                  width="150px"
                  height="auto"
                  src={lot_unavailable}
                />
                <PurpleLabel style={{ fontSize: "20px", color: PINK, fontWeight: 'bold', padding: "0px 0px 10px" }}>{translations.sportsNotAvailableTitle}</PurpleLabel>
                <PurpleLabel>{translations.sportsNotAvailableLabel}</PurpleLabel>
                <div style={{ padding: "15px 0px 10px", margin: "auto", display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: "16px", color: BLACK, fontWeight: 'normal' }}>
                  <ValidateButton
                    style={{ display: 'flex', width: '100%' }}
                    action={() => { window.location.href = `/${locale}/parking` }}
                    disabled={false}
                    message={translations.sportsNotAvailableButton}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        <Wrapper>
          {page === 'home' && <div className="containerTickets" style={{
            maxWidth: '100%', top: '13%',
            position: "relative",
            display: "contents",
            paddingInline: "200px",
            backgroundColor: "azure"
          }}>
            <ContentWrapper className="row" translate={!url.includes('ticket')}>
              <div style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "10px 7% 10px",
                flexWrap: "wrap"
              }}>
                <ButtonWrapper
                  style={selectorItem != "Ticket" ? { opacity: "0.7", backgroundColor: "#1B161F" } : { backgroundColor: "#3F2A55" }}
                  onClick={changeQuickTicket}
                  height="45px"
                >{ticketLabel}</ButtonWrapper>
                <ButtonWrapper
                  style={selectorItem != "Parking" ? { opacity: "0.7", backgroundColor: "#1B161F" } : { backgroundColor: "#3F2A55" }}
                  onClick={changeQuickItemParking}
                  height="45px"
                >Parking</ButtonWrapper>
                <ButtonWrapper
                  style={selectorItem != "Shuttle" ? { opacity: "0.7", backgroundColor: "#1B161F" } : { backgroundColor: "#3F2A55" }}
                  onClick={changeQuickItemShuttle}
                  height="45px"
                >Shuttle</ButtonWrapper>
                <ButtonWrapper
                  style={selectorItem != "Wheels" ? { opacity: "0.7", backgroundColor: "#1B161F" } : { backgroundColor: "#3F2A55" }}
                  onClick={changeQuickItemWheels}
                  height="45px"
                >{translations.wheelsSelector}</ButtonWrapper>
                <ButtonWrapper
                  style={selectorItem != "Bundles" ? { opacity: "0.7", backgroundColor: "#1B161F" } : { backgroundColor: "#3F2A55" }}
                  onClick={changeQuickItemBundles}
                  height="45px"
                >{translations.bundles}</ButtonWrapper>
              </div>
              <DestinationWrapperWhite>
                <QuickSelector
                  {...travelPurposes}
                  ticketType={{
                    ...ticketType,
                    options: ticketOptions
                  }}
                  isFamily={isFamily}
                  ticketTypeHandler={this.ticketTypeHandler}
                  buyingToggle={this.buyingToggle}
                  travelTypeHandler={this.travelTypeHandler}
                  flightDateHandler={this.flightDateHandler}
                  returnDateHandler={this.returnDateHandler}
                  switchPlaces={this.switchPlaces}
                  travelPurposeHandler={this.travelPurposeHandler}
                  shuttleDestinationHandler={shuttleDestinationHandler}
                  {...shuttleDestinations}
                  {...shuttleOrigins}
                  shuttleTravel={shuttleTravel}
                  shuttleTravelHandler={this.shuttleTravelHandler}
                  flightDate={flightDate}
                  returnDate={returnDate}
                  activeTicketType={activeTicketType}
                  ticketNumber={ticketNumber}
                  activeTravelType={activeTravelType}
                  minDate={minDate}
                  maxDate={maxDate}
                  travelPurposes={travelPurposes}
                  shuttleDestinations={shuttleDestinations}
                  shuttleOrigins={shuttleOrigins}
                  quantityPersons={quantityPersons}
                  locale={locale}
                  translations={translations}
                  disableButton={!flightDate || !returnDate}
                  origin={origin}
                  destination={destination}
                  travelPurpose={travelPurpose}
                  selectorItem={selectorItem}
                  lot={lot}
                  startDate={startDate}
                  endDate={endDate}
                  startTime={startTime}
                  endTime={endTime}
                  startTimeHandler={startTimeHandler}
                  endTimeHanlder={endTimeHanlder}
                  openParking={openParking}
                  endDateHandler={endDateHandler}
                  startDateHandler={startDateHandler}
                  onBundleSelect={selectBundle}
                  selectedBundle={selectedBundle}
                  lotHandler={this.lotHandler}
                  showCalendar={showCalendar}
                  showRangeCalendar={showRangeCalendar}
                  showStartDateCalendar={showStartDateCalendar}
                  showEndDateCalendar={showEndDateCalendar}
                  selectionRange={[selectionRange]}
                  handleSelect={handleSelect}
                  handleSelectStartDate={handleSelectStartDate}
                  company={company}
                  getLots={getLots}
                  isCallingParkingApi={isCallingParkingApi}
                  price={price}
                  incrementShuttle={incrementShuttle}
                  decrementShuttle={decrementShuttle}
                  counterShuttle={counterShuttle}
                  openShuttleSelectTrip={openShuttleSelectTrip}
                  shuttleTravelType={shuttleTravelType}
                  shuttleDestination={shuttleDestination}
                  shuttleOrigin={shuttleOrigin}
                  shuttleStartDate={shuttleStartDate}
                  shuttleEndDate={shuttleEndDate}
                  shuttlePassengers={shuttlePassengers}
                  shuttleEndDateHandler={this.shuttleEndDateHandler}
                  shuttlStartDateHandler={this.shuttleStartDateHandler}
                  shuttleTravelTypeHandler={shuttleTravelTypeHandler}
                  changeTravelType={changeTravelType}
                  getShuttleRoutes={getShuttleRoutes}
                  shuttleOriginHandler={shuttleOriginHandler}
                  isCallingShuttleApi={isCallingShuttleApi}
                  page={page}
                />
              </DestinationWrapperWhite>
              {["", "parking"].includes(window.location.pathname.split('/').pop()) && <div className="" style={{ "overflow": "hidden" }}>
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <div className="col-md-12" style={{ background: "rgb(234, 234, 234)", borderRadius: "5px", paddingTop: "30px", paddingRight: "10px", paddingBottom: "20px", paddingLeft: "10px", color: "black", fontWeight: "bold", textAlign: "center" }}>
                        {locale === 'en' ?
                          `We've got a space just for you! With over 10,000 public parking stalls at your disposal, many self-serve or valet parking options available, whether you reserve or decide to use our facilities the same-day, we are ready. Reservations for lots and valet parking are available at CBX. For pricing, go to the reservation tool and select your desired location. Street parking can't be reserved.`
                          : `Tenemos espacio para ti. Con más de 10,000 lugares de estacionamiento a tu disposición, con opciones como estacionamiento reservado, autoservicio o nuestro conveniente y siempre disponible servicio de valet, ya sea reservado o en sitio.
                          CBX cuenta con reservaciones para estacionamiento en lotes y Valet. Para informacion sobre precios acceda al modulo de reservas y seleccione el lote deseado. No se puede reservar estacionamiento en calle.`}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              }
            </ContentWrapper>

          </div>
          }
          {page === 'configTicket' &&
            (<div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
              <Stepper translations={translations} activeIndex={2} locale={locale} selectorItem={selectorItem} currentStep={currentStep}
                editTicket={openConfigTicket} editParking={openPersonalInfo} isLoading={isLoading}
                action={() => {
                  if (!isLoading) this.addParkingCart(true);
                }}
              />
              <TicketInfoGrayCollapsable
                buttonAction={() => {
                  this.setState({ showAddTicket: !showAddTicket });
                }}
                buttonText={translations.edit}
                data={{
                  isTicketFlow: true,
                  origin: origin.place,
                  destination: destination.place,
                  noPassengers: ticketNumber,
                  flightDate: flightDate ? flightDate.replaceAll('-', '/') : '',
                  returnDate: returnDate ? returnDate.replaceAll('-', '/') : '',
                  price
                }}
                translations={translations}
              />
              {((typeof window !== 'undefined' && window.localStorage.getItem('currentFlow') === 'Bundles') || showAddTicket) && (
                <WrapperTicketInfo style={{ margin: "30px 0px 0px", padding: "0px" }}>
                  <TicketInfo
                    {...travelPurposes}
                    ticketType={{
                      ...ticketType,
                      options: ticketOptions
                    }}
                    // {...shuttleDestinations}
                    isFamily={isFamily}
                    ticketTypeHandler={this.ticketTypeHandler}
                    buyingToggle={this.buyingToggle}
                    travelTypeHandler={this.travelTypeHandler}
                    flightDateHandler={this.flightDateHandler}
                    returnDateHandler={this.returnDateHandler}
                    switchPlaces={this.switchPlaces}
                    travelPurposeHandler={this.travelPurposeHandler}
                    shuttleOrigin={shuttleOrigin}
                    shuttleDestination={shuttleDestinationHandler}
                    shuttleOrigins={shuttleOrigins}
                    shuttleTravel={shuttleTravel}
                    shuttleTrav={this.shuttleTravelHandler}
                    flightDate={flightDate}
                    returnDate={returnDate}
                    activeTicketType={activeTicketType}
                    ticketNumber={ticketNumber}
                    activeTravelType={activeTravelType}
                    minDate={minDate}
                    maxDate={maxDate}
                    travelPurposes={travelPurposes}
                    quantityPersons={quantityPersons}
                    locale={locale}
                    translations={translations}
                    origin={origin}
                    destination={destination}
                    travelPurpose={travelPurpose}
                    selectorItem={'Ticket'}
                    price={price}
                    incrementShuttle={incrementShuttle}
                    decrementShuttle={decrementShuttle}
                    counterShuttle={counterShuttle}
                    openShuttleSelectTrip={openShuttleSelectTrip}
                    shuttleOriginHandler={shuttleOriginHandler}
                    page={page}
                  />
                </WrapperTicketInfo>)}
              <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                <CartSection>
                  <Label color="#292033" size="20px" style={{ marginTop: '2em', width: '100%' }}>
                    <img alt="" width="30px" height="20px"
                      style={{
                        marginInline: "auto",
                        cursor: "pointer",
                        paddingRight: "10px"
                      }}
                      src={purple_arrow}
                      onClick={selectorItem === "Parking" ? openLot : openHome}
                    />{" "}
                    {locale === "es" ? "Información de contacto" : "Contact Information"}
                  </Label>
                  {this.getContactInformation(true, false, isMobile)}
                </CartSection>
              </div>
            </div>)}
          {page === 'assistPassForm' &&
            (<div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
              <Stepper translations={translations} activeIndex={2} locale={locale} selectorItem={selectorItem} currentStep={currentStep}
                editTicket={openConfigTicket} editParking={openPersonalInfo} isLoading={isLoading}
                action={() => {
                  if (!isLoading) this.addParkingCart(true);
                }}
              />
              <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                <CartSection>
                  <AssistPassForm
                    translations={translations}
                    locale={locale}
                    assistPassName={assistPassName}
                    assistPassLastName={assistPassLastName}
                    assistPassGender={assistPassGender}
                    assistPassPhone={assistPassPhone}
                    assistPassAge={assistPassAge}
                    assistPassDate={assistPassDate}
                    assistPassFightNumber={assistPassFightNumber}
                    assistPassAirline={assistPassAirline}
                    assistPassOrigin={assistPassOrigin}
                    assistPassDestination={assistPassDestination}
                    assistPassTutorName={assistPassTutorName}
                    assistPassTutorLastName={assistPassTutorLastName}
                    assistPassTutorPhone={assistPassTutorPhone}
                    assistPassTutorEmail={assistPassTutorEmail}
                    assistPassTempId={assistPassTempId}
                    changeAssistPassData={changeAssistPassData}
                    activeTicketType={activeTicketType}
                    destination={destination}
                    hasContactInfo={name.status === 1}
                    insertContactInfo={insertContactInfo}
                    flightDate={flightDate}
                    assistPassNationality={assistPassNationality}
                  />
                </CartSection>
              </div>
            </div>)}
          {page === 'personalInfo' &&
            (<div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
              <Stepper translations={translations} cartactiveIndex={2} locale={locale} selectorItem={selectorItem} currentStep={currentStep} isLoading={isLoading}
                editParking={
                  currentStep >= 3 ? () => {
                    removeQuickData();
                    const product = cart[cart.length - 1];
                    if (product.type === "parking") {
                      this.editElementFromCartUsingStepper(cart.length - 1);
                    } else {
                      openLot();
                    }
                  }
                    : openLot
                }
                action={() => {
                  if (!isLoading) this.addParkingCart(true);
                }}
              />
              <TicketInfoGrayCollapsable
                buttonAction={() => {
                  window.location.href = `/${locale}/lot`;
                }}
                buttonText={translations.edit}
                data={{
                  isParkingFlow: true
                }}
                translations={translations}
              />
              <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                <CartSection>
                  <Label color="#292033" size="20px" style={{ marginTop: '2em', width: '100%' }}>
                    <img alt="" width="30px" height="20px"
                      style={{
                        marginInline: "auto",
                        cursor: "pointer",
                        paddingRight: "10px"
                      }}
                      src={purple_arrow}
                      onClick={
                        currentStep >= 3 ? () => {
                          removeQuickData();
                          const product = cart[cart.length - 1];
                          if (product.type === "parking") {
                            this.editElementFromCartUsingStepper(cart.length - 1);
                          } else {
                            openLot();
                          }
                        }
                          : goToPersonalInfo
                      } />
                    {translations.contactInformation}
                  </Label>
                  {this.getContactInformation(true, selectorItem === 'Parking', isMobile, selectorItem === 'Shuttle' || window.localStorage.getItem('currentFlow') === 'Bundles', window.localStorage.getItem('currentFlow') === 'Wheels')}
                </CartSection>
              </div>
            </div>)}
          {page === 'addOns' && (
            <CartSection>
              <Stepper translations={translations} activeIndex={3} locale={locale} selectorItem={selectorItem} currentStep={currentStep} isLoading={isLoading}
                editTicket={
                  cart
                    ? () => {
                      const product = cart[cart.length - 1];
                      if (product.type === "ticket") {
                        this.editElementFromCartUsingStepper(cart.length - 1);
                      } else {
                        openConfigTicket();
                      }
                    }
                    : openConfigTicket
                }
                editParking={
                  cart
                    ? () => {
                      removeQuickData();
                      const product = cart[cart.length - 1];
                      if (product.type === "parking") {
                        this.editElementFromCartUsingStepper(cart.length - 1);
                      } else {
                        openPersonalInfo();
                      }
                    }
                    : openPersonalInfo
                }
                action={() => {
                  this.addToCart();
                }
                }


              />
              <Label color="#292033" size="20px" style={{ marginTop: '1em', width: '100%' }}>
                {selectorItem === 'Shuttle' &&
                  <img
                    alt=""
                    width="30px"
                    height="20px"
                    style={{
                      marginInline: "auto",
                      cursor: "pointer",
                      paddingRight: "10px"
                    }}
                    src={purple_arrow}
                    onClick={goToPersonalInfo}
                  />
                }
                {selectorItem !== 'Shuttle' &&
                  <img
                    alt=""
                    width="30px"
                    height="20px"
                    style={{
                      marginInline: "auto",
                      cursor: "pointer",
                      paddingRight: "10px"
                    }}
                    src={purple_arrow}
                    onClick={
                      selectorItem === "Parking"
                        ? openPersonalInfo
                        :
                        cart
                          ? () => {
                            removeQuickData();
                            const product = cart[cart.length - 1];
                            if (product.type === "ticket") {
                              this.editElementFromCartUsingStepper(cart.length - 1);
                            } else {
                              openConfigTicket();
                            }
                          }
                          : openConfigTicket
                    }

                  />}{" "}

                {`${translations.addOnsSubtitle}`}
              </Label>

              {cart && cart.length > 0 && (
                <Label size="16px" style={{ marginTop: '1em', marginBottom: '0.5em' }}>
                  {translations.itemsInMyCart}
                </Label>
              )}
              {cart && cart.length === 1 && (
                <GrayContainer>
                  {cart[0].type === 'ticket' && (
                    <Label color="#726C79" style={{ fontSize: '15px' }}>
                      {cart[0].NuProdQuant} x {cart[0].NuProdQuant === 1 ? translations.ticket : `${translations.ticket}s`} - {translations.from}
                      <span style={{ color: PINK, textTransform: 'uppercase' }}>{` ${cart[0].origin.place} `}</span>
                      {translations.to}
                      <span style={{ color: PINK, textTransform: 'uppercase' }}>{` ${cart[0].destination.place} `}</span>
                    </Label>
                  )}
                  {cart[0].type === 'parking' && (
                    <Label color="#726C79">{cart[0].NuProdQuant} x {translations.parking} - {cart[0].vehicleDescription.split('color')[0]}</Label>
                  )}
                  {cart[0].type === 'shuttle' && (
                    <Label color="#726C79">{cart[0].passengersQ} x {translations.shuttle} - {cart[0].originText} {translations.destinationLabel.toLowerCase()} {cart[0].destinationText}</Label>
                  )}
                </GrayContainer>
              )}
              {cart && cart.length > 1 && (
                <GrayContainer>
                  {cart.map((item, index) => {
                    let renderItem;
                    if (index < 3 && item.type === 'ticket') {
                      renderItem = (<Label color="#726C79" style={{ fontSize: '15px' }}>
                        {item.NuProdQuant} x {item.NuProdQuant === 1 ? translations.ticket : `${translations.ticket}s`} - {translations.from}
                        <span style={{ color: PINK, textTransform: 'uppercase' }} >{` ${item.origin.place} `}</span>
                        {translations.to}
                        <span style={{ color: PINK, textTransform: 'uppercase' }} >{` ${item.destination.place} `}</span>
                      </Label>);
                    }
                    if (index < 3 && item.type === 'parking') {
                      renderItem = (<Label style={{ fontSize: '15px' }} color="#726C79">{item.NuProdQuant} x {translations.parking} - {item.vehicleDescription.split('color')[0]}</Label>);
                    }
                    if (index < 3 && item.type === 'shuttle') {
                      renderItem = (<Label color="#726C79">{cart[index].passengersQ} x {translations.shuttle} - {cart[index].originText.toUpperCase()} {translations.destinationLabel.toLowerCase()} {cart[index].destinationText.toUpperCase()}</Label>);
                    }
                    return renderItem;
                  })}
                  {cart.length > 3 && (
                    <div onClick={continueCart} style={{ cursor: 'pointer' }}><Label style={{ fontSize: '15px' }} color="#EF60A3">{translations.viewMore}</Label></div>
                  )}
                </GrayContainer>
              )}
              <Label size="16px" style={{ marginTop: '2em', marginBottom: `0.5em` }}>
                {translations.moreProducts}
              </Label>
              <div style={{
                display: 'flex', width: '90%', justifyContent: 'center', flexDirection: isMobile ? 'column' : 'row'
              }}
              >
                <ContainerPurpleButton onClick={() => {
                  window.localStorage.setItem("currentFlow", "Parking");
                  window.localStorage.removeItem('parking');
                  removeQuickData();
                  setParkingStatus(1);
                  getLots(`/${locale}/lot`);
                }}
                  style={{ display: hideParkingAddOn ? 'none' : 'flex' }}>
                  <img
                    alt=""
                    width={isMobile ? '50px' : '70px'}
                    height={isMobile ? '50px' : '70px'}
                    style={{ marginInline: 'auto' }}
                    src={icoParkingWhite}
                  />
                  <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', paddingTop: '20px' }}>{translations.parking}</p>
                </ContainerPurpleButton>

                <ContainerPurpleButton
                  onClick={() => {
                    window.localStorage.setItem("currentFlow", "Ticket");
                    removeQuickData();
                    continueShopping();
                  }}
                  style={{ display: hideTicketAddOn ? 'none' : 'flex' }}>
                  <img
                    alt=""
                    width={isMobile ? '50px' : '80px'}
                    height={isMobile ? '50px' : '80px'}
                    style={{ marginInline: 'auto' }}
                    src={icoTicketWhite}
                  />
                  <p style={{ margin: 'auto' }}>{translations.ticket}</p>
                </ContainerPurpleButton>

                <ContainerPurpleButton
                  onClick={() => {
                    openShuttleSelectTrip();
                    removeQuickData();
                    setCleanShuttleRoutes(1);
                  }}
                  style={{ display: hideTicketAddOn ? 'none' : 'flex' }}>
                  <img
                    alt=""
                    width={isMobile ? '50px' : '80px'}
                    height={isMobile ? '50px' : '80px'}
                    style={{ marginInline: 'auto' }}
                    src={CBX_IconShuttle}
                  />
                  <p style={{ margin: 'auto' }}>{"Shuttle"}</p>
                </ContainerPurpleButton>
              </div>
              <ValidateButton action={continueCart} message={translations.proceedCheckout} />
            </CartSection>
          )}
          {page === 'personalInfoShuttle' &&
            (<div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
              <Stepper translations={translations} activeIndex={2} locale={locale} selectorItem={selectorItem} currentStep={currentStep} isLoading={isLoading}
                editParking={
                  currentStep >= 3 ? () => {
                    removeQuickData();
                    const product = cart[cart.length - 1];
                    if (product.type === "parking") {
                      this.editElementFromCartUsingStepper(cart.length - 1);
                    } else {
                      openLot();
                    }
                  }
                    : openLot
                }
                action={() => {
                  if (!isLoading) this.addParkingCart(true);
                }}
              />
              <TicketInfoGrayCollapsable
                buttonAction={() => {
                  window.location.href = `/${locale}/lot`;
                }}
                buttonText={translations.edit}
                data={{
                  isParkingFlow: true
                }}
                translations={translations}
              />
              <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                <CartSection>
                  <Label color="#292033" size="20px" style={{ marginTop: '2em', width: '100%' }}>
                    <img alt="" width="30px" height="20px"
                      style={{
                        marginInline: "auto",
                        cursor: "pointer",
                        paddingRight: "10px"
                      }}
                      src={purple_arrow}
                      onClick={
                        currentStep >= 3 ? () => {
                          removeQuickData();
                          const product = cart[cart.length - 1];
                          if (product.type === "parking") {
                            this.editElementFromCartUsingStepper(cart.length - 1);
                          } else {
                            openLot();
                          }
                        }
                          : openLot
                      } />
                    {translations.contactInformation}
                  </Label>
                  {this.getContactInformation(true, true, false, true)}
                </CartSection>
              </div>
            </div>)}
          {page === 'passengerInfoShuttle' &&
            (<div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
              <Stepper translations={translations} activeIndex={1} locale={locale} selectorItem={selectorItem} currentStep={currentStep} isLoading={isLoading}
                action={() => {
                  this.addShuttleCart(true);
                }}
              />
              <div style={{ display: 'flex', width: '100%' }}>
                <CartSection>
                  <Label color="#292033" size="20px" style={{ marginTop: '2em', width: '100%' }}>
                    <img alt="" width="30px" height="20px"
                      style={{
                        marginInline: "auto",
                        cursor: "pointer",
                        paddingRight: "10px"
                      }}
                      src={purple_arrow}
                      onClick={openShuttleSelectTrip} />
                    {translations.passengerInformation}
                  </Label>
                  <ShuttlePassenger
                    minDate={minDate}
                    maxDate={maxDate}
                    incrementShuttle={incrementShuttle}
                    decrementShuttle={decrementShuttle}
                    initializeCounter={initializeCounter}
                    saveParkingInfo={this.saveParkingInfo}
                    counterShuttle={counterShuttle}
                    translations={translations}
                    ticketType={ticketType}
                    openAddOns={openAddOns}
                    // continueCart={ this.addShuttleCart(true)}
                    changeData={changeData}
                    onShuttleUpdate={onShuttleUpdate}
                    shuttleInfo={shuttles}
                    locale={locale}
                    selectorItem={selectorItem}
                    isLoading={isLoading}
                    currentStep={currentStep}
                    lot={lot}
                    cart={cart}
                    startDate={startDate}
                    endDate={endDate}
                    startTime={startTime}
                    endTime={endTime}
                    startTimeHandler={startTimeHandler}
                    endTimeHandler={endTimeHanlder}
                    openParking={openParking}
                    endDateHandler={endDateHandler}
                    startDateHandler={startDateHandler}
                    onBundleSelect={selectBundle}
                    selectedBundle={selectedBundle}
                    lotHandler={this.lotHandler}
                    showCalendar={showCalendar}
                    showRangeCalendar={showRangeCalendar}
                    showStartDateCalendar={showStartDateCalendar}
                    showEndDateCalendar={showEndDateCalendar}
                    selectionRange={[selectionRange]}
                    handleSelect={handleSelect}
                    handleSelectStartDate={handleSelectStartDate}
                    enableSendToCartShuttle={enableSendToCartShuttle}
                    callParkingApi={callParkingApi}
                    getParkingPrice={getParkingPrice}
                    isCallingParkingApi={isCallingParkingApi}
                    buyingToggle={this.buyingToggle}
                    ticketNumber={ticketNumber}
                    quantityBaggage={quantityBaggage}
                    emailShuttleCheck={this.emailShuttleCheck}
                    emailShuttleStatus={emailShuttleStatus}
                    openShuttleSelectSeats={shuttleTravelType === "round" ? selectRoundTrip : goToPersonalInfo}
                    shuttlePassengers={shuttlePassengers}
                    isCallingShuttleApi={isCallingShuttleApi}
                    openPersonalInfo={openPersonalInfo}
                    goToPersonalInfo={goToPersonalInfo}
                    enableSendToCartShuttleABC={enableSendToCartShuttleABC}
                  />
                </CartSection>
              </div>
            </div>)}
          {page === 'shuttleSelectTrip' &&
            <>
              <CartSection>
                <Stepper translations={translations} activeIndex={1} locale={locale} selectorItem={selectorItem} currentStep={currentStep} isLoading={isLoading}
                  action={() => {
                    if (!isLoading) this.addParkingCart(true);
                  }} />
              </CartSection>
              <ShuttleSelectTrip
                changeTripSelect={changeTripSelect}
                isSelectedTrip={isSelectedTrip}
                translations={translations}
                nontIncludeShow={nontIncludeShow}
                quantityPersons={quantityPersons}
                showModalFeet={showModalFeet}
                showModalScales={showModalScales}
                detailSelected={detailSelected}
                showScales={showScales}
                handleDetailSelected={handleDetailSelected}
                openShuttleForm={openShuttleForm}
                getSeats={getSeats}
                openShuttleSelectTrip={openShuttleSelectTrip}
                shuttleTravelType={shuttleTravelType}
                shuttleDestination={shuttleDestination}
                shuttleOrigin={shuttleOrigin}
                shuttleStartDate={shuttleStartDate}
                shuttleEndDate={shuttleEndDate}
                shuttlePassengers={shuttlePassengers}
                shuttleEndDateHandler={this.shuttleEndDateHandler}
                shuttlStartDateHandler={this.shuttleStartDateHandler}
                shuttleTravelTypeHandler={shuttleTravelTypeHandler}
                shuttlePassengersHandler={shuttlePassengersHandler}
                shuttleDestinationHandler={shuttleDestinationHandler}
                shuttleOrigins={shuttleOrigins}
                shuttleOriginHandler={shuttleOriginHandler}
                shuttleDestinations={shuttleDestinations}
                saveShuttleTripData={saveShuttleTripData}
                changeTravelType={changeTravelType}
                locale={locale}
                ticketType={{
                  ...ticketType,
                  options: ticketOptions
                }}
                getShuttleRoutes={getShuttleRoutes}
                isCallingShuttleApi={isCallingShuttleApi}
                callShuttleApi={callShuttleApi}
                openHome={openHome}
                cart={cart}
                selectRoundTrip={selectRoundTrip}
                page={page}
              />
            </>
          }
          {page === 'shuttleSelectRoundTrip' &&
            <>
              <CartSection>
                <Stepper translations={translations} activeIndex={1} locale={locale} selectorItem={selectorItem} currentStep={currentStep} isLoading={isLoading}
                  action={() => {
                    if (!isLoading) this.addParkingCart(true);
                  }} />
              </CartSection>
              <ShuttleSelectTrip
                changeTripSelect={changeTripSelect}
                isSelectedTrip={isSelectedTrip}
                translations={translations}
                nontIncludeShow={nontIncludeShow}
                quantityPersons={quantityPersons}
                showModalFeet={showModalFeet}
                showModalScales={showModalScales}
                detailSelected={detailSelected}
                showScales={showScales}
                handleDetailSelected={handleDetailSelected}
                openShuttleForm={openShuttleForm}
                getSeats={getSeats}
                openShuttleSelectTrip={openShuttleSelectTrip}
                shuttleTravelType={shuttleTravelType}
                shuttleDestination={shuttleDestination}
                shuttleOrigin={shuttleOrigin}
                shuttleStartDate={shuttleStartDate}
                shuttleEndDate={shuttleEndDate}
                shuttlePassengers={shuttlePassengers}
                shuttleEndDateHandler={this.shuttleEndDateHandler}
                shuttlStartDateHandler={this.shuttleStartDateHandler}
                shuttleTravelTypeHandler={shuttleTravelTypeHandler}
                shuttlePassengersHandler={shuttlePassengersHandler}
                shuttleDestinationHandler={shuttleDestinationHandler}
                shuttleOrigins={shuttleOrigins}
                shuttleOriginHandler={shuttleOriginHandler}
                shuttleDestinations={shuttleDestinations}
                saveShuttleTripData={saveTripShuttleDataRound}
                changeTravelType={changeTravelType}
                locale={locale}
                ticketType={{
                  ...ticketType,
                  options: ticketOptions
                }}
                getShuttleRoutes={getShuttleRoutes}
                isCallingShuttleApi={isCallingShuttleApi}
                callShuttleApi={callShuttleApi}
                openHome={openHome}
                page={page}
              />
            </>
          }
          {page === 'shuttleForm' &&
            <>
              <CartSection>
                <Stepper translations={translations} activeIndex={1} locale={locale} selectorItem={selectorItem} currentStep={currentStep} isLoading={isLoading}
                  action={() => {
                    if (!isLoading) this.addParkingCart(true);
                  }} />
              </CartSection>
              <ShuttleForm
                minDate={minDate}
                maxDate={maxDate}
                increment={incrementShuttle}
                decrement={decrementShuttle}
                initializeCounter={initializeCounter}
                saveParkingInfo={this.saveShuttleInfo}
                counterParking={counterShuttle}
                translations={translations}
                ticketType={ticketType}
                openAddOns={openAddOns}
                continueCart={continueCart}
                changeData={changeData}
                onVehicleUpdate={onVehicleUpdate}
                vehiclesInfo={vehicles}
                locale={locale}
                selectorItem={selectorItem}
                isLoading={isLoading}
                currentStep={currentStep}
                lot={lot}
                cart={cart}
                startDate={startDate}
                endDate={endDate}
                startTime={startTime}
                endTime={endTime}
                startTimeHandler={startTimeHandler}
                endTimeHandler={endTimeHanlder}
                openParking={openParking}
                endDateHandler={endDateHandler}
                startDateHandler={startDateHandler}
                onBundleSelect={selectBundle}
                selectedBundle={selectedBundle}
                lotHandler={this.lotHandler}
                showCalendar={showCalendar}
                showRangeCalendar={showRangeCalendar}
                showStartDateCalendar={showStartDateCalendar}
                showEndDateCalendar={showEndDateCalendar}
                selectionRange={[selectionRange]}
                handleSelect={handleSelect}
                handleSelectStartDate={handleSelectStartDate}
                enableSendToCart={enableSendToCart}
                callParkingApi={callParkingApi}
                getParkingPrice={getParkingPrice}
                isCallingParkingApi={isCallingParkingApi}
                openShuttleSelectSeats={openShuttleSelectSeats}
                isCallingShuttleApi={isCallingShuttleApi}
              />
            </>
          }
          {page === 'shuttleSelectSeats' &&
            <>
              <CartSection>
                <Stepper translations={translations} activeIndex={1} locale={locale} selectorItem={selectorItem} currentStep={currentStep} isLoading={isLoading}
                  action={() => { }} />
              </CartSection>
              <ShuttleSelectSeats
                onSelectedSeat={onSelectedSeat}
                selectedSeat={selectedSeat}
                openModalSelectedSeats={openModalSelectedSeats}
                translations={translations}
                goToPersonalInfo={page === 'shuttleSelectSeats' ? openShuttleForm : goToPersonalInfo}
                shuttlePassengers={shuttlePassengers}
                selectedCounter={selectedCounter}
                page={page}
              />
            </>
          }
          {page === 'shuttleSelectSeatsReturn' &&
            <>
              <CartSection>
                <Stepper translations={translations} activeIndex={1} locale={locale} selectorItem={selectorItem} currentStep={currentStep} isLoading={isLoading}
                  action={() => { }} />
              </CartSection>
              <ShuttleSelectSeats
                page={page}
                onSelectedSeat={onSelectedSeatRound}
                selectedSeat={selectedSeatRound}
                openModalSelectedSeats={openModalSelectedSeats}
                translations={translations}
                goToPersonalInfo={page === 'shuttleSelectSeatsReturn' ? goToPersonalInfo : openShuttleForm}
                shuttlePassengers={shuttlePassengers}
                selectedCounter={selectedCounter}
              />
            </>
          }
          {page === 'lot' && (
            <>
              <CartSection>
                <Stepper translations={translations} activeIndex={1} locale={locale} selectorItem={selectorItem} currentStep={currentStep} isLoading={isLoading}
                  editTicket={
                    cart
                      ? () => {
                        removeQuickData();

                        const product = cart[cart.length - 1];
                        if (product.type === "ticket") {
                          this.editElementFromCartUsingStepper(cart.length - 1);
                        } else {
                          openConfigTicket();
                        }
                      }
                      : openConfigTicket
                  }
                  editParking={
                    cart
                      ? () => {
                        removeQuickData();
                        const product = cart[cart.length - 1];
                        if (product.type === "parking") {
                          this.editElementFromCartUsingStepper(cart.length - 1);
                        } else {
                          openPersonalInfo();
                        }
                      }
                      : openPersonalInfo
                  }
                  action={() => {
                    if (!isLoading) this.addParkingCart(true);
                  }} />
              </CartSection>
              <ParkingForm
                minDate={minDate}
                maxDate={maxDate}
                increment={increment}
                decrement={decrement}
                initializeCounter={initializeCounter}
                saveParkingInfo={this.saveParkingInfo}
                counterParking={counterParking}
                translations={translations}
                ticketType={ticketType}
                openAddOns={openAddOns}
                continueCart={continueCart}
                changeData={changeData}
                onVehicleUpdate={onVehicleUpdate}
                vehiclesInfo={vehicles}
                locale={locale}
                selectorItem={selectorItem}
                isLoading={isLoading}
                currentStep={currentStep}
                lot={lot}
                cart={cart}
                startDate={startDate}
                endDate={endDate}
                startTime={startTime}
                endTime={endTime}
                startTimeHandler={startTimeHandler}
                endTimeHandler={endTimeHanlder}
                openParking={openParking}
                endDateHandler={endDateHandler}
                startDateHandler={startDateHandler}
                onBundleSelect={selectBundle}
                selectedBundle={selectedBundle}
                lotHandler={this.lotHandler}
                showCalendar={showCalendar}
                showRangeCalendar={showRangeCalendar}
                showStartDateCalendar={showStartDateCalendar}
                showEndDateCalendar={showEndDateCalendar}
                selectionRange={[selectionRange]}
                handleSelect={handleSelect}
                handleSelectStartDate={handleSelectStartDate}
                enableSendToCart={enableSendToCart}
                callParkingApi={callParkingApi}
                getParkingPrice={getParkingPrice}
                getLots={getLots}
                isCallingParkingApi={isCallingParkingApi}
                isCallingShuttleApi={isCallingShuttleApi}
              />
            </>
          )}
          {page === 'wheels' && (
            <>
              <CartSection>
                <Stepper translations={translations} activeIndex={1} locale={locale} selectorItem={selectorItem} currentStep={currentStep} isLoading={isLoading}
                  editTicket={
                    cart
                      ? () => {
                        removeQuickData();

                        const product = cart[cart.length - 1];
                        if (product.type === "ticket") {
                          this.editElementFromCartUsingStepper(cart.length - 1);
                        } else {
                          openConfigTicket();
                        }
                      }
                      : openConfigTicket
                  }
                  editParking={
                    cart
                      ? () => {
                        removeQuickData();
                        const product = cart[cart.length - 1];
                        if (product.type === "parking") {
                          this.editElementFromCartUsingStepper(cart.length - 1);
                        } else {
                          openPersonalInfo();
                        }
                      }
                      : openPersonalInfo
                  }
                  action={() => {
                    if (!isLoading) this.addParkingCart(true);
                  }} />
              </CartSection>
              <WheelsForm
                minDate={minDate}
                maxDate={maxDate}
                increment={increment}
                decrement={decrement}
                initializeCounter={initializeCounter}
                saveParkingInfo={this.saveWheelsInfo}
                counterParking={counterParking}
                translations={translations}
                ticketType={ticketType}
                openAddOns={openAddOns}
                continueCart={continueCart}
                changeData={changeData}
                onVehicleUpdate={onVehicleUpdate}
                vehiclesInfo={vehicles}
                locale={locale}
                selectorItem={selectorItem}
                isLoading={isLoading}
                currentStep={currentStep}
                lot={lot}
                cart={cart}
                startDate={startDate}
                endDate={endDate}
                startTime={startTime}
                endTime={endTime}
                startTimeHandler={startTimeHandler}
                endTimeHandler={endTimeHanlder}
                openParking={openParking}
                endDateHandler={endDateHandler}
                startDateHandler={startDateHandler}
                onBundleSelect={selectBundle}
                selectedBundle={selectedBundle}
                lotHandler={this.lotHandler}
                showCalendar={showCalendar}
                showRangeCalendar={showRangeCalendar}
                showStartDateCalendar={showStartDateCalendar}
                showEndDateCalendar={showEndDateCalendar}
                selectionRange={[selectionRange]}
                handleSelect={handleSelect}
                handleSelectStartDate={handleSelectStartDate}
                enableSendToCart={enableSendToCart}
                callParkingApi={callParkingApi}
                getParkingPrice={getParkingPrice}
                getLots={getLots}
                isCallingParkingApi={isCallingParkingApi}
                isCallingShuttleApi={isCallingShuttleApi}
              />
            </>
          )}
          {page === 'cart' &&
            <>
              <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                {isProcessing && <CartSection>
                  <div
                    style={{
                      padding: '5%',
                      width: '100%',
                      margin: 'auto',
                      justifyContent: 'center'
                    }}
                  >
                    <img
                      alt=""
                      style={{ margin: 'auto', display: 'block ' }}
                      width="150px"
                      height="auto"
                      src={shopping_processing}
                    />
                    <Label color="#3F2A55" size="40px" style={{ textAlign: 'center' }}>
                      {translations.requestProcessing}
                    </Label>
                    <LabelLight
                      color="#726C79"
                      size="18px"
                      style={{ textAlign: 'center', padding: '20px 60px 20px' }}
                    >
                      {translations.requestDoNotClose}
                    </LabelLight>
                  </div>
                </CartSection>
                }
                {!isProcessing && <CartSection>
                  <Stepper translations={translations} activeIndex={4} locale={locale} selectorItem={selectorItem} currentStep={currentStep} isLoading={isLoading}
                    editTicket={
                      cartTotal
                        ? () => {
                          removeQuickData();
                          const product = cart[cart.length - 1];
                          if (product.type === "ticket") {
                            this.editElementFromCartUsingStepper(cart.length - 1);
                          } else {
                            openConfigTicket();
                          }
                        }
                        : openConfigTicket
                    }
                    editParking={
                      cartTotal
                        ? () => {
                          removeQuickData();
                          const product = cart[cart.length - 1];
                          if (product.type === "parking") {
                            this.editElementFromCartUsingStepper(cart.length - 1);
                          } else {
                            openPersonalInfo();
                          }
                        }
                        : openPersonalInfo
                    }
                  />
                  <GrayContainer onClick={() => { window.location.href = `/${locale}/addOns` }} style={{ fontSize: '1em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', cursor: 'pointer' }}>
                    <span style={{ color: "#726C79", fontWeight: 'normal' }}>{cart && cart.length > 0 ? translations.missingSomething : translations.emptyCart} </span>
                    <span style={{ backgroundColor: "#FF3094", color: "white", padding: "0.25em 1em", borderRadius: '0.25rem', fontWeight: 'bold' }}>{cart && cart.length > 0 ? translations.addItems : translations.emptyAddItems}</span>
                  </GrayContainer>
                  {cart && cart.length > 0 &&
                    <>
                      <Label color="#292033" size="20px" style={{ marginTop: '1em', width: '100%' }}>
                        <img alt="" width="30px" height="20px"
                          style={{ marginInline: "auto", cursor: "pointer", paddingRight: "10px" }}
                          src={purple_arrow}
                          onClick={openAddOns}
                        />
                        {translations.purchaseSummary}
                      </Label>
                      <CartTicketsListWrapper>
                        {cart && cart.map((product, index) => (
                          <CartItem
                            product={product}
                            index={index}
                            locale={locale}
                            strings={translations}
                            editFn={i => this.editElementFromCart(i)}
                            deleteFn={i => this.removeElementFromCart(i)}
                          />
                        ))
                        }
                        {donationDisclaimer &&
                          <div className="column" style={{ display: 'flex', marginTop: '2rem', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                            <span style={{ fontSize: '1.125em', textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: donationDisclaimer[`text_${locale}`] }} ></span>
                            <DonationButtonStrip onDonationChange={this.handleDonationChange} amounts={[1, 3, 5, 10, 50, 100]} defaultSelectedAmount={acceptDonate.amount} />
                          </div>
                        }
                        <CartTotalWrapper style={{ flexDirection: 'column', alignItems: 'flex-end' }}>
                          {totalDiscount > 0.0 && <CartTotal>{`${locale === 'es' ? 'Descuento' : 'Discount'}: $${totalDiscount.toFixed(2)} USD`}</CartTotal>}
                          {acceptDonate.checked && <CartTotal>{`${locale === 'es' ? 'Donación' : 'Donation'}: $${acceptDonate.amount}.00 USD`}</CartTotal>}
                          <CartTotal>{`Total: $${cartTotal.toFixed(2)} USD`}</CartTotal>
                          <CartTotal>{translations.convertion}</CartTotal>
                        </CartTotalWrapper>
                      </CartTicketsListWrapper>
                      {this.getPaymentInformation()}
                      <FreedomPay
                        amount={cartTotal.toFixed(2)}
                        context={this.state.currentCard ? { tokenInfo: { token: this.state.token, expMonth: this.state.expirationDate.value.split('/')[0], expYear: this.state.expirationDate.value.split('/')[1] } } : {}}
                        doShopping={this.doShopping}
                        handleChange={this.handleChange}
                        locale={locale}
                      />
                      {/* {this.getCheckBoxes(false)} */}
                    </>}
                </CartSection>}
              </div>
            </>}
          {page === 'error' &&
            <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
              <CartSection>
                <div
                  style={{
                    padding: '5%',
                    width: '100%',
                    maxWidth: '780px',
                    margin: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <img
                    alt=""
                    style={{ margin: 'auto', display: 'block ' }}
                    width="150px"
                    height="auto"
                    src={shopping_error}
                  />
                  <Label color="#3F2A55" size="40px" style={{ textAlign: 'center', paddingLeft: 0, marginTop: '0.5em' }}>
                    {translations.shoppingError}
                  </Label>
                  {shortId && (
                    <Label color="#5e5964" size="20px" style={{ textAlign: 'center' }}>
                      {translations.salesId}: {shortId}
                    </Label>
                  )}
                  <LabelLight
                    color="#726C79"
                    size="16px"
                    style={{ textAlign: 'center', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '0.5em' }}
                  >
                    <span>
                      {translations.errorTickets}
                    </span>
                  </LabelLight>
                </div>
                <a href="/" style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: PURPLE_DARK, fontWeight: 'bold', fontSize: '1.5rem' }}>
                  <Label color="#292033" size="20px" style={{ textAlign: 'center' }}>
                    {translations.returnHome}
                  </Label>
                </a>

              </CartSection>
            </div>
          }
          {page === 'thankyou' && (
            <div style={{
              display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center'
            }}
            >
              <CartSection>
                <div
                  style={{
                    padding: '5%', width: '100%', margin: 'auto', justifyContent: 'center'
                  }}
                >
                  <img
                    alt=""
                    style={{ margin: 'auto', display: 'block ' }}
                    width="150px"
                    height="auto"
                    src={tickets_success}
                  />
                  <Label color="#3F2A55" size="40px" style={{ textAlign: 'center' }}>
                    {translations.thankYou}
                  </Label>
                  {shortId && (
                    <Label color="#5e5964" size="20px" style={{ textAlign: 'center' }}>
                      {translations.salesId}: {shortId}
                    </Label>
                  )}
                  <LabelLight
                    color="#726C79"
                    size="18px"
                    style={{ textAlign: 'center', padding: '20px 60px 20px' }}
                  >
                    {translations.successMessage}
                  </LabelLight>
                  {isInsuranceFeatureEnabled() && 
                   !!boughtTicket.insurance?.[InsuranceProvider.BATTLEFACE]?.length && (
                      <div
                        style={{
                          justifyContent: 'space-evenly',
                          width: '100%',
                          padding: '5px 10px 5px, ',
                          marginBottom: '1rem',
                          textAlign: 'center',
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <div>
                          <Label size="16px" color="#726C79" style={{  fontWeight: 'bold' }}>
                            {translations.selectedInsurance}
                          </Label>
                        </div>
                      </div>
                  )}
                  <div
                    style={{
                      justifyContent: 'space-evenly',
                      width: '100%',
                      padding: '5px 10px 5px, ',
                      marginBottom: '3rem',
                      textAlign: 'center',
                      display: 'flex'
                    }}
                  >
                    {boughtTicket.link && (
                      <div>
                        <a href={boughtTicket.link} rel="noopener noreferrer" target="_blank">
                          <img
                            alt=""
                            width="20px"
                            height="auto"
                            style={{ margin: '0px 5px 0px 20px' }}
                            src={download}
                          />
                          <labelInput style={{ color: '#FF3094', fontWeight: 'bold' }}>
                            {translations.download}
                          </labelInput>
                        </a>
                      </div>
                    )}
                    {boughtTicket.cbxLink && (
                      <div>
                        <a href={boughtTicket.cbxLink} rel="noopener noreferrer" target="_blank">
                          <img
                            alt=""
                            width="20px"
                            height="auto"
                            style={{ margin: '0px 5px 0px 20px' }}
                            src={download}
                          />
                          <labelInput style={{ color: '#FF3094', fontWeight: 'bold' }}>
                            {`${translations.download} (CBX)`}
                          </labelInput>
                        </a>
                      </div>
                    )}
                    {boughtTicket.parkingLink && (
                      <div>
                        <a href={boughtTicket.parkingLink} rel="noopener noreferrer" target="_blank">
                          <img
                            alt=""
                            width="20px"
                            height="auto"
                            style={{ margin: '0px 5px 0px 20px' }}
                            src={download}
                          />
                          <labelInput style={{ color: '#FF3094', fontWeight: 'bold' }}>
                            {translations.downloadParking}
                          </labelInput>
                        </a>
                      </div>
                    )}
                    {boughtTicket.shuttleLink && (
                      <div>
                        <a href={boughtTicket.shuttleLink} rel="noopener noreferrer" target="_blank">
                          <img
                            alt=""
                            width="20px"
                            height="auto"
                            style={{ margin: '0px 5px 0px 20px' }}
                            src={download}
                          />
                          <labelInput style={{ color: '#FF3094', fontWeight: 'bold' }}>
                            {translations.downloadShuttle}
                          </labelInput>
                        </a>
                      </div>
                    )}
                    {boughtTicket.wheelsLink && (
                      <div>
                        <a href={boughtTicket.wheelsLink} rel="noopener noreferrer" target="_blank">
                          <img
                            alt=""
                            width="20px"
                            height="auto"
                            style={{ margin: '0px 5px 0px 20px' }}
                            src={download}
                          />
                          <labelInput style={{ color: '#FF3094', fontWeight: 'bold' }}>
                            {translations.downloadWheels}
                          </labelInput>
                        </a>
                      </div>
                    )}
                    {boughtTicket.blackCarsLink && (
                      <div>
                        <a href={boughtTicket.blackCarsLink} rel="noopener noreferrer" target="_blank">
                          <img
                            alt=""
                            width="20px"
                            height="auto"
                            style={{ margin: '0px 5px 0px 20px' }}
                            src={download}
                          />
                          <labelInput style={{ color: '#FF3094', fontWeight: 'bold' }}>
                            {locale === 'es' ? 'Descargar Black Cars' : 'Download Black Cars'}
                          </labelInput>
                        </a>
                      </div>
                    )}

                  </div>
                  {process.env.GATSBY_FEATURE_INAMI_ENABLED &&
                    <div
                      style={{
                        justifyContent: 'space-evenly',
                        width: '100%',
                        padding: '5px 10px 5px, ',
                        marginBottom: '3rem',
                        textAlign: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      {boughtTicket?.inamiError && (
                        <div style={{ textAlign: 'center', maxWidth: '780px', margin: 'auto' }}>
                          <p style={{ marginBottom: 0 }}>{locale === 'es' ? 'Importante: Lamentablemente no pudimos generar su Forma Migratoria Múltiple (FMM) por este medio. Por favor, tramítela directamente en el sitio web del INAMI dando click aquí o en la terminal de CBX antes de su cruce a México.' :
                           'Important: Unfortunately, we were unable to generate your Multiple Migratory Form (FMM) through this platform. Please process it directly on the INAMI website by clicking here or at the CBX terminal before your crossing into Mexico.'}</p>
                        </div>
                      )}
                      {boughtTicket?.inami?.length > 0 && (
                        <div>

                          {boughtTicket.inami.map((inamires, index) => {
                            const isFirstFMMRequest = index === 0;
                            const FMMNotRequiredMessage = locale === 'es' ? 
                            'Su FMM no requiere pago por sus derechos migratorios (DNR) durante su estancia autorizada en México. Sin embargo, si su paso por México es por tránsito o escala para tomar un viaje internacional, sí requerirá el pago del DNR.' : 
                            'Your FMM does not require payment for your migratory rights (DNR) is not required during your authorized stay in Mexico. However, if your passage through Mexico is due to transit or a layover for international travel, you will be required to pay for the DNR.';

                            return (
                              <div key={inamires.folioCbx} style={{ textAlign: 'left', fontSize: '1rem', marginTop: '1.5em', borderTop: isFirstFMMRequest ? undefined : '0.5px solid #6C6D70', paddingTop: isFirstFMMRequest ? undefined : '1em' }}>
                                <p style={{ color: 'rgba(51, 51, 52, 1)', fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '0.75em' }}>{locale == 'es' ? 'Solicitud FMM' : 'FMM Request'}</p>
                                <p style={{ marginBottom: '0.5em' }}>Folio: {inamires.folioCbx}</p>
                                {inamires.isPaymentRequired && <>
                                  <p style={{ marginBottom: '0.5em' }}>{locale == 'es' ? 'Haga clic en el enlace a continuación para ver y pagar su FMM:' : 'Please click the link below to view and pay for your FMM:'}</p>
                                  <a href={inamires.urlPayment} rel="noopener noreferrer" target="_blank" style={{ color: '#FF3094', fontWeight: 'bold', marginBottom: 0 }}>{locale == 'es' ? 'Haga click aquí para procesar su pago de FMM' : 'Click here to process your FMM payment'}</a>
                                </>}
                                {!inamires.isPaymentRequired && <p style={{ marginBottom: 0 }}>{FMMNotRequiredMessage}</p>}
                              </div>
                            )
                          })}
                        </div>
                      )}
                    </div>
                  }
                  {process.env.GATSBY_FEATURE_PANAMERICAN_ENABLED && !!boughtTicket.insurance?.[InsuranceProvider.PANAMERICAN]?.length && (
                    <div
                      style={{
                        justifyContent: 'space-evenly',
                        width: '100%',
                        padding: '5px 10px 5px, ',
                        marginBottom: '3rem',
                        textAlign: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      {/* Header */}
                      <labelInput style={{ color: '#FF3094', fontWeight: 'bold' }}>
                        {locale == 'es' ? 'Protección Médica de Viaje' : 'Travel Medical Protection'}
                      </labelInput>
                      {/* Insurance List */}
                      {boughtTicket.insurance[InsuranceProvider.PANAMERICAN].map((voucher, index) => (
                          <div style={{ padding: '5px 0'}}>
                            <a href={voucher.url} rel="noopener noreferrer" target="_blank">
                              <img
                                alt=""
                                width="20px"
                                height="auto"
                                style={{ margin: '0px 5px 0px 20px' }}
                                src={download}
                              />
                              <labelInput style={{ color: '#FF3094', fontWeight: 'bold' }}>
                                {locale == 'es' ? 'Certificado' : 'Certificate'} {index + 1}
                              </labelInput>
                            </a>
                        </div>
                      ))}
                    </div>)}
                  <a
                    href="/"
                    style={{
                      width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: PURPLE_DARK, fontWeight: 'bold', fontSize: '1.5rem'
                    }}
                  >
                    <Label color="#292033" size="20px" style={{ textAlign: 'center' }}>
                      {translations.returnHome}
                    </Label>
                  </a>
                </div>
              </CartSection>
            </div>)}
        </Wrapper>
      </Fragment>
    );
  }
}

export default TicketsWhite;
